(
  (Shopify) => {
    const SHOPIFY_THEME_NAME = 'ShopifyArtistTheme'
    const ROUTES = window.routes
    const locale = Shopify.locale || 'en';
    const DESIGN_MODE = Boolean(Shopify.designMode)

    const TRANSLATIONS = window.translations ?? {locale: 'en', currency: 'USD'}
    const CUSTOM_TRANSLATIONS = window.custom_translations ?? {}

    TRANSLATIONS.decimals = new Intl.NumberFormat(TRANSLATIONS.locale, {
      style: 'currency',
      currency: TRANSLATIONS.currency
    }).resolvedOptions().maximumFractionDigits;

    const PERFORMANCE_START = performance.now();
    const PERFORMANCE_TIME = (label) => {
      const end = performance.now();
      const duration = end - PERFORMANCE_START;
      console.log(label, duration.toFixed(4));
    }

    const pageContent = document.querySelector('#page-content');

    const
      SHOPIFY_SECTION = '.shopify-section',
      SHOPIFY_BLOCK = '.shopify-block',
      SHOPIFY_SEND_GIFT_CARD_TO_RECIPIENT = '__shopify_send_gift_card_to_recipient',
      SHOPIFY_OFFSET = '__shopify_offset'

    const
      E = '',
      TRUE = 'true',
      FALSE = 'false',
      PAGE = 'page',
      ADD = 'add',
      REMOVE = 'remove',
      APPLY = 'apply',
      RESET = 'reset',
      PREV = 'prev',
      NEXT = 'next',
      IMAGE = 'image',
      AUTOMATIC = 'automatic',
      SHOPIFY_FIRST = 'shopify_first',
      VARIANT_ALWAYS = 'variant_always',
      SWATCHES = 'swatches',
      PILLS = 'pills',
      SELECT = 'select',
      HEADER = 'header',
      DEFAULT = 'default',
      SELECTED = 'selected',
      ELLIPSIS = 'ellipsis',
      AVAILABLE = 'available',
      UNAVAILABLE = 'unavailable',
      EMPTY = 'empty',
      LINES = 'lines',
      ACTIVE = 'active',
      CURRENT = 'current',
      SUBMENU = 'submenu',
      DISABLED = 'disabled',
      DEFAULT_MARK = 'default-mark',
      SELECTED_MARK = 'selected-mark',
      DISABLED_MARK = 'disabled-mark',
      OPACITY = 'opacity',
      INERT = 'inert',
      TRANSFORM = 'transform',
      VERTICAL = 'vertical',
      HORIZONTAL = 'horizontal',
      SUBMIT = 'submit',
      CLICK = 'click',
      CHANGE = 'change',
      POINTER_DOWN = 'pointerdown',
      POINTER_MOVE = 'pointermove',
      POINTER_UP = 'pointerup',
      POINTER_CANCEL = 'pointercancel',
      GOT_POINTER_CAPTURE = 'gotpointercapture',
      LOST_POINTER_CAPTURE = 'lostpointercapture',
      KEY_DOWN = 'keydown',
      SCROLL = 'scroll',
      RESIZE = 'resize',
      CONTENT = 'content',
      HIDDEN = '!hidden',
      INVISIBLE = 'invisible',
      POINTER_EVENT_AUTO = 'pointer-events-auto',
      TRANSITION_ALL = 'transition-all',
      DURATION = 'duration',
      DIMENSIONS = 'dimensions',
      SCOPE = ':scope',
      SCRIPT = 'script[type="application/json"]',
      SCRIPT_JSON = `${SCOPE} > ${SCRIPT}`;

    const
      A = 'a',
      P = 'p',
      H1 = 'h1',
      H2 = 'h2',
      H3 = 'h3',
      H4 = 'h4',
      H5 = 'h5',
      H6 = 'h6',
      UL = 'ul',
      LI = 'li',
      TIME = 'time',
      DIALOG = 'dialog',
      FORM = 'form',
      INPUT = 'input',
      TEXTAREA = 'textarea',
      TEMPLATE = 'template',
      ARTICLE = 'article',
      NAV = 'nav',
      DIV = 'div',
      DL = 'dl',
      DT = 'dt',
      DD = 'dd',
      BTN = 'button',
      SPN = 'span',
      SPN_CONTENT = `${SPN}.${CONTENT}`,
      SVG = 'svg',
      IMG = 'img',
      TRAIT = ':scope > .shopify-block > template.trait';

    const tagClass = {}
    
    const
      THEME_SECTION = 'theme-section',
      EVENT_BUTTON = 'event-button',
      CART_BUTTON = 'cart-button',
      MENU_ROOT = 'menu-root',

      PRODUCT_ROOT = 'product-root',
      PRODUCT_CARD = 'product-card',
      PRODUCT_LINK = 'product-link',
      PRODUCT_TITLE = 'product-title',
      PRODUCT_TEXTAREA = 'product-textarea',
      PRODUCT_RICHTEXT = 'product-richtext',
      PRODUCT_IMAGE = 'product-image',
      PRODUCT_MEDIA = 'product-media',
      PRODUCT_PRICE = 'product-price',
      PRODUCT_VARIANTS = 'product-variants',
      VARIANT_HEADER = 'variant-header',
      VARIANT_CONTENT = 'variant-content',
      VARIANT_TITLE = 'variant-title',
      VARIANT_SELECT = 'variant-select',
      VARIANT_PILLS = 'variant-pills',
      VARIANT_SWATCHES = 'variant-swatches',
      VARIANT_SKU = 'variant-sku',
      VARIANT_INVENTORY = 'variant-inventory',
      VARIANT_PRICE = 'variant-price',
      VARIANT_UNIT_PRICE = 'variant-unit-price',
      VARIANT_PICKUPS = 'variant-pickups',
      PRODUCT_IMAGES = 'product-images',
      PRODUCT_VIDEO = 'product-video',
      PRODUCT_YOUTUBE = 'product-youtube',
      PRODUCT_VIMEO = 'product-vimeo',
      PRODUCT_MODEL = 'product-model',
      PRODUCT_THUMB = 'product-thumb',
      PRODUCT_THUMBS = 'product-thumbs',
      PRODUCT_QUANTITY = 'product-quantity',
      PRODUCT_ERROR = 'product-error',
      PRODUCT_BUTTON_ADD_TO_CART = 'product-button-add-to-cart',
      PRODUCT_BUTTON_SHOPIFY = 'product-button-shopify',
      PRODUCT_RECOMMENDATIONS = 'product-recommendations',
      PRODUCT_GIFT_CARD = 'product-gift-card',

      TABS_CONTAINER = 'tabs-container',
      TAB_CONTENT = 'tab-content',
      ACCORDION_ITEM = 'accordion-item',

      COLLECTION_ROOT = 'collection-root',
      COLLECTION_CARD = 'collection-card',
      COLLECTION_VENDORS = 'collection-vendors',
      COLLECTION_TAGS = 'collection-tags',
      COLLECTION_TYPES = 'collection-types',
      COLLECTION_LINK = 'collection-link',
      COLLECTION_IMAGE = 'collection-image',
      COLLECTION_SORT = 'collection-sort',
      COLLECTION_TITLE = 'collection-title',
      COLLECTION_TEXTAREA = 'collection-textarea',
      COLLECTION_RICHTEXT = 'collection-richtext',
      COLLECTION_PRODUCT_COUNT = 'collection-product-count',

      SORT_SELECT = 'sort-select',

      FILTER_GROUP = 'filter-group',
      FILTER_BOOLEAN = 'filter-boolean',
      FILTER_LIST = 'filter-list',
      FILTER_SWATCH = 'filter-swatch',
      FILTER_PRICE = 'filter-price',

      APPLY_BUTTON = 'apply-button',
      RESET_BUTTON = 'reset-button',

      PAGE_ROOT = 'page-root',
      PAGE_CARD = 'page-card',
      PAGE_LINK = 'page-link',
      PAGE_TITLE = 'page-title',
      PAGE_IMAGE = 'page-image',
      PAGE_TEXTAREA = 'page-textarea',
      PAGE_RICHTEXT = 'page-richtext',

      ARTICLE_ROOT = 'article-root',
      ARTICLE_CARD = 'article-card',
      ARTICLE_BLOG = 'article-blog',
      ARTICLE_TITLE = 'article-title',
      ARTICLE_LINK = 'article-link',
      ARTICLE_IMAGE = 'article-image',
      ARTICLE_TIME = 'article-time',
      ARTICLE_EXCERPT = 'article-excerpt',
      ARTICLE_AUTHOR = 'article-author',
      ARTICLE_DATE = 'article-date',
      ARTICLE_TAGS = 'article-tags',
      ARTICLE_TEXTAREA = 'article-textarea',
      ARTICLE_RICHTEXT = 'article-richtext',

      COMMENT_FORM = 'comment-form',

      BLOG_ROOT = 'blog-root',
      BLOG_TITLE = 'blog-title',
      BLOG_IMAGE = 'blog-image',
      BLOG_TEXTAREA = 'blog-textarea',
      BLOG_RICHTEXT = 'blog-richtext',
      BLOG_FILTER = 'blog-filter',

      CART_ROOT = 'cart-root',
      CART_SUMMARY = 'cart-summary',
      CART_DISCOUNT = 'cart-discount',
      CART_NOTE = 'cart-note',
      CART_CHECKOUT = 'cart-checkout',
      CART_LINES = 'cart-lines',

      CART_LINE_ROOT = 'cart-line-root',
      CART_LINE = 'cart-line',
      CART_LINE_CHILD_INDICATOR = 'cart-line-child-indicator',
      CART_LINE_TITLE = 'cart-line-title',
      CART_LINE_IMAGE = 'cart-line-image',
      CART_LINE_LINK = 'cart-line-link',
      CART_LINE_QUANTITY = 'cart-line-quantity',
      CART_LINE_PRICE = 'cart-line-price',
      CART_LINE_DISCOUNT = 'cart-line-discount',
      CART_LINE_SELLING_PLAN = 'cart-line-selling-plan',
      CART_LINE_DETAIL = 'cart-line-detail',

      SWITCH_CONTROL = 'switch-control',
      CHECKBOX_CONTROL = 'checkbox-control',
      CHECKBOX_FIELD = 'checkbox-field',
      CHECKBOX_SWATCH = 'checkbox-swatch',
      RANGE_INPUT = 'range-input',
      RANGE_SLIDER = 'range-slider',
      CONTROL_ARROW = 'control-arrow',

      CAROUSEL_LIST = 'carousel-list',
      CAROUSEL_ITEM = 'carousel-item',
      CAROUSEL_BUTTONS = 'carousel-buttons',

      VIDEO_SECTION = 'video-section',
      VIDEO_BUTTON = 'video-button',

      BACK_TO_TOP = 'back-to-top',
      SHARE_BUTTON = 'share-button',

      SEARCH_FORM = 'search-form',
      SHARE_FORM = 'share-form',

      COUNTRY_SELECT = 'country-select',
      LANGUAGE_SELECT = 'language-select',

      PARALLAX_IMG = 'parallax-img',

      TEMPLATE_SLOT = 'template-slot',

      PAGINATION_ROOT = 'pagination-root',
      PAGINATION_NUMBERS = 'pagination-numbers',
      PAGINATION_SELECT = 'pagination-select',
      PAGINATION_INFO = 'pagination-info',

      COUNTDOWN_TIMER = 'countdown-timer',
      COUNTDOWN_VIEWER = 'countdown-viewer';

    window.goBackHandler = (event, pattern) => {
      if (document.referrer && history.length > 1) {
        const url = new URL(document.referrer)
        const path = url.pathname
        if (path.startsWith(pattern)) {
          event.preventDefault()
          history.back()
        }
      }
    }

    const generateID = () => crypto.randomUUID()

    const changeInputID = (root) => {
      const
        input = root.querySelector(INPUT),
        id = input.id;

      if (id) {
        let parent = root
        const
          new_id = generateID(),
          query = `${SCOPE} > label[for="${id}"]`;

        for (let i = 0; i < 5; i++) {
          const label = parent.querySelector(query)
          if (label) {
            label.setAttribute('for', new_id)
            input.id = new_id
            return new_id
          }
          parent = parent.parentElement
        }
      }
    }

    const escape_html = (value) => {
      return String(value).replace(/[&<>"']/g, char => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char])
    }

    const color_to_image_src = (hex, size = 24) => {
      const svg =
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
        `<rect width="100%" height="100%" fill="${hex}" />` +
        `</svg>`;
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
    }

    const empty_svg = (size = 24) => {
      const svg =
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"></svg>`;
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
    }

    const preprocessLine = (item, key) => {
      return {
        line_item: {
          id: {
            product: item.product_id,
            variant: item.variant_id,
          },
          key,
          url: item.url,
          title: {
            line: item.title,
            product: null,
            variant: null
          },
          image: null,
          options: item.options_with_values,
          properties: Object.entries(item.properties ?? {}),
          components: [],
          has_components: item.has_components ?? false,
          selling_plan_name: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null,

          parent_key: item.parent_relationship ? item.parent_relationship.parent.key : null,
          can_remove: item.instructions ? item.instructions.can_remove : true,
          can_update_quantity: item.instructions ? item.instructions.can_update_quantity : true,

          quantity: item.quantity,
          inventory: null,
          in_cart: null,
          rule: null,
          price: {
            price: item.price,
            line_price: item.line_price,
          },
          original: {
            price: item.original_price,
            line_price: item.original_line_price,
          },
          final: {
            price: item.final_price,
            line_price: item.final_line_price,
          },
          discounts: (item.line_level_discount_allocations ?? [])
            .map(item => ({
                title: item.discount_application.title,
                amount: item.amount
              })
            ),
        }
      }
    }

    const calcInCart = (items) => {
      const variants = new Map()

      items.forEach(({line_item}) => {
        const variant_id = line_item.id.variant

        if (!variants.has(variant_id)) {
          variants.set(variant_id, {quantity: 0, items: []})
        }

        const group = variants.get(variant_id)

        group.quantity += line_item.quantity
        group.items.push(line_item)
      })

      variants.forEach(group => {
        group.items.forEach(line => {
          line.in_cart = group.quantity
        })
      })

      return variants
    }

    const preprocessCart = async (data) => {
      const
        items = data.items ?? [],
        items_added = data.items_added ?? [],
        items_removed = data.items_removed ?? [];

      data.items = new Map()
      data.items_added = new Map()
      data.items_removed = new Map()

      items.forEach(item => {
        const key = item.key
        data.items.set(key, preprocessLine(item, key))
      });

      items_added.forEach(item => {
        const
          key = item.view_key,
          line = data.items.get(key);

        if (line) {
          data.items_added.set(key, line)
        }
      });

      items_removed.forEach(item => {
        data.items_removed.set(item.view_key, item)
      });

      const
        variant_groups = calcInCart(data.items),
        added = data.items_added,
        keys = [...added.keys()],
        has_components = keys.some(key => added.get(key).line_item.has_components);

      if (keys.length > 0) {
        const variants = new Map()

        keys.forEach(key => {
          const
            line_item = added.get(key).line_item,
            variant_id = line_item.id.variant;

          if (!variants.has(variant_id)) {
            variants.set(variant_id, line_item.url)
          }
        })

        if (has_components) {
          variants.set(E, ROUTES.cart_url)
        }

        const variant_data = new Map(
          await Promise.all(
            [...variants].map(async ([variant_id, item_url]) => {
              const
                is_components = variant_id === E,
                url = new URL(item_url, window.location.href)

              url.searchParams.set('section_id', is_components ? 'json-cart-components' : 'json-product-variant')

              const
                response = await fetch(url),
                text = await response.text(),
                data = JSON.parse(createHtml(text).querySelector(SCRIPT_JSON).textContent)

              return [variant_id, data]
            })
          )
        )

        const components_data = variant_data.get(E) ?? {}
        variant_data.delete(E)

        keys.forEach(key => {
          const
            line_item = added.get(key).line_item,
            data_item = variant_data.get(line_item.id.variant),
            product = data_item.product,
            variant = data_item.variant

          line_item.title.product = product.title
          line_item.title.variant = variant.title
          line_item.image = variant.image ?? product.image
          line_item.unit_price = variant.unit_price
          line_item.in_cart = variant.in_cart
          line_item.inventory = variant.inventory
          line_item.rule = variant.rule
          line_item.options = product.has_only_default_variant ? [] : line_item.options
          line_item.components = components_data[key] ?? []
        })

        variant_data.forEach(({variant}) => {
          const group = variant_groups.get(variant.id).items

          group.forEach(line_item => {
            line_item.in_cart = variant.in_cart
            line_item.inventory = variant.inventory
            line_item.rule = variant.rule
          })
        })
      }

      return data
    }

    const toCamelCase = (str) => {
      return str.replace(/-([a-z0-9])/gi, (_, char) => char.toUpperCase());
    }

    const createHtml = (html) => {
      return new DOMParser().parseFromString(html, 'text/html').body.firstElementChild
    }

    const stripHtml = (html) => {
      return createHtml(`<div>${html}</div>`).textContent || '';
    }

    const createElement = (tag, parent) => {
      const element = document.createElement(tag)
      if (parent) {
        parent.append(element)
      }
      return element
    }

    const t_format = (str, reg_expression, params = {}) => {
      return str.replace(reg_expression, (_, key) => {
        return params[key] ?? '';
      });
    }

    const t_path = (obj, path) => {
      const keys = path === E ? [] : path.split('.')
      let result = obj
      while (keys.length) {
        result = (result ?? {})[keys.shift()]
      }
      return result
    }

    const t_replace_values = (str, reg_expression, params = {}, def_str) => {
      if (typeof str !== 'object' || params['count'] === undefined) {
        return t_format(str, reg_expression, params)
      }

      let to_translate
      if (params['count'].toString() === '0') {
        to_translate = str.zero ?? str.other ?? str.one ?? def_str;
      }
      else {
        const form = new Intl.PluralRules(locale).select(params['count']);
        to_translate = str[form] ?? str.other ?? str.one ?? def_str;
      }

      if (!to_translate) return '';
      return t_format(to_translate, reg_expression, params)
    }

    const t = (path, params = {}) => {
      const str = t_path(TRANSLATIONS, path)
      return t_replace_values(str, /\{\{\s*(\w+)\s*}}/g, params, '')
    }

    const t_custom = (path, key, params = {}) => {
      const str = (t_path(CUSTOM_TRANSLATIONS, path) ?? {})[key] ?? key
      return t_replace_values(str, /\[\[\s*(\w+)\s*]]/g, params, key)
    }

    const modifyUrl = (src, param, value) => {
      const url = new URL(src, location.origin);
      if (value === undefined) {
        url.searchParams.delete(param);
      } else {
        url.searchParams.set(param, value);
      }

      if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(src)) {
        return url.toString();
      }

      if (src.startsWith('//')) {
        return '//' + url.hostname + url.pathname + url.search + url.hash;
      }

      return url.pathname + url.search + url.hash;
    }

    const getImageUrl = (src) => {
      return modifyUrl(src, 'width')
    }

    const imageReplace = (str, new_base) => {
      const url = new URL(str, location.origin);
      url.searchParams.delete('v');

      const new_url = new URL(new_base, location.origin);
      url.searchParams.entries()
        .forEach(([key, value]) => {
          new_url.searchParams.set(key, value)
        })

      return new_url.toString();
    }

    const imageSrcSetReplace = (src, dest, img_url) => {
      dest.src = imageReplace(src.src, img_url)
      if (src.srcset) {
        dest.srcset = src.srcset
          .split(', ')
          .map(item => {
            const
              [url, descriptor] = item.trim().split(/\s+/, 2),
              replacedUrl = imageReplace(url, img_url);
            return descriptor ? `${replacedUrl} ${descriptor}` : replacedUrl
          })
          .join(", ");
      }
    }

    const amountFormat = (amount, formatter) => {
      const value = amount / Math.pow(10, TRANSLATIONS.decimals)
      const decimals = {
        minimumFractionDigits: TRANSLATIONS.decimals,
        maximumFractionDigits: TRANSLATIONS.decimals
      }

      const formatters = {
        amount: () => value.toLocaleString('en-US', decimals),
        amount_no_decimals: () => Math.round(value).toString(),
        amount_with_comma_separator: () => value.toLocaleString('de-DE', decimals),
        amount_with_space_separator: () => value.toLocaleString('fr-FR', decimals),
        amount_with_apostrophe_separator: () => value.toLocaleString('de-CH', decimals)
      };

      return formatter.replace(/\{\{\s*(\w+)\s*}}/, (_, key) => {
        return formatters[key] ? formatters[key]() : value;
      });
    }

    const moneyFormat = (amount) => {
      return amountFormat(amount, TRANSLATIONS.moneyFormat)
    }

    const moneyWithCurrencyFormat = (amount) => {
      return amountFormat(amount, TRANSLATIONS.moneyWithCurrencyFormat)
    }

    const dateFormat = (input, pattern) => {
      const date = input instanceof Date ? input : new Date(input);

      if (Number.isNaN(date.getTime())) return '';

      const pad = (value, length = 2) => String(value).padStart(length, '0');

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();

      const hour12 = hour % 12 || 12;

      const startOfYear = new Date(year, 0, 1);
      const dayOfYear = Math.floor((date - startOfYear) / 86400000) + 1;

      const sundayWeekday = date.getDay();
      const mondayWeekday = sundayWeekday === 0 ? 7 : sundayWeekday;

      const monthName = (style) =>
        new Intl.DateTimeFormat(locale, {month: style}).format(date);

      const weekdayName = (style) =>
        new Intl.DateTimeFormat(locale, {weekday: style}).format(date);

      const timezoneOffset = () => {
        const offset = -date.getTimezoneOffset();
        const sign = offset >= 0 ? '+' : '-';
        const abs = Math.abs(offset);

        return `${sign}${pad(Math.floor(abs / 60))}${pad(abs % 60)}`;
      };

      const timezoneName = () =>
        new Intl.DateTimeFormat(locale, {timeZoneName: 'short'})
          .formatToParts(date)
          .find(part => part.type === 'timeZoneName')
          ?.value || '';

      const replacements = {
        '%%': () => '%',

        '%Y': () => pad(year, 4),
        '%y': () => pad(year % 100),

        '%m': () => pad(month),
        '%-m': () => String(month),
        '%B': () => monthName('long'),
        '%b': () => monthName('short'),
        '%h': () => monthName('short'),

        '%d': () => pad(day),
        '%-d': () => String(day),
        '%e': () => String(day).padStart(2, ' '),

        '%A': () => weekdayName('long'),
        '%a': () => weekdayName('short'),

        '%H': () => pad(hour),
        '%-H': () => String(hour),
        '%k': () => String(hour).padStart(2, ' '),

        '%I': () => pad(hour12),
        '%-I': () => String(hour12),
        '%l': () => String(hour12).padStart(2, ' '),

        '%M': () => pad(minute),
        '%S': () => pad(second),

        '%p': () => hour < 12 ? 'AM' : 'PM',
        '%P': () => hour < 12 ? 'am' : 'pm',

        '%j': () => pad(dayOfYear, 3),
        '%w': () => String(sundayWeekday),
        '%u': () => String(mondayWeekday),

        '%z': () => timezoneOffset(),
        '%Z': () => timezoneName(),

        '%s': () => String(Math.floor(date.getTime() / 1000)),

        '%F': () => `${pad(year, 4)}-${pad(month)}-${pad(day)}`,
        '%D': () => `${pad(month)}/${pad(day)}/${pad(year % 100)}`,
        '%T': () => `${pad(hour)}:${pad(minute)}:${pad(second)}`,
        '%R': () => `${pad(hour)}:${pad(minute)}`,
        '%r': () => `${pad(hour12)}:${pad(minute)}:${pad(second)} ${hour < 12 ? 'AM' : 'PM'}`
      };

      return pattern.replace(
        /%%|%-?[YymdHIS]|%[ABbahdejwuklMpPzZsFDTRr]/g,
        token => replacements[token]?.() ?? token
      );
    }

    const scrollIntoViewNearest = (item, parent, margin = 5) => {
      const itemRect = item.getBoundingClientRect()
      const parentRect = parent.getBoundingClientRect()

      const maxScrollTop = parent.scrollHeight - parent.clientHeight
      const maxScrollLeft = parent.scrollWidth - parent.clientWidth

      const top = itemRect.top - Math.min(margin, parent.scrollTop)
      const bottom = itemRect.bottom + Math.min(
        margin,
        maxScrollTop - parent.scrollTop
      )

      const left = itemRect.left - Math.min(margin, parent.scrollLeft)
      const right = itemRect.right + Math.min(
        margin,
        maxScrollLeft - parent.scrollLeft
      )

      if (top < parentRect.top) {
        parent.scrollTop -= parentRect.top - top
      }
      else if (bottom > parentRect.bottom) {
        parent.scrollTop += bottom - parentRect.bottom
      }

      if (left < parentRect.left) {
        parent.scrollLeft -= parentRect.left - left
      }
      else if (right > parentRect.right) {
        parent.scrollLeft += right - parentRect.right
      }
    }

    const clamp = (value, min, max) => {
      return Math.min(Math.max(value, min), max)
    }

    const arrowVisibility = (arrow, visible) => {
      if (visible) {
        arrow.classList.remove(INVISIBLE)
        arrow.classList.add(POINTER_EVENT_AUTO)
      } else {
        arrow.classList.add(INVISIBLE)
        arrow.classList.remove(POINTER_EVENT_AUTO)
      }
    }

    const nextFrame = () => {
      return new Promise(resolve =>
        requestAnimationFrame(() =>
          requestAnimationFrame(resolve)
        )
      )
    }

    const waitTransitionEnd = (el, properties = TRANSFORM, timeout = 500) => {
      let props = Array.isArray(properties) ? properties : [properties];

      return new Promise((resolve) => {
        const done = (event = null) => {
          clearTimeout(timer)
          el.removeEventListener('transitionend', onEnd)
          resolve(event)
        }
        const timer = setTimeout(done, timeout)

        const onEnd = (event) => {
          if (event.target === el && props.includes(event.propertyName)) {
            props = props.filter(property => property !== event.propertyName)
            if (props.length === 0) {
              done(event)
            }
          }
        }
        el.addEventListener('transitionend', onEnd)
      })
    }

    const setProperties = (element, properties) => {
      const regex = /--[\w-]+/
      const old_properties = {}
      Object.entries(properties).forEach(([key, value]) => {
        const var_name = key.match(regex)?.[0] ?? null;

        old_properties[key] = undefined
        if (element.classList.contains(key)) {
          old_properties[key] = null
          if (var_name) {
            old_properties[key] = element.style.getPropertyValue(var_name) || null
          }
        }

        if (value === undefined) {
          element.classList.remove(key)
          if (var_name) {
            element.style.removeProperty(var_name)
          }
        }
        else if (value === null) {
          element.classList.add(key)
          if (var_name) {
            element.style.removeProperty(var_name)
          }
        }
        else {
          element.classList.add(key)
          element.style.setProperty(var_name, value)
        }
      })
      return old_properties
    }

    const opacityScaleTransformation = async (new_item, old_item, start, end) => {
      const transitionClass = ['transition-all']

      const new_values = setProperties(new_item, {'opacity-(--opacity)': '0%', 'scale-(--scale)': '105%'})
      if (typeof start === 'function') {
        start()
      }

      old_item.classList.remove(...transitionClass)
      const old_values = setProperties(old_item, {'opacity-(--opacity)': '100%'})

      await nextFrame()

      new_item.classList.add(...transitionClass)
      setProperties(new_item, {'opacity-(--opacity)': '100%', 'scale-(--scale)': '100%'})

      old_item.classList.add(...transitionClass)
      setProperties(old_item, {'opacity-(--opacity)': '0%'})

      await Promise.all([
        waitTransitionEnd(new_item, [TRANSFORM, OPACITY]),
        waitTransitionEnd(old_item, [OPACITY]),
      ])

      new_item.classList.remove(...transitionClass)
      old_item.classList.remove(...transitionClass)

      if (typeof end === 'function') {
        end()
      }
      setProperties(new_item, new_values)
      setProperties(old_item, old_values)
    }

    class AppState {

      constructor(storage, storageKey = SHOPIFY_THEME_NAME) {
        this.storage = storage;
        this.storageKey = storageKey;
        this.data = {};

        try {
          const saved = this.storage.getItem(this.storageKey);
          if (saved) {
            this.data = JSON.parse(saved);
          }
        } catch (e) {
          this.data = {};
        }
      }

      get(path, defaultValue = null) {
        const keys = path.split(".");
        let current = this.data;

        for (const key of keys) {
          if (current && typeof current === "object" && key in current) {
            current = current[key];
          } else {
            return defaultValue;
          }
        }

        return current;
      }

      set(path, value) {
        const keys = path.split(".");
        let current = this.data;

        for (let i = 0; i < keys.length - 1; i++) {
          const key = keys[i];

          if (!(key in current) || typeof current[key] !== "object") {
            current[key] = {};
          }

          current = current[key];
        }

        current[keys[keys.length - 1]] = value;

        this.save();
      }

      save() {
        try {
          this.storage.setItem(this.storageKey, JSON.stringify(this.data));
        } catch (e) {
        }
      }
    }

    const local_state = new AppState(localStorage);

    class PubSub {
      static TICKER = 'TICKER'
      static CUSTOM = 'CUSTOM'
      static CART_CHANGED = 'CART_CHANGED';
      static CART_NOTE = 'CART_NOTE';
      static PRODUCT_VARIANT_CHANGED = 'PRODUCT_VARIANT_CHANGED';
      static PRODUCT_QUANTITY_CHANGED = 'PRODUCT_QUANTITY_CHANGED';
      static PRODUCT_ERROR = 'PRODUCT_ERROR'
      static PRODUCT_CLEAR_ERROR = 'PRODUCT_CLEAR_ERROR'
      static PRODUCT_THUMB_CLICKED = 'PRODUCT_THUMB_CLICKED';
      static PRODUCT_THUMB_CHANGED = 'PRODUCT_THUMB_CHANGED';
      static PRODUCT_THUMB_INITIALISED = 'PRODUCT_THUMB_INITIALISED';
      static PRODUCT_GIFT_CARD_FORM = 'PRODUCT_GIFT_CARD_FORM';

      constructor() {
        this.subscribers = {}
        setInterval(() => {
          this.publish(PubSub.TICKER)
        }, 1_000)
      }

      create(event_name) {
        if (this.subscribers[event_name] === undefined) {
          this.subscribers[event_name] = [];
        }
      }

      count(event_name) {
        this.create(event_name)
        return this.subscribers[event_name].length;
      }

      subscribe(event_name, callback) {
        this.create(event_name)
        this.subscribers[event_name] = [...this.subscribers[event_name], callback];
      }

      unsubscribe(event_name, callback) {
        this.create(event_name)
        this.subscribers[event_name] = this.subscribers[event_name].filter((cb) => {
          return cb !== callback;
        });
      }

      publish(eventName, data) {
        if (!this.subscribers[eventName]) {
          return Promise.resolve();
        }

        const promises = this.subscribers[eventName].map((callback) => {
          try {
            return Promise.resolve(callback(data));
          } catch (err) {
            return Promise.reject(err);
          }
        });

        return Promise.all(promises);
      }
    }

    const pub_sub = new PubSub();

    const applyTraits = (element, trait) => {
      const template = trait.content.firstElementChild

      const classes = template.classList
      const styles = template.style.cssText

      if (element.classList.contains('contents') || element.classList.contains('traits')) {
        element = element.firstElementChild
      }

      element.classList.add(...classes)
      element.style.cssText += styles;
    }

    const cloneTemplate = (template) => {
      const result = searchAndApplyTraits(template.content.firstElementChild.cloneNode(true));
      result.querySelectorAll(TRAIT)
        .forEach((trait) => {trait.remove()})
      return result
    }

    const applyTemplate = (element, template, replace_content) => {
      if (element && template) {
        element.className = template.className
        element.style.cssText = template.style.cssText

        if (replace_content !== undefined) {
          element.textContent = replace_content
        }
        if (template.children.length) {
          const traits = [...template.children].map(el => el.cloneNode(true))
          element.append(...traits)
          searchAndApplyTraits(element)
        }
        element.querySelectorAll(TEMPLATE).forEach((template) => {template.parentElement.remove()})
      }
      return element;
    }

    const
      TRAIT_TAGS = [DIV, ARTICLE, NAV, P, H1, H2, H3, H4, H5, H6, A, BTN, SPN, UL, LI, DL, TIME, FORM, DIALOG],
      TRAIT_QUERY = TRAIT_TAGS.map(tag => TRAIT.replace(SCOPE, tag)).join(',');

    const searchAndApplyTraits = root => {
      for (const trait of root.querySelectorAll(TRAIT_QUERY)) {
        if (!trait.classList.contains('contents') && !trait.classList.contains('traits')) {
          applyTraits(trait.parentElement.parentElement, trait);
        }
      }

      for (const image of root.querySelectorAll(IMG)) {
        const parent = image.parentElement;

        if (parent.classList.contains('contents') || parent.classList.contains('traits')) {
          for (const trait of parent.querySelectorAll(TRAIT)) {
            applyTraits(image, trait);
          }
        }
      }

      return root;
    };

    if (DESIGN_MODE) {
      document.addEventListener(
        'shopify:section:load',
        (event) => {
          searchAndApplyTraits(event.target)
        }
      );
    }
    searchAndApplyTraits(document)

    const dimensions_map = new WeakMap();

    const dimensionsText = (img) => img.clientWidth + ' x ' + img.clientHeight

    const imageSizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const img = entry.target;

        if (dimensions_map.has(img)) {
          dimensions_map.get(img).textContent = dimensionsText(img);
        }
      }
    })

    const imageDimensions = (root) => {
      if (DESIGN_MODE) {
        const
          top = ['top-(--t)', '--t', 'calc(2 * var(--spacing))'],
          bottom = ['bottom-(--b)', '--b', 'calc(2 * var(--spacing))'],
          start = ['start-(--s)', '--s', 'calc(2 * var(--spacing))'],
          text = ['text-(--text-color)', '--text-color', 'var(--color-white)'],
          glow = ['text-glow-(--text-glow-color)', '--text-glow-color', 'var(--color-black)'],
          classes = {
            top: [top],
            center: [top, bottom, 'h-fit', 'my-auto'],
            bottom: [bottom],
          }

        root.querySelectorAll(`${IMG}.${DIMENSIONS}`)
          .forEach(img => {
            if (!dimensions_map.has(img)) {
              const pos = [...img.classList]
                .find(cls => cls.startsWith(DIMENSIONS + '-'))
                .slice(DIMENSIONS.length + 1)

              const dimensions = createElement(DIV);
              [...classes[pos], start, text, glow, 'absolute', 'text-sm']
                .forEach((item) => {
                  if (typeof item === 'string') {
                    dimensions.classList.add(item)
                  }
                  else {
                    dimensions.classList.add(item[0])
                    dimensions.style.setProperty(item[1], item[2])
                  }
                })
              dimensions.textContent = dimensionsText(img)
              dimensions_map.set(img, dimensions);
              imageSizeObserver.observe(img)
              img.after(dimensions_map.get(img))
            }
          })
      }
    }
    imageDimensions(document)

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        imageDimensions(event.target)
      }
    );

    class Base extends HTMLElement {
      #initialized = false;

      constructor() {
        super();
        this.applyTraits()
        this.binder([])
      }

      init() {
      }

      applyTraits() {
        this.querySelectorAll(TRAIT)
          .forEach(trait => {
            applyTraits(this, trait)
          })
      }

      #do_bind(bind_list) {
        bind_list.forEach((item) => {
          this[item] = this[item].bind(this);
        })
      }

      binder(bind_list) {
        this.#do_bind(bind_list);
      }

      clickBinder(click_bind) {
        this.#do_bind(Object.keys(click_bind));
        this.click_bind = click_bind;
      }

      subscribeBinder(subscribe_bind) {
        this.#do_bind(Object.values(subscribe_bind));
        this.subscribe_bind = subscribe_bind;
      }

      collectStateTemplate(states, empty_tag) {
        const result = {};
        [...this.querySelectorAll(TEMPLATE)]
          .filter(template => states.includes(template.className))
          .forEach(template => {
            const state = template.className
            result[state] = result[state] ?? cloneTemplate(template)
          })
        if (empty_tag) {
          states
            .forEach(state => {
              result[state] = result[state] ?? (
                typeof empty_tag === 'function'
                  ? empty_tag.call(this, state)
                  : createElement(empty_tag)
              )
            })
        }
        return result
      }

      #eventListeners(oper, event_name, map) {
        const oper_method = oper + 'EventListener'
        Object.keys(map).forEach((method) => {
          map[method].forEach((item) => {
            item[oper_method](event_name, this[method])
          })
        })
      }

      #subscribe(oper) {
        Object.entries(this.subscribe_bind).forEach(([key, value]) => {
          pub_sub[oper](key, this[value])
        })
      }

      #doInit() {
        if (!this.#initialized) {
          this.#initialized = true
          this.init()
          this.clickBinder({})
          this.subscribeBinder({})
        }
      }

      connect() {}

      disconnect() {}

      connectedCallback() {
        this.#doInit()
        this.connect()
        this.#subscribe('subscribe')
        this.#eventListeners(ADD, CLICK, this.click_bind)
      }

      disconnectedCallback() {
        this.#eventListeners(REMOVE, CLICK, this.click_bind)
        this.#subscribe('unsubscribe')
        this.disconnect()
      }

      findParentMethod(methodName, ...args) {
        for (
          let parent = this.parentElement;
          parent && parent !== document.body;
          parent = parent.parentElement
        ) {
          if (typeof parent[methodName] === 'function') {
            return parent[methodName](...args);
          }
        }

        return null;
      }

    }

    [
      'getArticleRoot',
      'getArticleInfo',
      'getBlogRoot',
      'getBlogInfo',
      'getCartInfo',
      'getCartLineInfo',
      'getPageRoot',
      'getPageInfo',
      'getProductRoot',
      'getProductInfo',
      'getVariantInfo',
      'getVariantProperties',
      'getCollectionRoot',
      'getCollectionInfo',
      'filterStateChanged',
      'stateChanged',
      'doCommand',
    ].forEach(methodName => {
      Base.prototype[methodName] = function (...args) {
        return this.findParentMethod(methodName, ...args);
      };
    });

    const Root = (Base) => class extends Base {

      constructor() {
        super();

        this.main_root = this.parentElement === document.body

        const json = this.querySelector(SCRIPT_JSON)
        if (json) {
          this.parseData(JSON.parse(json.textContent))
        }
      }

      parseData(data) {
      }

    }

    const replaceImage = async (destination, source) => {
      if (source) {
        destination.alt = source.alt
        destination.width = source.width;
        destination.height = source.height;
        destination.classList.add('object-(--object-position)');
        destination.style.setProperty('--object-position', source.focal_point);

        const preload = new Image()
        preload.sizes = destination.sizes
        imageSrcSetReplace(destination, preload, source.image)

        await preload.decode()
        imageSrcSetReplace(destination, destination, source.image)
        await nextFrame()
      }
      destination.classList.remove(INVISIBLE)
    }

    const ImageBase = (Base) => class extends Base {

      init() {
        void this.replaceImage()
      }

      async replaceImage() {
        await replaceImage(this.querySelector(IMG), this.getImage())
      }

      getImage() {}

    }

    const ComboBox = (Base) => class extends Base {

      init() {
        super.init()

        this.open = false
        this.active_item = null
        this.combo_handlers = new WeakMap()

        this.combo_index = ++ComboBox.combo_index
        this.anchor_name = `--combo-${this.combo_index}`
        this.dropdown_id = `combo-${this.combo_index}`
      }

      getComboElements() {
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.comboHandler.name,
          this.comboKeyHandler.name,
          this.documentPointerHandler.name,
        ])
      }

      calcMenuHeight() {
        const
          dropdown_styles = getComputedStyle(this.combo.dropdown),
          first_button = this.combo.buttons[0],
          item_height = first_button?.getBoundingClientRect().height || 52,

          padding = parseFloat(dropdown_styles.paddingTop) + parseFloat(dropdown_styles.paddingBottom),
          border = parseFloat(dropdown_styles.borderTopWidth) + parseFloat(dropdown_styles.borderBottomWidth),
          vertical_extra = padding + border;

        this.menu_height = Math.min(item_height * this.combo.buttons.length, item_height * 5) + vertical_extra;
        this.combo.dropdown.style.setProperty('--max-h', this.menu_height + 'px')
      }

      setupCombo() {
        const
          button = this.combo.button,
          dropdown = this.combo.dropdown;

        button.role = 'combobox'
        button.ariaExpanded = 'false'
        button.setAttribute('aria-controls', this.dropdown_id)

        dropdown.id = this.dropdown_id
        dropdown.role = 'listbox'
        dropdown.popover = 'manual'
        dropdown.hidden = false

        button.style.setProperty('anchor-name', this.anchor_name)
        dropdown.style.setProperty('position-anchor', this.anchor_name)
      }

      isComboItemDisabled(item) {
        return false
      }

      setupComboItem(item) {
        const item_index = this.combo.buttons.indexOf(item)
        item.id = `${this.dropdown_id}-option-${item_index}`
        item.role = 'option'
        item.tabIndex = -1
        item.ariaSelected = item === this.combo.current ? TRUE : FALSE
        item[this.isComboItemDisabled(item) ? 'setAttribute' : 'removeAttribute']('aria-disabled', true)
      }

      syncComboState() {
        this.combo.buttons.forEach(item => {
          item.ariaSelected = item === this.combo.current ? TRUE : FALSE
          item[this.isComboItemDisabled(item) ? 'setAttribute' : 'removeAttribute']('aria-disabled', true)
        })
      }

      registerComboItem(item) {
        if (this.combo_handlers.has(item)) return

        this.setupComboItem(item)

        const handler = event => this.itemHandler(item, event)

        this.combo_handlers.set(item, handler)
        item.addEventListener(CLICK, handler)
      }

      unregisterComboItem(item) {
        const handler = this.combo_handlers.get(item)
        if (!handler) return

        item.removeEventListener(CLICK, handler)
        this.combo_handlers.delete(item)
      }

      getComboItems() {
        return this.combo.buttons.filter(item => !this.isComboItemDisabled(item))
      }

      connect() {
        this.combo = this.getComboElements()
        this.setupCombo()

        this.querySelectorAll(TRAIT)
          .forEach(trait => {
            const parent_trait = trait.parentElement
            this.combo.button.append(parent_trait.cloneNode(true))
            this.combo.dropdown.append(parent_trait.cloneNode(true))
            parent_trait.remove()
          })

        searchAndApplyTraits(this.combo.button)
        searchAndApplyTraits(this.combo.dropdown)

        this.combo.buttons.forEach(item => {
          this.registerComboItem(item)
        })

        this.combo.button.addEventListener(CLICK, this.comboHandler)
        this.combo.button.addEventListener('keydown', this.comboKeyHandler)
        document.addEventListener(POINTER_DOWN, this.documentPointerHandler)

        this.syncComboState()
      }

      disconnect() {
        this.comboCloseHandler()

        document.removeEventListener(POINTER_DOWN, this.documentPointerHandler)
        this.combo.button.removeEventListener('keydown', this.comboKeyHandler)
        this.combo.button.removeEventListener(CLICK, this.comboHandler)

        this.combo.buttons.forEach(item => {
          this.unregisterComboItem(item)
        })
      }

      setActiveItem(item) {
        if (this.active_item === item) return

        if (this.active_item) {
          delete this.active_item.dataset.highlighted
        }

        this.active_item = item

        if (!item) {
          this.combo.button.removeAttribute('aria-activedescendant')
          return
        }

        item.dataset.highlighted = E
        this.combo.button.setAttribute('aria-activedescendant', item.id)
        scrollIntoViewNearest(item, this.combo.dropdown)
      }

      clearActiveItem() {
        if (this.active_item) {
          delete this.active_item.dataset.active
        }
        this.active_item = null
        this.combo.button.removeAttribute('aria-activedescendant')
      }

      moveActiveItem(direction) {
        const items = this.getComboItems()
        if (!items.length) return

        const current_index = items.indexOf(this.active_item)
        let next_index

        if (current_index === -1) {
          next_index = direction === 'down' ? 0 : items.length - 1
        }
        else if (direction === 'down') {
          next_index = (current_index + 1) % items.length
        }
        else {
          next_index = current_index === 0 ? items.length - 1 : current_index - 1
        }
        this.setActiveItem(items[next_index])
      }

      setFirstActiveItem() {
        const items = this.getComboItems()
        if (items.length) {
          this.setActiveItem(items[0])
        }
      }

      setLastActiveItem() {
        const items = this.getComboItems()
        if (items.length) {
          this.setActiveItem(items[items.length - 1])
        }
      }

      comboKeyHandler(event) {
        switch (event.code) {
          case 'ArrowDown':
            event.preventDefault()
            if (!this.open) {
              this.comboOpenHandler(false)
            }
            this.moveActiveItem('down')
            break

          case 'ArrowUp':
            event.preventDefault()
            if (!this.open) {
              this.comboOpenHandler(false)
            }
            this.moveActiveItem('up')
            break

          case 'Home':
            if (!this.open) return
            event.preventDefault()
            this.setFirstActiveItem()
            break

          case 'End':
            if (!this.open) return
            event.preventDefault()
            this.setLastActiveItem()
            break

          case 'Enter':
          case 'Space':
            event.preventDefault()
            if (!this.open) {
              this.comboOpenHandler()
            }
            else if (this.active_item) {
              this.active_item.click()
            }
            break

          case 'Escape':
            if (!this.open) return
            event.preventDefault()
            this.comboCloseHandler()
            break

          case 'Tab':
            if (this.open) {
              this.comboCloseHandler()
            }
            break
        }
      }

      documentPointerHandler(event) {
        if (this.open) {
          const path = event.composedPath()
          if (!path.includes(this.combo.button) && !path.includes(this.combo.dropdown)) {
            this.comboCloseHandler()
          }
        }
      }

      comboOpenHandler(set_current = true) {
        if (this.open) return

        this.combo.dropdown.showPopover()
        this.combo.button.ariaExpanded = 'true'
        this.combo.chevron.style.setProperty('--rotate','180deg')
        this.open = true

        this.calcMenuHeight()

        if (set_current && this.combo.current) {
          this.setActiveItem(this.combo.current)
        }
      }

      comboCloseHandler() {
        if (!this.open) return
        if (this.combo.dropdown.matches(':popover-open')) {
          this.combo.dropdown.hidePopover()
        }
        this.combo.button.ariaExpanded = 'false'
        this.combo.chevron.style.setProperty('--rotate', '0deg')
        this.clearActiveItem()
        this.open = false
      }

      comboHandler() {
        if (this.open) {
          this.comboCloseHandler()
        }
        else {
          this.comboOpenHandler()
        }
      }

      itemSelected(item, event) {
      }

      itemHandler(item, event) {
        this.comboCloseHandler()
        this.itemSelected(item, event)
      }

    }
    ComboBox.combo_index = 0

    class ThemeSection extends Base {
      #isShown = false
      #transit = false
      #focused = null
      #pendingClose = false

      schema = {
        'slide-left': {
          root: 'flex justify-start items-stretch',
          aside: 'h-full',
          transition: TRANSFORM,
          animation: ['animate-slide-in-left', 'animate-slide-out-left'],
        },
        'slide-right': {
          root: 'flex justify-end items-stretch',
          aside: 'h-full',
          transition: TRANSFORM,
          animation: ['animate-slide-in-right', 'animate-slide-out-right'],
        },
        'slide-top': {
          root: 'flex justify-stretch items-start',
          aside: 'w-full',
          transition: TRANSFORM,
          animation: ['animate-slide-in-top', 'animate-slide-out-top'],
        },
        'slide-bottom': {
          root: 'flex justify-stretch items-end',
          aside: 'w-full',
          transition: TRANSFORM,
          animation: ['animate-slide-in-bottom', 'animate-slide-out-bottom'],
        },
        'fade': {
          root: 'flex justify-center items-center',
          aside: E,
          transition: OPACITY,
          animation: ['animate-fade-in-up', 'animate-fade-out'],
        },
      }

      get isShown() {
        return this.#isShown
      }

      set isShown(value) {
        if (this.#isShown === value) return

        if (this.#transit) {
          if (!value) {
            this.#pendingClose = true
          }
          return
        }

        this.#isShown = value
        this.#transit = true
        this[value ? 'show' : 'hide']()
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.cancelHandler.name,
          this.escapeHandler.name
        ]);
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.CUSTOM]: this.customHandler.name,
        });
      }

      init() {
        this.event = this.dataset.event ?? E
        const animation = this.dataset.animation ?? E
        if (this.event !== E && this.schema[animation]) {
          const schema = this.schema[animation]
          this.animation = schema.animation
          this.transition = schema.transition
          this.root = searchAndApplyTraits(this.firstElementChild)
          this.root.classList.add(...schema.root.split(' '))
          this.overlay = this.root.firstElementChild.firstElementChild
          this.aside = this.root.firstElementChild.nextElementSibling.firstElementChild
          if (schema.aside !== E) {
            this.aside.classList.add(...schema.aside.split(' '))
          }
        }
      }

      connect() {
        if (this.root && !DESIGN_MODE) {
          this.root.addEventListener('cancel', this.cancelHandler);
          this.root.addEventListener('keydown', this.escapeHandler);
        }
      }

      disconnect() {
        if (this.root && !DESIGN_MODE) {
          this.root.removeEventListener('cancel', this.cancelHandler);
          this.root.removeEventListener('keydown', this.escapeHandler);
        }
      }

      async show() {
        this.#focused = document.activeElement

        const animation = this.animation[0];
        this.overlay.classList.add('animate-fade-in')
        this.aside.classList.add(animation)
        this.root.classList.remove(HIDDEN)

        this.root.showModal()

        await Promise.all([
          waitTransitionEnd(this.overlay, OPACITY),
          waitTransitionEnd(this.aside, this.transition),
        ])

        this.overlay.classList.remove('animate-fade-in')
        this.aside.classList.remove(animation)
        this.#transit = false

        if (this.#pendingClose) {
          this.#pendingClose = false
          this.isShown = false
        }
      }

      async hide() {
        const animation = this.animation[1];
        this.overlay.classList.add('animate-fade-out')
        this.aside.classList.add(animation)

        await Promise.all([
          waitTransitionEnd(this.overlay, OPACITY),
          waitTransitionEnd(this.aside, this.transition),
        ])

        this.root.close()
        this.root.classList.add(HIDDEN)
        this.overlay.classList.remove('animate-fade-out')
        this.aside.classList.remove(animation)
        this.#transit = false

        if (this.#focused?.isConnected) {
          this.#focused.focus({preventScroll: true})
        }

        this.#focused = null
      }

      customHandler(event) {
        if (DESIGN_MODE) return

        if (event.event === this.event && this.animation !== E) {
          const data = event.data ?? {open: true, close: true}
          if (this.isShown && data.close) {
            this.isShown = false
          }
          else if (!this.isShown && data.open) {
            this.isShown = true
          }
          return true
        }
      }

      escapeHandler(event) {
        if (event.key !== 'Escape' || event.defaultPrevented) return

        this.cancelHandler(event)
      }

      cancelHandler(event) {
        event.preventDefault()

        if (this.isShown) {
          pub_sub.publish(PubSub.CUSTOM, {event: this.event, data: {close: true}});
        }
      }

    }

    tagClass[THEME_SECTION] = ThemeSection

    class EventButton extends Base {

      connect() {
        const event = this.dataset.event ?? ''
        if (event) {
          this.firstElementChild.addEventListener(CLICK, () => {
            pub_sub.publish(PubSub.CUSTOM, {event})
          });
        }
      }

    }
    tagClass[EVENT_BUTTON] = EventButton;


    class MenuRoot extends Base {

      init() {
        this.templates = this.collectStateTemplate([DEFAULT, ACTIVE, CURRENT, SUBMENU]);
        [DEFAULT, SUBMENU].forEach(state => {
          this.templates[state] = this.templates[state] ?? createElement(DIV)
        });
        [ACTIVE, CURRENT].forEach(state => {
          this.templates[state] = this.templates[state] ?? this.templates[DEFAULT]
        });
        this.querySelectorAll(`${SCOPE} > ${UL} ${LI}`)
          .forEach(item => {
            this[item.firstElementChild.localName === A ? 'initItem' : 'initGroup'](item)
          })
      }

      initItem(item) {
        const link = item.firstElementChild
        const current = link.ariaCurrent === PAGE
        applyTemplate(item, this.templates[current ? CURRENT : DEFAULT])
      }

      initGroup(group) {
        const
          row = group.firstElementChild,
          sub = row.nextElementSibling,
          link = row.firstElementChild.firstElementChild,
          button = row.firstElementChild.nextElementSibling,
          params = {group, row, sub, link, button};

        this.changeTemplate(params)
        row.addEventListener(CLICK, () => {this.expandHandler(params)})
        group.addEventListener(KEY_DOWN, (event) => {this.keyboardHandler(event, params)})
        applyTemplate(sub.firstElementChild, this.templates[SUBMENU])
      }

      changeTemplate({row, link, button}) {
        const
          current = link.ariaCurrent === PAGE,
          active = button ? button.ariaExpanded === TRUE : false,
          key = active ? ACTIVE : current ? CURRENT : DEFAULT;

        applyTemplate(row, this.templates[key])
      }

      keyboardHandler(event, params) {
        if (event.key !== 'Escape' || event.defaultPrevented) return
        if (params.button.ariaExpanded !== TRUE) return

        event.preventDefault()
        params.button.focus({preventScroll: true})
        this.expandHandler(params)
      }

      expandHandler(params) {
        const {button, group, sub} = params
        if (button.ariaExpanded === TRUE) {
          button.ariaExpanded = FALSE
          group.style.setProperty('--rotate', '0deg')
          group.style.setProperty('--grid-rows', '0fr')
          sub.setAttribute(INERT, E);
        }
        else {
          button.ariaExpanded = TRUE
          group.style.setProperty('--rotate', '90deg')
          group.style.setProperty('--grid-rows', '1fr')
          sub.removeAttribute(INERT);
        }
        this.changeTemplate(params)
      }

    }

    tagClass[MENU_ROOT] = MenuRoot;

    class CollectionBase extends Base {
      #collection;
      #product;
      #variant;

      set collection(value) {
        this.#collection = value;
      }

      get collection() {
        if (!this.#collection) {
          this.#collection = super.getCollectionInfo()
        }
        return this.#collection;
      }

      set product(value) {
        this.#product = value;
      }

      get product() {
        if (!this.#product) {
          this.#product = super.getProductInfo()
        }
        return this.#product;
      }

      set variant(value) {
        this.#variant = value;
      }

      get variant() {
        if (!this.#variant) {
          this.#variant = super.getVariantInfo()
        }
        return this.#variant;
      }

    }

    class CollectionRoot extends Root(CollectionBase) {

      getCollectionRoot() {
        return this
      }

      getCollectionInfo() {
        return this.collection;
      }

      getProductInfo() {
        return this.product;
      }

      getVariantInfo() {
        return this.variant;
      }

      parseData(data) {
        this.collection = data.collection;
        this.product = data.product;
        this.variant = data.variant;
      }

    }

    tagClass[COLLECTION_ROOT] = CollectionRoot

    class CollectionCard extends CollectionRoot {
    }

    tagClass[COLLECTION_CARD] = CollectionCard

    class CollectionFacets extends CollectionBase {

      init() {
        const
          link = this.dataset.link === TRUE,
          pattern = this.dataset.pattern,
          template = this.collectStateTemplate([E], this.getEmptyTemplate)[E];

        this.getFacets().forEach(item => {
          const element = template.cloneNode(true);
          element.querySelector(SPN).textContent = t_custom(E, pattern, {value: item})
          if (link) {
            const anchor = createElement(A)
            anchor.href = `${this.collection.url}?${this.getFilterKey()}=${encodeURIComponent(item)}`;
            anchor.appendChild(element);
            this.appendChild(searchAndApplyTraits(anchor))
          }
          else {
            this.appendChild(searchAndApplyTraits(element))
          }
        })
      }

      getEmptyTemplate() {
        return createHtml('<div><span></span></div>')
      }

      getFacets() {
      }

      getFilterKey() {}
    }

    class CollectionVendors extends CollectionFacets {

      getFacets() {
        return this.collection.all_vendors
      }

      getFilterKey() {
        return 'filter.p.vendor'
      }

    }

    tagClass[COLLECTION_VENDORS] = CollectionVendors

    class CollectionTags extends CollectionFacets {

      getFacets() {
        return this.collection.all_tags
      }

      getFilterKey() {
        return 'filter.p.tag'
      }

    }

    tagClass[COLLECTION_TAGS] = CollectionTags

    class CollectionTypes extends CollectionFacets {

      getFacets() {
        return this.collection.all_types
      }

      getFilterKey() {
        return 'filter.p.product_type'
      }

    }

    tagClass[COLLECTION_TYPES] = CollectionTypes

    class CollectionLink extends CollectionBase {

      init() {
        this.firstElementChild.href = this.collection.url
      }
    }

    tagClass[COLLECTION_LINK] = CollectionLink

    class CollectionImage extends ImageBase(CollectionBase) {

      getImage() {
        const field = this.dataset.field

        if (field === 'featured_image') {
          return this.collection.image
        }
      }

    }

    tagClass[COLLECTION_IMAGE] = CollectionImage

    class CollectionSort extends CollectionBase {

      init() {
        const states = [
          'best-selling',
          'title-ascending',
          'price-ascending',
          'price-descending',
          'created-ascending',
          'created-descending',
          'manual'
        ]
        const templates = this.collectStateTemplate(states)
        const sort_by = this.collection.sort_by
        if (templates[sort_by]) {
          this.append(searchAndApplyTraits(templates[sort_by]))
        }
      }

    }

    tagClass[COLLECTION_SORT] = CollectionSort

    class CollectionTitle extends CollectionBase {

      init() {
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.collection.title
      }

    }

    tagClass[COLLECTION_TITLE] = CollectionTitle

    class CollectionTextarea extends CollectionBase {

      init() {
        const field = this.dataset.field
        if (field === 'description') {
          const text = this.page[field]?.text
          if (text !== undefined) {
            this.firstElementChild.textContent = text
          }
        }
      }

    }

    tagClass[COLLECTION_TEXTAREA] = CollectionTextarea

    class CollectionRichtext extends CollectionBase {

      init() {
        const field = this.dataset.field
        if (field === 'description') {
          const html = this.page[field]?.html
          if (html !== undefined) {
            this.firstElementChild.firstElementChild.innerHTML = html
          }
        }
      }

    }

    tagClass[COLLECTION_RICHTEXT] = CollectionRichtext

    class CollectionProductCount extends CollectionBase {

      init() {
        const pattern = this.dataset.pattern
        const span = this.querySelector(`${SPN_CONTENT}`)
        span.textContent = t_custom(
          '',
          pattern,
          {count: this.collection.products_count}
        )
      }

    }

    tagClass[COLLECTION_PRODUCT_COUNT] = CollectionProductCount

    class SortSelect extends ComboBox(Base) {

      getComboElements() {
        const
          templates = this.collectStateTemplate([DEFAULT, SELECTED], DIV),
          button = this.querySelector(BTN),
          label = button.firstElementChild.nextElementSibling,
          chevron = button.lastElementChild,
          dropdown = button.nextElementSibling,
          buttons = [...dropdown.children]
            .map(item => {
              const selected = item.dataset.selected === TRUE
              item.combo_selected = selected
              const template = templates[selected ? SELECTED : DEFAULT]
              return applyTemplate(item, template)
            }),
          current = buttons.find(item => item.combo_selected) ?? null;

        return {button, label, chevron, dropdown, buttons, current}
      }

      itemSelected(item) {
        const type = item.dataset.type
        this.combo.label.textContent = t(`sort.sort.${type}`)
        window.location = modifyUrl(location.href, 'sort_by', type)
      }

    }

    tagClass[SORT_SELECT] = SortSelect

    class FilterGroup extends Base {

      init() {
        this.params = {};
        (new URL(location.href)).searchParams
          .forEach((value, key) => {
            this.params[key] ??= [];
            this.params[key].push(...value.split(','));
          });
        this.initial_state =  this.makeString()
        this.buttons = this.querySelector(`${SCOPE} > [id$="__buttons"]`).firstElementChild
        this.buttons.classList.add(HIDDEN)
      }

      makeString() {
        return Object.keys(this.params)
          .sort((a, b) => a.localeCompare(b))
          .map(key => (
            `${encodeURIComponent(key)}=${
              [...this.params[key]]
                .sort((a, b) => a.localeCompare(b))
                .map(value => encodeURIComponent(value))
                .join(',')
            }`
          ))
          .join('&')
      }

      stateReplace(key, value) {
        const values = value == null ? [] : Array.isArray(value) ? value : [value]

        if (values.length) {
          this.params[key] = values
        }
        else {
          delete this.params[key]
        }
      }

      stateApply() {
        const url = new URL(location.href);
        url.search = this.makeString();
        location.assign(url.href);
      }

      stateReset() {
        Object.keys(this.params)
          .forEach(key => {
            if (key.startsWith('filter.')) {
              delete this.params[key];
            }
          })
        this.stateApply()
      }

      filterStateChanged(key, value) {
        this.stateReplace(key, value);
        const state = this.makeString()
        this.buttons.classList.toggle(HIDDEN, this.initial_state === state)
        return true
      }

      doCommand(command) {
        ({[APPLY]: this.stateApply, [RESET]: this.stateReset})[command].apply(this)
      }

    }

    tagClass[FILTER_GROUP] = FilterGroup

    class FilterBoolean extends Base {

      init() {
        this.param = this.dataset.paramName
      }

      stateChanged(element, value) {
        super.filterStateChanged(this.param, value ? 1 : null)
      }

    }

    tagClass[FILTER_BOOLEAN] = FilterBoolean

    class FilterList extends Base {

      init() {
        this.param = this.dataset.paramName
        this.items = {}
        this.querySelectorAll(this.getInputTag())
          .forEach((item) => {
            customElements.upgrade(item)
            this.items[item.dataset.key] = item.getState()
          })
      }

      stateChanged(element, value) {
        this.items[element.dataset.key] = value
        this.filterStateChanged(this.param, Object.keys(this.items).filter(key => this.items[key]))
      }

      getInputTag() {
        return CHECKBOX_FIELD
      }

    }

    tagClass[FILTER_LIST] = FilterList

    class FilterSwatch extends FilterList {

      getInputTag() {
        return CHECKBOX_SWATCH
      }

    }

    tagClass[FILTER_SWATCH] = FilterSwatch

    class FilterPrice extends Base {

      init() {
        this.inputs = [
          this.children[0].firstElementChild,
          this.children[1].firstElementChild,
        ]
      }

      stateChanged(element, min_value, max_value) {
        this.inputs
          .forEach((input) => {
            input.setMinValue(min_value)
            input.setMaxValue(max_value)
          })
        this.filterStateChanged('filter.v.price.gte', min_value)
        this.filterStateChanged('filter.v.price.lte', max_value)
      }

    }

    tagClass[FILTER_PRICE] = FilterPrice

    class CommandButton extends Base {

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.button]
        });
      }

      init() {
        this.button = this.firstElementChild
      }

      clickHandler() {}
    }

    class ApplyButton extends CommandButton {

      clickHandler() {
        this.doCommand(APPLY)
      }

    }

    tagClass[APPLY_BUTTON] = ApplyButton

    class ResetButton extends CommandButton {

      clickHandler() {
        this.doCommand(RESET)
      }

    }

    tagClass[RESET_BUTTON] = ResetButton

    class ProductBase extends Base {
      #root;
      #product = undefined;
      #variant;
      #properties;

      get root() {
        if (this.#root === undefined) {
          this.#root = super.getProductRoot() ?? null
        }
        return this.#root;
      }

      set product(value) {
        this.#product = value;
      }

      get product() {
        if (this.#product === undefined) {
          this.#product = super.getProductInfo() ?? null
        }
        return this.#product;
      }

      set variant(value) {
        this.#variant = value;
      }

      get variant() {
        if (this.#variant === undefined) {
          this.#variant = super.getVariantInfo() ?? null
        }
        return this.#variant;
      }

      set properties(value) {
        this.#properties = value;
      }

      get properties() {
        if (this.#properties === undefined) {
          this.#properties = super.getVariantProperties() ?? null
        }
        return this.#properties;
      }

      get option_titles() {
        return this.properties?.option_titles
      }

      get option_names() {
        return this.properties?.option_names
      }

      get option_values() {
        return this.properties?.option_values
      }

      get option_colors() {
        return this.properties?.option_colors
      }

      get option_images() {
        return this.properties?.option_images
      }

      get tree() {
        return this.properties?.tree
      }

      get variants_by_ids() {
        return this.properties?.variants_by_ids
      }

      get variant_media_ids() {
        return this.properties?.variant_media_ids
      }

      get media() {
        return this.properties?.media
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.PRODUCT_VARIANT_CHANGED]: this.variantChangedHandler.name,
          [PubSub.PRODUCT_QUANTITY_CHANGED]: this.quantityChangedHandler.name,
          [PubSub.PRODUCT_ERROR]: this.errorHandler.name,
          [PubSub.PRODUCT_CLEAR_ERROR]: this.clearErrorHandler.name,
          [PubSub.PRODUCT_THUMB_CLICKED]: this.thumbClickedHandler.name,
          [PubSub.PRODUCT_THUMB_CHANGED]: this.thumbChangedHandler.name,
          [PubSub.PRODUCT_THUMB_INITIALISED]: this.thumbInitializedHandler.name,
        });
      }

      async variantChanged() {
      }

      async variantChangedHandler(data) {
        if (data.product === this.product) {
          if (this.#variant !== data.variant) {
            this.#variant = data.variant
            await this.variantChanged()
          }
        }
      }

      quantityChanged(quantity) {
      }

      quantityChangedHandler(data) {
        data.product === this.product
        && this.quantityChanged(data.quantity);
      }

      error(source, error) {
      }

      errorHandler(data) {
        data.product === this.product
        && this.error(data.source, data.error);
      }

      clearError() {
      }

      clearErrorHandler(data) {
        data.product === this.product
        && this.clearError();
      }

      thumbClicked(media_id) {
      }

      thumbClickedHandler(data) {
        data.product === this.product
        && this.thumbClicked(data.media_id);
      }

      thumbChanged(media_id, prev_id, next_id) {
      }

      thumbChangedHandler(data) {
        data.product === this.product
        && this.thumbChanged(data.media_id, data.prev_id, data.next_id);
      }

      thumbInitialized() {
      }

      thumbInitializedHandler(data) {
        data.product === this.product
        && this.thumbInitialized();
      }

      sendMessage(message, data = {}) {
        data.product = this.product
        data.sender = this
        pub_sub.publish(message, data);
      }

    }

    class ProductRoot extends Root(ProductBase) {
      static ProductMaster = {}

      init() {
        const test = ['CJYD252592521UF', 'CJYD252592522VE', 'CJYD252592517QJ'];
        if (this.variants_by_ids) {
          Object.values(this.variants_by_ids)
            .filter(variant => test.includes(variant.sku))
            .forEach(variant => {
              variant.available = false
            })
        }
      }

      getProductRoot() {
        return this
      }

      getProductInfo() {
        return this.product
      }

      getVariantInfo() {
        return this.variant
      }

      getVariantProperties() {
        return this.properties
      }

      isProductMaster() {
        const product_id = this.product.id
        const master = ProductRoot.ProductMaster

        return master[product_id] && master[product_id][0] === this
      }

      setProductMaster() {
        const product_id = this.product.id
        const master = ProductRoot.ProductMaster

        if (product_id) {
          if (master[product_id] === undefined) {
            master[product_id] = []
          }
          master[product_id][this.main_root ? 'unshift' : 'push'](this)
        }
      }

      clearProductMaster() {
        const product_id = this.product.id
        const master = ProductRoot.ProductMaster

        master[product_id] = master[product_id].filter(item => item !== this)
      }

      connect() {
        this.setProductMaster();
      }

      disconnect() {
        this.clearProductMaster();
      }

      findItem(options) {
        let node = this.tree
        for (const option of options) {
          node = node[option];
        }
        return node
      }

      flatBranch(branch) {
        const result = []

        const walk = (branch) => {
          if (branch.id !== undefined) {
            result.push(branch)
          } else {
            Object.values(branch).forEach(v => walk(v))
          }
        }
        walk(branch);
        return result
      }

      variantsByOptions(options) {
        return this.flatBranch(this.findItem(options));
      }

      buildTree(levels) {
        function buildLevel(level) {
          if (level >= levels.length) {
            return null;
          }

          const values = levels[level];
          const node = {};

          for (const value of values) {
            node[value] = buildLevel(level + 1);
          }

          return node;
        }

        return buildLevel(0);
      }

      attachItem(tree, item) {
        const keys = item.options

        function findLevel(level, node) {
          if (level >= keys.length) {
            return item;
          }
          const key = keys[level];
          node[key] = findLevel(level + 1, node[key]);
          return node
        }

        findLevel(0, tree)
      }

      parseData(data) {
        this.product = data.product
        this.variant = data?.variant ?? null
        this.properties = null

        const
          variants = data?.variants ?? [],
          options = data.options ?? [],
          data_media = data.media ?? [];

        if (variants.length) {
          const
            option_titles = [],
            option_names = [],
            option_values = [],
            option_colors = [],
            option_images = [];

          options.sort((a, b) => a.position - b.position);
          options.forEach(option => {
            const title = option.name;
            option_titles.push(title)
            option_names.push(title.toLowerCase())
            option_values.push(option.values)
            option_colors.push(option.colors)
            option_images.push(option.images)
          })

          const tree = this.buildTree(option_values)

          const variants_by_ids = {}
          const variant_media_ids = []
          variants.forEach(item => {
            variants_by_ids[item.id] = item;
            variant_media_ids.push(item.media_id);
            this.attachItem(tree, item);
          })

          const media = {}
          data_media.forEach(item => {
            media[item.id] = item;
          })

          this.properties = {
            option_titles, option_names, option_values, option_colors, option_images,
            tree, variants_by_ids, variant_media_ids, media
          }
          this.variant = this.variants_by_ids[this.variant.id]
        }

      }

      async variantChanged() {
        if (!this.isProductMaster()) return

        if (this.main_root) {
          history.replaceState({}, '', modifyUrl(location, 'variant', this.variant.id));
        }
      }

    }

    tagClass[PRODUCT_ROOT] = ProductRoot


    class ProductCard extends ProductRoot {
    }

    tagClass[PRODUCT_CARD] = ProductCard

    class ProductLink extends ProductBase {

      init() {
        this.firstElementChild.href = this.product.url
      }

    }

    tagClass[PRODUCT_LINK] = ProductLink

    class ProductTitle extends ProductBase {

      init() {
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.product.title
      }

    }

    tagClass[PRODUCT_TITLE] = ProductTitle

    class ProductTextarea extends ProductBase {

      init() {
        const field = this.dataset.field
        if (field === 'description') {
          const text = this.product[field]?.text
          if (text !== undefined) {
            this.firstElementChild.textContent = text
          }
        }
      }

    }

    tagClass[PRODUCT_TEXTAREA] = ProductTextarea

    class ProductRichtext extends ProductBase {

      init() {
        const field = this.dataset.field
        if (field === 'description') {
          const html = this.product[field]?.html
          if (html !== undefined) {
            this.firstElementChild.firstElementChild.innerHTML = html
          }
        }
      }

    }

    tagClass[PRODUCT_RICHTEXT] = ProductRichtext

    class ProductImage extends ImageBase(ProductBase) {

      getImage() {
        const field = this.dataset.field

        if (field === 'featured_image') {
          return this.product.image;
        }
      }

    }

    tagClass[PRODUCT_IMAGE] = ProductImage

    class ProductMedia extends ProductBase {

      init() {
        const
          image = this.querySelector(IMG),
          types = ['video', 'youtube', 'vimeo', 'model'],
          templates = this.collectStateTemplate(types, DIV),
          title = this.product.title,
          media = this.product.media,
          poster = media.preview_image.src;

        if (media.media_type === 'image') {
          void replaceImage(image, this.product.image);
        }
        else if (media.media_type === 'model') {
          const
            product_model = templates['model'],
            script = product_model.firstElementChild,
            model = script.nextElementSibling,
            button = model.nextElementSibling,
            source = media.sources.find(({ format }) => format === 'glb');
          script.textContent = JSON.stringify(media);
          model.src = source.url;
          model.alt = title
          model.poster = poster
          button.dataset.shopifyModel3dId = media.id
          button.dataset.shopifyTitle = title
          image.replaceWith(product_model)
          product_model.play()
        }
        else if (media.media_type === 'video') {
          const
            product_video = templates['video'],
            video = product_video.firstElementChild,
            source = video.firstElementChild,
            img = source.nextElementSibling,
            media_source = this.getBestLoopSource(video, media.sources);
          source.src = media_source.url
          source.type = media_source.mime_type
          video.ariaLabel = title
          video.poster = poster
          img.src = poster
          img.alt = title
          image.replaceWith(product_video)
          product_video.play()
        }
        else if (media.media_type === 'external_video' && media.host === 'youtube') {
          const
            product_youtube = templates['youtube'],
            iframe = product_youtube.firstElementChild,
            video_id = media.external_id,
            url = new URL(`https://www.youtube.com/embed/${video_id}`);
          url.searchParams.set('autoplay', '0');
          url.searchParams.set('controls', '1');
          url.searchParams.set('enablejsapi', '1');
          url.searchParams.set('loop', '1');
          url.searchParams.set('modestbranding', '1');
          url.searchParams.set('origin', location.origin);
          url.searchParams.set('playlist', video_id);
          url.searchParams.set('playsinline', '1');
          url.searchParams.set('rel', '0');
          iframe.src = url.toString()
          iframe.title = title;
          image.replaceWith(product_youtube)
        }
        else if (media.media_type === 'external_video' && media.host === 'vimeo') {
          const
            product_vimeo = templates['vimeo'],
            iframe = product_vimeo.firstElementChild,
            video_id = media.external_id,
            url = new URL(`https://player.vimeo.com/video/${video_id}`);
          url.searchParams.set('autoplay', '0');
          url.searchParams.set('byline', '0');
          url.searchParams.set('controls', '1');
          url.searchParams.set('loop', '1');
          url.searchParams.set('playsinline', '1');
          url.searchParams.set('title', '0');
          iframe.src = url.toString()
          iframe.title = title;
          image.replaceWith(product_vimeo)
        }
        else {
          void replaceImage(image, this.product.image);
        }
      }

      getBestLoopSource(video, sources) {
        const priorities = {
          mp4: 3,
          mov: 2,
          m3u8: 1,
        };

        return sources.reduce((best, source) => {
          if (!video.canPlayType(source.mime_type)) return best;

          if (!best) return source;

          const priority = priorities[source.format] ?? 0;
          const bestPriority = priorities[best.format] ?? 0;

          if (priority !== bestPriority) {
            return priority > bestPriority ? source : best;
          }

          const resolution = source.width * source.height;
          const bestResolution = best.width * best.height;

          return resolution > bestResolution ? source : best;
        }, null);
      }


    }

    tagClass[PRODUCT_MEDIA] = ProductMedia

    class ProductPrice extends ProductBase {

      init() {
        const
          ds = this.dataset,
          pattern = ds.pattern,
          show = ds.show,
          hide_if_no_compare = ds.hideIfNoCompare === TRUE,
          span = this.querySelector(SPN),
          product = this.product;

        let value = '';

        if (product) {
          const
            price = product.price.varies
              ? `${moneyFormat(product.price.min)} - ${moneyFormat(product.price.max)}`
              : moneyFormat(product.price.price),
            has_compare = product.compare_at.price !== null,
            compare = has_compare ? moneyFormat(product.compare_at.max) : null,
            placeholders = ['[[ price ]]', '[[ compare ]]'],
            empty_pattern = placeholders.reduce(
              (p, c) => p.replaceAll(c, ''),
              pattern
            ),
            length = empty_pattern.length;

          value = t_custom(E, pattern, {price, compare})

          if (pattern.length !== length && value.length === length) {
            value = ''
          }
          if ((show === 'available' && !product.available) || (show === 'unavailable' && product.available)) {
            value = ''
          }
          if (hide_if_no_compare && !has_compare) {
            value = ''
          }
        }

        this.classList.toggle(HIDDEN, !value)
        span.textContent = value
      }

    }

    tagClass[PRODUCT_PRICE] = ProductPrice

    class VariantHeader extends ProductBase {
      #index;

      init() {
        const block = this.firstElementChild;

        this.blocks = new Map()
        this.blocks.set(block, block.textContent.trim());

        [...this.querySelectorAll(TEMPLATE)]
          .filter(item => item.classList.contains(HEADER))
          .forEach(template => {
            const block = cloneTemplate(template)
            this.append(block)
            this.blocks.set(block, block.textContent.trim());
            template.parentElement.remove()
          })
      }

      set index(index) {
        if (this.#index !== undefined) return
        this.#index = index
        this.updateHeader()
      }

      updateHeader() {
        const
          index = this.#index,
          params = {
            option: this.option_titles[index],
            value: this.variant.options[index],
          };
        [0, 1, 2].forEach(i => {
          const
            option = `option${i + 1}`,
            value = `value${i + 1}`;
          params[option] = E
          params[value] = E
          if (i === index) {
            params[option] = params['option']
            params[value] = params['value']
          }
        })
        this.blocks.forEach((pattern, block) => {
          const content = t_custom('', pattern, params)
          block.textContent = /[\p{L}\p{N}]/u.test(content) ? content : E
        })
      }

      async variantChanged() {
        this.updateHeader()
      }

    }

    tagClass[VARIANT_HEADER] = VariantHeader

    class VariantContent extends Base {
    }

    tagClass[VARIANT_CONTENT] = VariantContent

    class VariantElement extends ProductBase {
      #index = null
      #headerTemplate = null

      init() {
        this.demo = this.dataset.demo === TRUE

        this.handlers = new WeakMap()
        this.options = {}
        this.uplevel_options = null

        this.states = [DEFAULT, SELECTED, DISABLED]
        this.marks = [DEFAULT_MARK, SELECTED_MARK, DISABLED_MARK]

        this.#headerTemplate = this.collectStateTemplate([HEADER])[HEADER]
        this.templates = this.collectStateTemplate(this.states, this.getEmptyTemplate)
        this.mark_templates = this.collectStateTemplate(this.marks, DIV)
      }

      getEmptyTag() {
        return DIV
      }

      getEmptyTemplate(state) {
        const result = createElement(this.getEmptyTag())
        result.classList.add('whitespace-nowrap')
        result.classList.add((state === DISABLED) ? 'cursor-not-allowed' : 'cursor-default')
        return result
      }

      getTemplates(selected, disabled) {
        const state = disabled ? DISABLED : selected ? SELECTED : DEFAULT
        return this.templates[state]
      }

      get headerTemplate() {
        return this.#headerTemplate
      }

      set headerTemplate(template) {
        this.#headerTemplate = this.#headerTemplate ?? template
      }

      get index() {
        return this.#index
      }

      set index(index) {
        if (this.#index !== null) return;
        this.#index = index
        this.createContent()
      }

      createContent() {
        this.uplevel_options = this.variant.options.slice(0, this.#index)
        this.createHeader()
        this[this.demo ? this.createDemoItems.name : this.createItems.name]()
        this.customizeContent()
      }

      createHeader() {
        const header = this.headerTemplate.cloneNode(true)
        header.classList.add('block')
        this.parentElement.prepend(header)
        header.index = this.#index
      }

      customizeContent() {
      }

      createMarks() {
        const
          states = {
            [DEFAULT]: DEFAULT_MARK,
            [SELECTED]: SELECTED_MARK,
            [DISABLED]: DISABLED_MARK,
          },
          marks = {}
        Object.entries(states)
          .forEach(([key, value]) => {
            marks[key] = this.mark_templates[value].cloneNode(true).firstElementChild ?? createElement(DIV)
          })
        return marks
      }

      createIcons(item) {
        const icons = {}
        Object.entries(item.marks)
          .forEach(([key, value]) => {
            icons[key] = !!value.querySelector(SVG)
          })
        return icons
      }

      createPosition(item) {
        const positions = {}
        Object.entries(item.marks)
          .forEach(([key, value]) => {
            positions[key] = value.dataset.position === 'before'
          })
        return positions
      }

      createDemoItems() {
        this.states.forEach(state => {
          if (this.templates[state]) {
            const item = this.templates[state].cloneNode(true)
            item.marks = this.createMarks()
            item.icons = this.createIcons(item)
            item.positions = this.createPosition(item)
            item.state = {
              [SELECTED]: state === SELECTED,
              [DISABLED]: state === DISABLED,
            }
            this.customizeDemoItem(item)
            this.updateState(item)
            this.appendItem(item)
            this.options[state] = item
          }
        })
      }

      prepareState(value) {
        const
          opts = [...this.uplevel_options, value],
          selected = opts.reduce((p, c, i) => p && c === this.variant.options[i], true),
          vars = this.root.variantsByOptions(opts),
          disabled = vars.reduce((p, c) => p && !c.available, true)
        return {selected, disabled}
      }

      createItems() {
        this.option_values[this.#index]
          .forEach(value => {
            const
              {selected, disabled} = this.prepareState(value),
              template = this.getTemplates(selected, disabled),
              item = template.cloneNode(true),
              handler = (e) => this.clickHandler(e, item);

            this.handlers.set(item, handler)
            item.addEventListener(CLICK, handler)
            item.marks = this.createMarks()
            item.icons = this.createIcons(item)
            item.positions = this.createPosition(item)
            item.state = {selected, disabled};
            item.variant_value = value
            item.disabled = disabled

            this.customizeItem(item, value);
            this.updateState(item)
            this.appendItem(item);

            this.options[value] = item
          })
      }

      customizeDemoItem(item) {
      }


      customizeItem(item, value) {
      }

      updateState(item) {
        if (item.state[DISABLED]) {
          item.marks[DEFAULT].remove()
          item.marks[SELECTED].remove()
          if (item.icons[DISABLED]) {
            item[item.positions[DISABLED] ? 'prepend' : 'append'](item.marks[DISABLED])
          }
        }
        else if (item.state[SELECTED]) {
          item.marks[DEFAULT].remove()
          if (item.icons[SELECTED]) {
            item[item.positions[SELECTED] ? 'prepend' : 'append'](item.marks[SELECTED])
          }
          item.marks[DISABLED].remove()
        }
        else {
          if (item.icons[DEFAULT]) {
            item[item.positions[DEFAULT] ? 'prepend' : 'append'](item.marks[DEFAULT])
          }
          item.marks[SELECTED].remove()
          item.marks[DISABLED].remove()
        }
      }

      appendItem(item) {
        this.appendChild(item)
      }

      async variantChanged() {
        this.uplevel_options = this.variant.options.slice(0, this.index)

        this.updateCustomization()

        for (const value of this.option_values[this.#index]) {
          const
            {selected, disabled} = this.prepareState(value),
            template = this.getTemplates(selected, disabled),
            item = this.options[value];

          item.className = template.className
          item.style.cssText = template.style.cssText
          item.state[SELECTED] = selected
          item.state[DISABLED] = disabled
          item.disabled = disabled

          this.updateCustomizationItem(item, value);
          this.updateState(item)
        }

      }

      updateCustomization() {
      }

      updateCustomizationItem(item, value) {
      }

      clicked() {
      }

      clickHandler(event, item) {
        if (!item.state[DISABLED] && !item.state[SELECTED]) {
          this.clicked()

          for (const item of Object.values(this.options)) {
            if (item.state[SELECTED]) {
              item.state[SELECTED] = false
              this.updateState(item)
            }
          }
          item.state[SELECTED] = true
          this.updateState(item)

          const opt = [...this.variant.options]
          opt[this.index] = item.variant_value
          const variant = this.root.findItem(opt)
          if (variant !== this.variant) {
            this.sendMessage(PubSub.PRODUCT_VARIANT_CHANGED, {variant})
          }
        }
      }
    }

    class VariantPills extends VariantElement {

      getEmptyTag() {
        return BTN
      }

      customizeItem(item, value) {
        item.querySelector(SPN).textContent = value;
      }

    }

    tagClass[VARIANT_PILLS] = VariantPills

    class VariantSelect extends ComboBox(VariantElement) {
      #elements = null;

      get elements() {
        if (!this.#elements) {
          const button = this.querySelector(BTN)
          const label = button.firstElementChild
          const chevron = button.lastElementChild
          const dropdown = button.nextElementSibling

          const buttons = []
          const current = null
          this.#elements = {button, label, chevron, dropdown, buttons, current}
        }
        return this.#elements;
      }

      getComboElements() {
        return this.elements
      }

      customizeContent(){
        const elements = this.elements
        elements.button.ariaLabel = this.option_titles[this.index]
        elements.label.textContent = this.demo
          ? Object.values(this.options).filter(item => item.state[SELECTED])[0].textContent
          : this.variant.options[this.index]
      }

      customizeItem(item, value) {
        item.querySelector(SPN).textContent = value;
      }

      appendItem(item) {
        const elements = this.elements
        elements.dropdown.append(item)
        elements.buttons.push(item)

        if (item.state[SELECTED]) {
          elements.current = item
        }

        if (this.combo) {
          this.registerComboItem(item)
        }
      }

      updateCustomization() {
        this.elements.label.textContent = this.variant.options[this.index]
        this.elements.current = this.elements.buttons.find(item => item.state[SELECTED]) ?? null
        this.syncComboState()
      }

      clicked() {
        this.comboCloseHandler()
      }

      isComboItemDisabled(item) {
        return item.state[DISABLED]
      }

    }

    tagClass[VARIANT_SELECT] = VariantSelect

    class VariantSwatches extends VariantElement {

      init() {
        super.init()
        this.behavior = this.closest(PRODUCT_VARIANTS).dataset.swatchBehavior
        this.cache = {}
        this.image_template = this.collectStateTemplate([IMAGE])[IMAGE]
        this.image = this.image_template.firstElementChild
        this.image.remove()
      }

      getImage(value) {
        const
          index = this.index,
          value_index = this.option_values[index].indexOf(value),
          cache_index = [...this.uplevel_options, value].join('|')

        if (!this.cache[cache_index]) {
           let
             img = this.image.cloneNode(true)
           const
             images = this.option_images[index],
             colors = this.option_colors[index],
             shopify = !!(this.behavior !== VARIANT_ALWAYS && (colors || images));

          img.classList.remove('object-(--object-position)')
          img.style.removeProperty('--object-position')

          if (shopify) {
            const
              media = images ? images[value_index] : null,
              color = colors ? colors[value_index] : null;

            if (media) {
              imageSrcSetReplace(img, img, media.src)
              img.width = media.width
              img.height = media.height
              img.classList.add('object-(--object-position)')
              img.style.setProperty('--object-position', media.focal_point)
            }
            else {
              img.src = color ? color_to_image_src(color) : empty_svg()
              img.width = 24
              img.height = 24
              img.removeAttribute('srcset')
              img.removeAttribute('sizes')

              if (!color) {
                img = createElement(SPN);
                img.textContent = value
                img.classList.add('whitespace-normal')
              }
            }

            img.alt = value
          }
          else {
            const
              opts = [...this.uplevel_options, value],
              vars = this.root.variantsByOptions(opts),
              media_id = vars[0]?.media_id,
              media = this.media[media_id]

            if (media?.src) {
              imageSrcSetReplace(img, img, media.src)
              img.alt = media.alt || value
              img.width = media.width
              img.height = media.height
              if (media.focal_point) {
                img.classList.add('object-(--object-position)')
                img.style.setProperty('--object-position', media.focal_point)
              }
            }
            else {
              img = createElement(SPN)
              img.textContent = value
              img.classList.add('whitespace-normal')
            }
          }
          img.title = value
          this.cache[cache_index] = img
        }

        return this.cache[cache_index]
      }

      createMarks() {
        const
          classes = 'absolute inset-0 pointer-events-none flex justify-center items-center'.split(' '),
          marks = super.createMarks();
        Object.values(marks).forEach((mark) => {
          mark.classList.remove('inline-block')
          mark.classList.add(...classes)
        })
        return marks
      }

      customizeDemoItem(item) {
        item.classList.add(...this.image_template.classList)
        item.style.cssText += this.image_template.style.cssText

        const img = this.image.cloneNode(true)
        const media = item.querySelector(IMG).src
        imageSrcSetReplace(img, img, media)

        item.textContent = ''
        item.appendChild(img);
      }

      customizeItem(item, value) {
        item.classList.add(...this.image_template.classList)
        item.style.cssText += this.image_template.style.cssText

        item.textContent = ''
        item.appendChild(this.getImage(value));
      }

      updateCustomizationItem(item, value) {
        item.classList.add(...this.image_template.classList)
        item.style.cssText += this.image_template.style.cssText
        item.firstElementChild.replaceWith(this.getImage(value));
      }


    }

    tagClass[VARIANT_SWATCHES] = VariantSwatches

    class ProductVariants extends ProductBase {

      init() {
        this.swatch_behavior = this.dataset.swatchBehavior
        this.header_template = this.collectStateTemplate([HEADER], VARIANT_HEADER)[HEADER];
        this.component_templates = this.collectStateTemplate([SWATCHES, PILLS, SELECT])
        this.default_template = null;
        this.templates = {};

        [...this.querySelectorAll(TEMPLATE)]
          .filter(template => 'fields' in template.dataset)
          .forEach(template => {
            const node = cloneTemplate(template)

            template.dataset.fields
              .toLowerCase()
              .split(',')
              .forEach(field => {
                field = field.trim()
                if (field === '*') {
                  this.default_template = this.default_template ?? node
                } else {
                  this.templates[field] = this.templates[field] ?? node;
                }
              })
          })
        this.default_template = this.default_template ?? this.component_templates[PILLS] ?? createElement(VARIANT_PILLS)

        this.option_names
          ?.forEach((field, index) => {
            const
              swatch = this.swatch_behavior === AUTOMATIC && (this.option_colors[index] || this.option_images[index]),
              template = (
                swatch
                ? this.component_templates[SWATCHES]
                : this.templates[field]
              ) ?? this.default_template,
              option = template.cloneNode(true),
              variant_element = option.firstElementChild;

            this.appendChild(option)
            variant_element.headerTemplate = this.header_template
            variant_element.index = index;
          })
      }

    }

    tagClass[PRODUCT_VARIANTS] = ProductVariants


    class VariantSKU extends ProductBase {

      init() {
        this.text = this.dataset.text
      }

      async variantChanged() {
        this.textContent = t_custom('', this.text, {sku: this.variant.sku})
      }
    }

    tagClass[VARIANT_SKU] = VariantSKU

    class VariantInventory extends ProductBase {

      init() {
        this.thresholds = []

        for (const template of this.querySelectorAll(TEMPLATE)) {
          const threshold = {
            threshold: parseInt(template.dataset.threshold),
            less: template.dataset.less,
            more: template.dataset.more,
            template: template.content.firstElementChild.cloneNode(true)
          }
          this.thresholds.push(threshold)
          template.remove()
        }

        this.thresholds.sort((a, b) => a.threshold - b.threshold)
        this.showInventory()
      }

      showInventory() {
        const quantity = this.variant.inventory

        const result = {
          str: '',
          template: null,
          more: true
        }
        const params = {quantity}

        for (const threshold of this.thresholds) {
          if (result.more) {
            result.template = threshold.template
            params.threshold = threshold.threshold
            if (quantity <= threshold.threshold) {
              result.str = t_custom('', threshold.less, params)
              result.more = false
            } else {
              result.str = t_custom('', threshold.more, params)
            }
          }
        }

        this.textContent = ''
        if (result.template) {
          const node = result.template.cloneNode(true)
          this.appendChild(searchAndApplyTraits(node))
          node.textContent = result.str
        }
      }

      async variantChanged() {
        this.showInventory()
      }

    }

    tagClass[VARIANT_INVENTORY] = VariantInventory

    class VariantPrice extends ProductBase {

      init() {
        this.demo = this.dataset.demo === TRUE
        this.pattern = this.dataset.pattern
        this.show = this.dataset.show
        this.sr_pattern = this.dataset.srOnly

        this.price = this.firstElementChild
        this.sr_only = this.price.nextElementSibling
      }

      async variantChanged() {
        const placeholders = ['[[ price ]]', '[[ compare ]]', '[[ discount ]]'];
        const available = this.variant.available
        let hidden = false, price, compare, discount;

        if (this.demo) {
          price = 9999
          compare = 14549
        }
        else {
          price = this.variant.price?.price ?? null
          compare = this.variant.compare_at?.price ?? null
        }

        if (compare && compare > price) {
          discount = Math.round((compare - price) * 100 / compare)
        }
        else {
          compare = null
          discount = null
        }

        if (price != null) {
          price = moneyFormat(price)
        }
        if (compare != null) {
          compare = moneyFormat(compare)
        }

        let pattern = this.pattern
        let empty_pattern = placeholders.reduce((p, c) => p.replaceAll(c, ''), pattern)
        let length = empty_pattern.length;
        let value = t_custom(E, pattern, {price, compare, discount})

        if (pattern.length !== length && value.length === length) {
          value = ''
        }

        pattern = this.sr_pattern
        empty_pattern = placeholders.reduce((p, c) => p.replaceAll(c, ''), pattern)
        length = empty_pattern.length;
        let sr_value = t_custom(E, pattern, {price, compare, discount})

        if (pattern.length !== length && sr_value.length === length) {
          sr_value = ''
        }

        if (!this.demo) {
          if (available) {
            if (this.show === 'unavailable') {
              hidden = true
            }
          }
          else {
            if (this.show === 'available') {
              hidden = true
            }
          }
          if (!value) {
            hidden = true
          }
        }

        if (hidden) {
          this.price.textContent = ''
          this.sr_only.textContent = ''
          this.classList.add(HIDDEN)
        }
        else {
          this[available ? 'removeAttribute' : 'setAttribute']('aria-disabled', true)
          this.price.textContent = value
          this.price[sr_value ? 'setAttribute' : 'removeAttribute']('aria-hidden', true)
          this.sr_only.textContent = sr_value
          this.classList.remove(HIDDEN)
        }
      }

    }

    tagClass[VARIANT_PRICE] = VariantPrice

    class VariantUnitPrice extends ProductBase {

      init() {
        this.demo = this.dataset.demo === TRUE
        this.text = this.firstElementChild
        this.pattern = this.dataset.pattern
        this.showValue()
      }

      showValue() {
        if (this.demo) {
          const value = moneyFormat(9999) + ' / ' + t_custom('', 'kg')
          this.text.textContent = t_custom('', this.pattern, {value})
          this.classList.remove(HIDDEN)
        } else if (this.variant.unit_price) {
          const value = this.variant.unit_price
          this.text.textContent = t_custom('', this.pattern, {value})
          this.classList.remove(HIDDEN)
        } else {
          this.text.textContent = ''
          this.classList.add(HIDDEN)
        }
      }

      async variantChanged() {
        this.showValue()
      }

    }

    tagClass[VARIANT_UNIT_PRICE] = VariantUnitPrice

    class VariantPickups extends ComboBox(Root(ProductBase)) {
      #elements;

      init() {
        super.init()
        this.demo = this.dataset.demo === TRUE
        this.templates = this.collectStateTemplate([AVAILABLE, UNAVAILABLE], DIV)
        this.updatePickups()
      }

      parseData(data) {
        this.pickups = data.pickups
      }

      get elements() {
        if (!this.#elements) {
          const
            button = this.querySelector(BTN),
            label = button.firstElementChild,
            chevron = button.lastElementChild,
            dropdown = button.nextElementSibling;

          this.#elements = {button, label, chevron, dropdown, buttons: [], current: null}
        }
        return this.#elements;
      }

      getComboElements() {
        return this.elements
      }

      updatePickups() {
        const
          available = this.pickups.some(item => item.available),
          {button, label, buttons, dropdown} = this.elements

        button.classList.toggle(HIDDEN, !available)
        while (buttons.length) buttons.pop()
        dropdown.textContent = ''

        if (available) {
          this.pickups.forEach((item, index) => {
            const
              template = this.templates[item.available ? AVAILABLE : UNAVAILABLE],
              pickup = template.cloneNode(true),
              phone = pickup.querySelector('.location-phone');

            pickup.dataset.latitude = item.location.latitude
            pickup.dataset.longitude = item.location.longitude

            pickup.querySelector('.location-name').textContent = item.location.name
            pickup.querySelector('.pick-up-time').textContent = item.available ? item.pick_up_time : ''
            pickup.querySelector('.location-address').innerHTML = item.location.address
            phone.textContent = item.location.phone
            phone.href = `tel:${item.location.phone}`

            if (index === 0) {
              const div = label.firstElementChild
              div.textContent = ''
              div.append(pickup.querySelector('.location-name').parentElement.cloneNode(true))
            }

            buttons.push(pickup)
            dropdown.appendChild(pickup)
          })
        }
      }

      calcMenuHeight() {
        const
          dropdown_styles = getComputedStyle(this.combo.dropdown),
          padding = parseFloat(dropdown_styles.paddingTop) + parseFloat(dropdown_styles.paddingBottom),
          border = parseFloat(dropdown_styles.borderTopWidth) + parseFloat(dropdown_styles.borderBottomWidth),
          vertical_extra = padding + border,
          items_height = this.combo.buttons.reduce((p, c) => p + c.getBoundingClientRect().height, 0)

        this.menu_height = Math.min(items_height, 300) + vertical_extra;
        this.combo.dropdown.style.setProperty('--max-h', this.menu_height + 'px')
      }


      async variantChanged() {
        if (!this.demo) {
          const url = new URL(location.href)
          url.searchParams.set('section_id', 'json-variant-pickups');

          const
            response = await fetch(url),
            text = await response.text(),
            data = JSON.parse(createHtml(text).querySelector(SCRIPT_JSON).textContent)

          this.pickups = data.pickups
        }
        this.updatePickups()
      }

      itemSelected(item, event) {
        if (event?.target.closest(A)) return

        const
          latitude = Number(item.dataset.latitude),
          longitude = Number(item.dataset.longitude);

        if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
          const url = new URL('https://www.google.com/maps/search/')
          url.searchParams.set('api', '1')
          url.searchParams.set('query', `${latitude},${longitude}`)
          window.open(url, '_blank','noopener,noreferrer')
        }
      }

    }

    tagClass[VARIANT_PICKUPS] = VariantPickups

    class MediaBase extends Base {
      #playing = false

      get playing() {
        return this.#playing
      }

      set playing(value) {
        if (this.#playing !== value) {
          this[value ? 'play' : 'pause']()
        }
      }

      play() {
        this.#playing = true
      }

      pause() {
        this.#playing = false
      }

    }

    class ModelXR {
      static #instance;
      #models = [];
      #ready = false

      constructor() {
        if (ModelXR.#instance) {
          return ModelXR.#instance
        }
        ModelXR.#instance = this
        this.setupShopifyXR = this.setupShopifyXR.bind(this)
        document.readyState === 'loading'
          ? window.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true })
          : this.initialize()
      }

      initialize() {
        Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: this.setupShopifyXR,
          },
        ]);
      }

      static addModel(model) {
        const instance = this.#instance ?? new this()
        instance.#models.push(model)
        instance.addModels()
      }

      addModels() {
        if (this.#ready) {
          window.ShopifyXR.addModels(this.#models)
          window.ShopifyXR.setupXRElements();
        }
      }

      setupShopifyXR(errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', () => {
            this.#ready = true;
            this.addModels()
          });
        }
      }

    }

    class ProductVideo extends MediaBase {

      init() {
        this.video = this.querySelector('video')
      }

      play() {
        this.video.play()
        super.play();
      }

      pause() {
        this.video.pause()
        super.pause();
      }

    }

    tagClass[PRODUCT_VIDEO] = ProductVideo

    class ProductYouTube extends MediaBase {

      init() {
        this.youtube = this.querySelector('iframe')
      }

      play() {
        const message = {event: 'command', func: 'playVideo', args: ''}
        this.youtube.contentWindow.postMessage(JSON.stringify(message), '*');
        super.play();
      }

      pause() {
        const message = {event: 'command', func: 'pauseVideo', args: ''}
        this.youtube.contentWindow.postMessage(JSON.stringify(message), '*');
        super.pause();
      }

    }

    tagClass[PRODUCT_YOUTUBE] = ProductYouTube

    class ProductVimeo extends MediaBase {

      init() {
        this.vimeo = this.querySelector('iframe')
      }

      play() {
        this.vimeo.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        super.play();
      }

      pause() {
        this.vimeo.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        super.pause();
      }

    }

    tagClass[PRODUCT_VIMEO] = ProductVimeo

    class ProductModel extends MediaBase {

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.playHandler.name,
          this.pauseHandler.name,
          this.setupModelViewerUI.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this],
        });
      }

      init() {
        this.loadStyles()
        this.json = JSON.parse(this.querySelector(SCRIPT_JSON).textContent)
        this.viewer = this.querySelector('model-viewer')

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI,
          },
        ]);
      }

      connect() {
        this.viewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.playHandler)
        this.viewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.playHandler)
      }

      disconnect() {
        this.viewer.removeEventListener('shopify_model_viewer_ui_toggle_play', this.playHandler)
        this.viewer.removeEventListener('shopify_model_viewer_ui_toggle_pause', this.playHandler)
      }

      loadStyles() {
        const id = 'model-viewer-style'
        if (document.getElementById(id)) return;

        const link = createElement('link')

        link.id = 'model-viewer-style';
        link.rel = 'stylesheet';
        link.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
        link.media = 'print';
        link.onload = () => link.media = 'all';

        document.head.append(link);
      }

      setupModelViewerUI(errors) {
        if (errors) return;
        this.modelViewerUI = new Shopify.ModelViewerUI(this.viewer);
        this.modelViewerUI[this.playing ? 'play' : 'pause']();
        ModelXR.addModel(this.json)
      }

      play() {
        if (this.modelViewerUI) {
          this.modelViewerUI.play()
        }
        else {
          super.play();
        }
      }

      pause() {
        if (this.modelViewerUI) {
          this.modelViewerUI.pause()
        }
        else {
          super.pause();
        }
      }

      playHandler() {
        super.play();
      }

      pauseHandler() {
        super.pause();
      }

      clickHandler(event) {
        event.preventDefault();
      }

    }

    tagClass[PRODUCT_MODEL] = ProductModel

    class ProductImages extends ProductBase {
      frameId = 0
      control = {current: null, left: null, right: null}

      init() {
        const selector = `${PRODUCT_VIDEO},${PRODUCT_YOUTUBE},${PRODUCT_VIMEO},${PRODUCT_MODEL}`
        this.playable = new Map();
        this.media_map = {};
        this.querySelectorAll(`${DIV}[data-media]`)
          .forEach(media => {
            const media_id = media.dataset.media
            if (media.dataset.mediaType !== 'image') {
              this.playable.set(media, media.querySelector(selector));
            }
            media.media_id = parseInt(media_id);
            this.media_map[media_id] = media;
            if (media.style.getPropertyValue('--t-base') === '0%') {
              this.control.current = media
              if (this.playable.has(media)) {
                this.playable.get(media).play()
              }
            }
          })
        this.media_list = Object.values(this.media_map)

        const arrows = this.querySelectorAll(CONTROL_ARROW)
        this.arrow_prev = arrows[0]
        this.arrow_next = arrows[1]

        this.updateArrows()

        this.pointer = {id: null, capture: false, start: 0, end: 0}
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.pointerDown.name,
          this.pointerMove.name,
          this.pointerUp.name,
          this.gotPointerCapture.name,
          this.lostPointerCapture.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.prevHandler.name]: [this.arrow_prev],
          [this.nextHandler.name]: [this.arrow_next],
        });
      }

      connect() {
        this.addEventListener(POINTER_DOWN, this.pointerDown)
        this.addEventListener(POINTER_MOVE, this.pointerMove)
        this.addEventListener(POINTER_UP, this.pointerUp)
        this.addEventListener(POINTER_CANCEL, this.pointerUp)
        this.addEventListener(GOT_POINTER_CAPTURE, this.gotPointerCapture)
        this.addEventListener(LOST_POINTER_CAPTURE, this.lostPointerCapture)
      }

      disconnect() {
        cancelAnimationFrame(this.frameId);
        this.removeEventListener(LOST_POINTER_CAPTURE, this.lostPointerCapture)
        this.removeEventListener(GOT_POINTER_CAPTURE, this.gotPointerCapture)
        this.removeEventListener(POINTER_CANCEL, this.pointerUp)
        this.removeEventListener(POINTER_UP, this.pointerUp)
        this.removeEventListener(POINTER_MOVE, this.pointerMove)
        this.removeEventListener(POINTER_DOWN, this.pointerDown)
      }

      finishAnimations(control) {
        Object.values(control)
          .filter(item => item)
          .forEach(item => {
            item.getAnimations()
              .filter(animation => animation instanceof CSSTransition)
              .forEach(animation => animation.finish());
          })
      }

      setBaseValue(control) {
        if (control.current) {
          control.current.style.setProperty('--t-base', '0%')
        }
        if (control.left) {
          control.left.style.setProperty('--t-base', '-100%')
        }
        if (control.right) {
          control.right.style.setProperty('--t-base', '100%')
        }
      }

      setOffset(control, value) {
        cancelAnimationFrame(this.frameId);
        this.frameId = requestAnimationFrame(
          () => {
            Object.values(control).forEach((item) => {
              if (item) {
                item.style.setProperty('--t-offset', value)
              }
            })
          }
        );
      }

      transform(control, method) {
        Object.values(control).forEach((item) => {
          if (item) {
            item.classList[method]('transition-transform')
          }
        })
      }

      findCurrentMedia() {
        return this.media_list.find(media => media.style.getPropertyValue('--t-base') === '0%')
      }

      getCurrentMedia() {
        const current = ProductThumbs.getThumbMaster(this.product)?.getCurrentMedia()

        if (current) return current

        const
          media = this.findCurrentMedia(),
          index = this.media_list.indexOf(media),
          prev = this.media_list.slice(0, index).reverse(),
          next = this.media_list.slice(index + 1),
          prev_media = prev[0],
          next_media = next[0];
        return {
          media_id: media.media_id,
          prev_id: prev_media ? prev_media.media_id : null,
          next_id: next_media ? next_media.media_id : null,
        }
      }

      newControl({media_id, prev_id, next_id}) {
        return {
          current: this.media_map[media_id],
          left: this.media_map[prev_id],
          right: this.media_map[next_id],
        };
      }

      pointerDown(event) {
        this.pointer.capture = event.target.localName === IMG
        if (this.pointer.capture) {
          this.pointer.start = event.clientX
          this.pointer.end = event.clientX
          this.setPointerCapture(event.pointerId);
        }
      }

      gotPointerCapture(event) {
        if (this.pointer.capture) {
          this.pointer.id = event.pointerId
          this.control = this.newControl(this.getCurrentMedia())
          this.finishAnimations(this.control)
          this.setBaseValue(this.control)
          this.setOffset(this.control, '0px')
        }
      }

      calcValues(pointer) {
        const threshold = 60
        const thresholdRatio = 0.25

        const width = Math.round(this.getBoundingClientRect().width)
        const limit = Math.min(threshold, Math.round(width * thresholdRatio))

        const delta = Math.round(pointer.end - pointer.start);
        let distance = Math.max(-width, Math.min(delta, width))

        if (!this.control.left) {
          distance = Math.min(distance, limit);
        }
        if (!this.control.right) {
          distance = Math.max(distance, -limit);
        }

        const absolute = Math.abs(distance);
        const direction = distance === absolute ? PREV : NEXT

        return {width, limit, delta, distance, absolute, direction}
      }

      pointerMove(event) {
        if (this.pointer.id === event.pointerId) {
          this.pointer.end = event.clientX;
          const {distance} = this.calcValues(this.pointer)
          this.setOffset(this.control, distance + 'px')
        }
      }

      pointerUp(event) {
        this.releasePointerCapture(event.pointerId);
      }

      async lostPointerCapture(event) {
        if (this.pointer.id === event.pointerId) {
          this.pointer.id = null
          this.pointer.capture = false
          const {limit, delta, direction} = this.calcValues(this.pointer)

          if (limit < Math.abs(delta)) {
            await this.swapeDoing(direction)
          } else {
            await this.swapeDoing()
          }
        }
      }

      async swapeDoing(direction) {
        const control = this.control
        if (direction === PREV) {
          if (control.left) {
            this.control = {current: control.left, right: control.current}
          }
        }
        if (direction === NEXT) {
          if (control.right) {
            this.control = {left: control.current, current: control.right}
          }
        }

        this.transform(this.control, ADD)
        await nextFrame()
        this.setBaseValue(this.control)
        this.setOffset(this.control, '0px')

        this.sendMessage(PubSub.PRODUCT_THUMB_CLICKED, {media_id: this.control.current.media_id})

        await Promise.all(
          Object.values(control)
            .filter(item => item)
            .map(item => waitTransitionEnd(item, 'transform'))
        )

        this.transform(control, REMOVE)
      }

      async prevHandler() {
        this.control = this.newControl(this.getCurrentMedia())
        this.setBaseValue(this.control)
        await nextFrame()
        await this.swapeDoing(PREV)
      }

      async nextHandler() {
        this.control = this.newControl(this.getCurrentMedia())
        this.setBaseValue(this.control)
        await nextFrame()
        await this.swapeDoing(NEXT)
      }

      thumbChanged(media_id, prev_id, next_id) {
        const old_media = this.findCurrentMedia().media_id
        const new_media = media_id;
        if (old_media !== new_media) {
          const new_item = this.media_map[new_media]
          const old_item = this.media_map[old_media]
          void opacityScaleTransformation(
            new_item,
            old_item,
            () => {
              new_item.style.setProperty('--t-base', '0%')
              if (this.playable.has(new_item)) {
                this.playable.get(new_item).play()
              }
            },
            () => {
              old_item.style.setProperty('--t-base', '100%')
              if (this.playable.has(old_item)) {
                this.playable.get(old_item).pause()
              }
            }
          )
        }
        this.updateArrows()
      }

      thumbInitialized() {
        this.updateArrows()
      }

      updateArrows() {
        const media = this.getCurrentMedia()
        arrowVisibility(this.arrow_prev, media.prev_id)
        arrowVisibility(this.arrow_next, media.next_id)
      }

    }

    tagClass[PRODUCT_IMAGES] = ProductImages

    class ProductThumbs extends ProductBase {
      static ThumbMaster = {}
      frameId = 0

      init() {
        this.variant_hide = this.dataset.hide === TRUE
        this.container = this.firstElementChild
        this.direction = this.container.classList.contains('flex-col') ? VERTICAL : HORIZONTAL

        this.templates = this.collectStateTemplate([DEFAULT, SELECTED], DIV)

        const arrows = this.querySelectorAll(CONTROL_ARROW)
        this.arrow_prev = arrows[0]
        this.arrow_next = arrows[1]
        this.updateScrollState()

        this.thumbs = {}
        this.thumb_list = []
        this.variant_thumbs = []
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.scrollHandler.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.prevHandler.name]: [this.arrow_prev],
          [this.nextHandler.name]: [this.arrow_next],
        });
      }

      static getThumbMaster(product) {
        return ProductThumbs.ThumbMaster[product.id]?.[0] ?? null;
      }

      isThumbMaster() {
        return ProductThumbs.ThumbMaster[this.product.id]?.[0] === this
      }

      setThumbMaster() {
        const product_id = this.product.id
        const master = ProductThumbs.ThumbMaster
        if (product_id) {
          if (master[product_id] === undefined) {
            master[product_id] = []
          }
          if (this.variant_hide) {
            master[product_id].push(this);
          } else {
            master[product_id].unshift(this);
          }
        }
      }

      clearThumbMaster() {
        const product_id = this.product.id
        const master = ProductThumbs.ThumbMaster
        if (this.isThumbMaster()) {
          master[product_id] = master[product_id].filter(item => item !== this)
        }
      }

      addThumb(item) {
        const media_id = item.media_id;
        this.thumbs[media_id] = item
        this.thumb_list.push(item)
        if (item.variant_media) {
          this.variant_thumbs.push(item)
        }
        item.addEventListener(CLICK, () => this.clickThumb(media_id))
        if (this.isThumbMaster()) {
          this.sendMessage(PubSub.PRODUCT_THUMB_INITIALISED)
        }
      }

      selected() {
        return this.thumb_list.find(t => t.selected)
      }

      getTemplate(selected) {
        return this.templates[selected ? SELECTED : DEFAULT]
      }

      connect() {
        this.setThumbMaster();
        this.container.addEventListener(SCROLL, this.scrollHandler);
      }

      disconnect() {
        cancelAnimationFrame(this.frameId);
        this.container.removeEventListener(SCROLL, this.scrollHandler);
        this.clearThumbMaster();
      }

      async variantChanged() {
        const media_id = this.variant.media_id
        const new_thumb = this.thumbs[media_id]

        if (this.selected() === new_thumb) return

        if (this.variant_hide) {
          const old_thumb = this.variant_thumbs.find(thumb => !thumb.hidden)
          if (old_thumb) {
            old_thumb.hidden = true
          }
          new_thumb.hidden = false
        }
        if (this.isThumbMaster()) {
          await nextFrame()
          this.sendMessage(PubSub.PRODUCT_THUMB_CLICKED, {media_id})
        }
      }

      clickThumb(media_id) {
        this.sendMessage(PubSub.PRODUCT_THUMB_CLICKED, {media_id})
      }

      prepareMedia(thumb) {
        const
          index = this.thumb_list.indexOf(thumb),
          prev = this.thumb_list.slice(0, index).reverse(),
          next = this.thumb_list.slice(index + 1),
          prev_thumb = prev.find(thumb => !thumb.hidden),
          next_thumb = next.find(thumb => !thumb.hidden);
        return {
          media_id: thumb.media_id,
          prev_id: prev_thumb ? prev_thumb.media_id : null,
          next_id: next_thumb ? next_thumb.media_id : null,
        }
      }

      getCurrentMedia() {
        const thumb = this.selected()
        if (thumb) {
          return this.prepareMedia(thumb);
        }
      }

      sendThumbMessage(thumb, name) {
        if (this.isThumbMaster() && thumb) {
          this.sendMessage(name, this.prepareMedia(thumb))
        }
      }

      thumbClicked(media_id) {
        const
          old_thumb = this.selected(),
          new_thumb = this.thumbs[media_id];

        if (old_thumb === new_thumb) return;

        old_thumb.selected = false
        new_thumb.selected = true

        this.sendThumbMessage(new_thumb, PubSub.PRODUCT_THUMB_CHANGED)
      }

      updateScrollState() {
        const
          properties = {
            [HORIZONTAL]: ['scrollLeft', 'offsetWidth', 'scrollWidth'],
            [VERTICAL]: ['scrollTop', 'offsetHeight', 'scrollHeight'],
          }[this.direction],
          currentScroll = this.container[properties[0]],
          container = this.container[properties[1]],
          scroll = this.container[properties[2]];

        arrowVisibility(this.arrow_prev, currentScroll > 5)
        arrowVisibility(this.arrow_next, currentScroll + container < scroll - 5)
      }

      scrollHandler() {
        cancelAnimationFrame(this.frameId)
        this.frameId = requestAnimationFrame(() => this.updateScrollState())
      }

      horizontalScroll(direction) {
        const
          scrollAmount = this.container.offsetWidth * 0.8,
          rtl = getComputedStyle(this.container).direction === 'rtl';
        this.container.scrollBy({
          left: scrollAmount * direction * (rtl ? -1 : 1),
          behavior: 'smooth'
        });
        requestAnimationFrame(() => this.updateScrollState);
      }

      verticalScroll(direction) {
        const scrollAmount = this.container.offsetHeight * 0.8;
        this.container.scrollBy({
          top: scrollAmount * direction,
          behavior: 'smooth'
        });
        requestAnimationFrame(() => this.updateScrollState);
      }

      prevHandler() {
        this[`${this.direction}Scroll`](-1)
      }

      nextHandler() {
        this[`${this.direction}Scroll`](1)
      }

    }

    tagClass[PRODUCT_THUMBS] = ProductThumbs

    class ProductThumb extends Base {

      get selected() {
        return this.button.ariaCurrent === TRUE
      }

      set selected(value) {
        if (this.selected !== value) {
          this.button.ariaCurrent = value ? TRUE : undefined
          this.applyTemplate()
          if (value) {
            scrollIntoViewNearest(this.button, this.list.container)
          }
        }
      }

      get hidden() {
        return this.button.classList.contains(HIDDEN)
      }

      set hidden(hidden) {
        this.button.classList[hidden ? ADD : REMOVE](HIDDEN)
        this.applyTemplate()
      }

      init() {
        this.media_id = parseInt(this.dataset.media)
        this.variant_media = this.dataset.variantMedia === TRUE;
        this.button = this.firstElementChild

        this.list = this.closest(PRODUCT_THUMBS)
        this.list.addThumb(this)
        this.applyTemplate()
        if (this.selected) {
          scrollIntoViewNearest(this.button, this.list.container)
          requestAnimationFrame(() => {this.list.container.classList.add('scroll-smooth')})
        }
      }

      applyTemplate() {
        if (!this.hidden) {
          applyTemplate(this.button, this.list.getTemplate(this.selected))
        }
      }

    }

    tagClass[PRODUCT_THUMB] = ProductThumb

    class ProductQuantityBase extends ProductBase {

      init() {
        this.quantity = this.variant.rule.min
      }

      correctQuantity(qnt) {
        const variant = this.variant
        qnt -= (qnt - variant.rule.min) % variant.rule.inc
        qnt = (variant.policy !== 'deny' || qnt <= variant.rule.max) ? qnt : variant.rule.max
        return qnt >= variant.rule.min ? qnt : variant.rule.min
      }

      async variantChanged() {
        this.quantity = this.correctQuantity(this.quantity)
      }

      quantityChanged(quantity) {
        this.quantity = quantity
      }

    }

    class ProductQuantity extends ProductQuantityBase {

      init() {
        super.init()
        this.container = this.firstElementChild
        this.initType()
      }

      initType() {
        const type = this.dataset.type
        this[`${type}Init`]()
      }

      clickBinder(click_bind) {
        const type = this.dataset.type
        super.clickBinder({
          ...click_bind,
          ...(type === 'qnt' ? {} : {[`${type}Handler`]: [this.container]})
        });
      }

      canIncrease() {
        const
          variant = this.variant,
          next = variant.in_cart + this.quantity + variant.rule.inc,
          rule_ok = variant.rule.max == null || next <= variant.rule.max,
          inventory_ok =
            variant.inventory.management !== 'shopify' ||
            variant.inventory.policy !== 'deny' ||
            next <= variant.inventory.quantity

        return rule_ok && inventory_ok
      }

      incInit() {
        this.container.ariaLabel = 'Increase quantity'
        this.container.disabled = !this.canIncrease()
      }

      incHandler() {
        if (this.canIncrease()) {
          this.sendQuantity(this.correctQuantity(this.quantity + this.variant.rule.inc))
        }
      }

      canDecrease() {
        const
          variant = this.variant,
          next = this.quantity - variant.rule.inc

        return next >= variant.rule.min
      }

      decInit() {
        this.container.ariaLabel = 'Decrease quantity'
        this.container.disabled = !this.canDecrease()
      }

      decHandler(event) {
        if (this.canDecrease()) {
          this.sendQuantity(this.correctQuantity(this.quantity - this.variant.rule.inc))
        }
      }

      sendQuantity(quantity) {
        if (this.quantity !== quantity) {
          this.sendMessage(PubSub.PRODUCT_QUANTITY_CHANGED, {quantity})
        }
      }

      qntInit() {
        this.querySelector(SPN_CONTENT).textContent = this.quantity.toString()
      }

      quantityChanged(quantity) {
        super.quantityChanged(quantity)
        this.initType()
      }

      async variantChanged() {
        await super.variantChanged()
        this.initType()
      }

    }

    tagClass[PRODUCT_QUANTITY] = ProductQuantity

    class ProductButtonShopify extends ProductQuantityBase {

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.PRODUCT_GIFT_CARD_FORM]: this.giftCardSubscribe.name,
        });
      }

      init() {
        super.init()
        this.form = this.querySelector(FORM)
        this.input_variant = this.form.querySelector('input[name="id"]');
        this.input_quantity = this.form.querySelector('input[name="quantity"]');
        this.input_offset = this.form.querySelector(`input[name="properties[${SHOPIFY_OFFSET}]"]`);
        this.input_offset.value = new Date().getTimezoneOffset()
      }

      connect() {
        this.setButtonState()
      }

      isDisabled() {
        const
          variant = this.variant,
          check_inventory = variant.management === 'shopify' && variant.policy === 'deny',
          sold_out = check_inventory && variant.rule.min > variant.inventory
        return !variant.available || sold_out
      }

      setButtonState() {
        const disabled = this.isDisabled()
        this[disabled ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true')
        this.classList[disabled ? ADD : REMOVE]('pointer-events-none')
      }

      async variantChanged() {
        await super.variantChanged()
        this.input_variant.value = this.variant.id.toString()
        this.input_quantity.value = this.quantity.toString()
        this.setButtonState()
      }

      quantityChanged(quantity) {
        super.quantityChanged(quantity)
        this.input_quantity.value = this.quantity
      }

      giftCardSubscribe(data) {
        if (data.product.id === this.product.id) {
          const
            form = data.form,
            keys = [
              'Recipient email',
              'Recipient name',
              'Message',
              'Send on',
              SHOPIFY_SEND_GIFT_CARD_TO_RECIPIENT
            ];
          this.input_offset.disabled = !form;
          if (form) {
            keys.forEach(key => {
              const property = `properties[${key}]`
              let input = this.form.querySelector(`input[name="${property}"]`);
              if (!input) {
                input = createElement('input', this.form)
                input.type = 'hidden'
                input.name = property
              }
              input.value = key === SHOPIFY_SEND_GIFT_CARD_TO_RECIPIENT ? true : form[key];
            })
          }
          else {
            keys.forEach(key => {
              const input = this.form.querySelector(`input[name="properties[${key}]"]`);
              if (input) {
                input.remove()
              }
            })
          }
        }
      }

    }

    tagClass[PRODUCT_BUTTON_SHOPIFY] = ProductButtonShopify

    class ProductButtonAddToCart extends ProductButtonShopify {

      init() {
        super.init()

        const ds = this.dataset
        this.text = {
          'add_to_cart': t_custom(E, ds.addToCart),
          'sold_out': t_custom(E, ds.soldOut),
        }

        this.button = this.form.querySelector(BTN);
        this.button_spinner = this.button.querySelector(SVG);
        this.button_label = this.button.querySelector(SPN);

        this.button.disabled = !this.variant.available
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.submitHandler.name,
        ]);
      }

      connect() {
        super.connect()
        this.form.addEventListener(SUBMIT, this.submitHandler);
      }

      disconnect() {
        this.form.removeEventListener(SUBMIT, this.submitHandler);
        super.disconnect();
      }

      setButtonState() {
        super.setButtonState()
        const disabled = this.isDisabled()
        this.classList.remove('pointer-events-none')
        this.classList[disabled ? ADD : REMOVE]('cursor-not-allowed')
        this.button.disabled = disabled
        this.button_label.textContent = this.text[disabled ? 'sold_out' : 'add_to_cart']
      }

      async variantChanged() {
        await super.variantChanged()
        this.button.disabled = !this.variant.available
      }

      async submitHandler(event) {
        event.preventDefault()
        this.sendMessage(PubSub.PRODUCT_CLEAR_ERROR)

        const form_data = new FormData(this.form)

        const config = {
          method: 'POST',
          body: form_data,
        }

        try {
          this.button_spinner.classList.remove(HIDDEN);
          this.button.disabled = true;

          const
            add_response = await fetch(`${ROUTES.cart_add_url}.js`, config),
            add_data = await add_response.json();

          if (!add_response.ok) {
            const message = add_data.description || add_data.message || 'Failed to add to cart';
            throw new Error(message);
          }

          const cart_response = await fetch(`${ROUTES.cart_url}.js`)
          const cart_data = await cart_response.json();

          if (!cart_response.ok) {
            location.reload();
            return
          }

          cart_data.items_added = (add_data.items ?? [add_data]).map(item => ({view_key: item.key}))

          await pub_sub.publish(PubSub.CART_CHANGED, await preprocessCart(cart_data))
        } catch (error) {
          this.sendMessage(PubSub.PRODUCT_ERROR, {source: 'Add to Cart', error})
          setTimeout(
            () => {
              this.sendMessage(PubSub.PRODUCT_CLEAR_ERROR)
            },
            60_000
          )
        } finally {
          this.button_spinner.classList.add(HIDDEN);
          this.setButtonState()
        }

      }

    }

    tagClass[PRODUCT_BUTTON_ADD_TO_CART] = ProductButtonAddToCart

    class ProductError extends ProductBase {

      init() {
        this.span = this.querySelector(SPN);
        this.button = this.querySelector(BTN)
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.button]
        });
      }

      error(source, error) {
        this.span.textContent = error.message;
        this.classList.remove(HIDDEN)
      }

      clearError() {
        this.span.textContent = '';
        this.classList.add(HIDDEN)
      }

      clickHandler() {
        this.clearError()
      }

    }

    tagClass[PRODUCT_ERROR] = ProductError

    class ProductRecommendations extends Base {
      #observer;
      #loaded = false;

      init() {
        this.limit = this.dataset.limit
        this.intent = this.dataset.intent
        this.product_id = this.dataset.productId
        this.template = this.collectStateTemplate([E])[E]
      }

      connect() {
        this.observe()
      }

      disconnect() {
        this.#observer?.disconnect();
      }

      observe() {
        if (this.#loaded) return;

        this.#observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;

            observer.disconnect();
            void this.loadRecommendations();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        this.#observer.observe(this);
      }

      async loadRecommendations() {
        try {
          const url = new URL(ROUTES.product_recommendations_url, location.origin)
          url.searchParams.set('limit', this.limit);
          url.searchParams.set('intent', this.intent);
          url.searchParams.set('product_id', this.product_id);
          url.searchParams.set('section_id', 'json-recommendations');

          const response = await fetch(url)

          if (!response.ok) {
            throw new Error(`Failed to load recommendations: ${response.status}`);
          }

          const
            text = await response.text(),
            json = createHtml(text).querySelector(SCRIPT_JSON);

          if (!json) {
            throw new Error('Recommendations JSON not found');
          }

          const data = JSON.parse(json.textContent);

          for (const item of data) {
            const
              element = this.template.cloneNode(true),
              script = element.querySelector(SCRIPT);

            script.textContent = JSON.stringify(item)
            this.append(element)
          }

          this.#loaded = true;
        } catch (error) {
          console.error(error);
        }
      }
    }

    tagClass[PRODUCT_RECOMMENDATIONS] = ProductRecommendations

    class ProductGiftCard extends ProductBase {

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.submitHandler.name,
          this.changeHandler.name,
        ]);
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.PRODUCT_GIFT_CARD_FORM]: this.giftCardSubscribe.name,
        });
      }

      init() {
        this.keys = ['Recipient email', 'Recipient name', 'Message', 'Send on'];
        this.properties = {}
        this.form = this.querySelector(FORM)
        if (this.form) {
          this.body = this.form.querySelector(DIV).nextElementSibling
          this.switch = this.form.querySelector(SWITCH_CONTROL);
            this.keys.forEach(key => {
              this.properties[key] = this.form.querySelector(`[name="properties[${key}]"]`)
            })
        }
      }

      connect() {
        if (this.form) {
          this.form.addEventListener(SUBMIT, this.submitHandler);
          this.keys.forEach(key => {
            this.properties[key].addEventListener(CHANGE, this.changeHandler);
          })
        }
      }

      disconnect() {
        if (this.form) {
          this.form.removeEventListener(SUBMIT, this.submitHandler);
          this.keys.forEach(key => {
            this.properties[key].removeEventListener(CHANGE, this.changeHandler);
          })
        }
      }

      prepareData() {
        return this.keys.reduce((p, c) => ({...p, [c]: this.properties[c].value}), {})
      }

      expand(expanded) {
        this.switch.querySelector(INPUT).ariaExpanded = expanded
        this.style.setProperty('--grid-rows', expanded ? '1fr' : '0fr')
        this.body[expanded ? 'removeAttribute' : 'setAttribute'](INERT, E)
      }

      updateForm() {
        const
          expanded = this.switch.getState(),
          form = expanded ? this.prepareData() : null;
        this.expand(expanded);
        this.sendMessage(PubSub.PRODUCT_GIFT_CARD_FORM, {form})
      }

      stateChanged() {
        this.updateForm();
      }

      submitHandler(event) {
        event.preventDefault()
      }

      changeHandler() {
        this.updateForm()
      }

      giftCardSubscribe(data) {
        if (data.sender !== this && data.product.id === this.product.id) {
          if (this.form) {
            const form = data.form
            this.expand(!!form)
            if (form) {
              this.switch.setState(true)
              Object.entries(form)
                .forEach(([key, value]) => {
                  this.properties[key].value = value
                })
            }
            else {
              this.switch.setState(false)
            }
          }
        }
      }

    }

    tagClass[PRODUCT_GIFT_CARD] = ProductGiftCard

    class TabsContainer extends Base {

      init() {
        this.container = this.firstElementChild.firstElementChild
        this.tabs = []
        this.state = [DEFAULT, SELECTED]
        this.templates = this.addCursor(this.collectStateTemplate(this.state, DIV))
      }

      addCursor(templates) {
        Object.values(templates).forEach((item) => {item.classList.add('cursor-default')})
        return templates
      }

      addTab(item) {
        const index = this.tabs.length
        item.index = index
        item.selected = index === 0
        this.tabs.push(item)
        this.container.append(item.tabElement)
      }

      select(item) {
        this.tabs.forEach(tab => {
          tab.selected = tab === item
        })
      }

      keydown(item, event) {
        let index

        switch (event.key) {
          case 'ArrowRight':
            index = item.index + 1
            break
          case 'ArrowLeft':
            index = item.index - 1
            break
          case 'Home':
            index = 0
            break
          case 'End':
            index = this.tabs.length - 1
            break
          default:
            return
        }

        event.preventDefault()
        index = (index + this.tabs.length) % this.tabs.length
        const tab = this.tabs[index]
        this.select(tab)
        tab.tabElement.focus()
      }
    }

    tagClass[TABS_CONTAINER] = TabsContainer

    class TabContent extends Base {

      get selected() {
        return this.tabElement.ariaSelected === TRUE
      }

      set selected(selected) {
        if (this.selected !== selected) {
          this.tabElement.ariaSelected = selected ? TRUE : FALSE
          this.tabElement.tabIndex = selected ? 0 : -1
          this.classList.toggle(HIDDEN, !selected)
          applyTemplate(this.tabElement, this.templates[selected ? SELECTED : DEFAULT])
        }
      }

      init() {
        this.index = 0
        this.header = this.dataset.header
        this.owner = this.parentElement.parentElement.querySelector(TABS_CONTAINER)
        if (this.owner) {
          this.templates = this.collectStateTemplate([DEFAULT, SELECTED], this.defaultTemplate)
          this.owner.addCursor(this.templates)
          this.createTab()
          this.owner.addTab(this)
        }
      }

      defaultTemplate(state) {
        return this.owner.templates[state]
      }

      createTab() {
        const
          id = generateID(),
          tab = this.templates[DEFAULT].cloneNode(true)

        this.id = `panel-${id}`
        tab.id = `tab-${id}`

        this.setAttribute('role', 'tabpanel')
        tab.setAttribute('role', 'tab')

        this.setAttribute('aria-labelledby', tab.id)
        tab.setAttribute('aria-controls', this.id)

        tab.ariaSelected = FALSE
        tab.tabIndex = -1
        this.classList.add(HIDDEN)

        if (DESIGN_MODE) {
          tab.dataset.shopifyEditorBlock = this.dataset.shopifyEditorBlock
        }

        tab.textContent = this.header
        this.tabElement = tab
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.keydownHandler.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.tabElement]
        });
      }

      clickHandler() {
        this.owner.select(this)
      }

      connect() {
        this.tabElement.addEventListener('keydown', this.keydownHandler)
      }

      disconnect() {
        this.tabElement.removeEventListener('keydown', this.keydownHandler)
      }

      keydownHandler(event) {
        this.owner.keydown(this, event)
      }

    }

    tagClass[TAB_CONTENT] = TabContent

    class AccordionItem extends Base {
      #first_time = true

      get expanded() {
        return this.button.ariaExpanded === TRUE
      }

      set expanded(value) {
        if (this.expanded !== value || this.#first_time) {
          this.#first_time = false
          this.button.ariaExpanded = value ? TRUE : FALSE
          local_state.set(this.key, value)
          this.style.setProperty('--rotate', value ? '90deg' : '0deg')
          this.style.setProperty('--grid-rows', value ? '1fr' : '0fr')
          this.body[value ? 'removeAttribute' : 'setAttribute'](INERT, E)
        }
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.label]
        });
      }

      init() {
        this.key = `AccordionItem.${location.pathname}.${this.dataset.key}`
        this.label = this.firstElementChild
        this.button = this.label.firstElementChild
        this.body = this.label.nextElementSibling

        const sub_id = generateID();
        this.body.id = sub_id
        this.button.setAttribute('aria-controls', sub_id)

        const next = this.parentElement.nextElementSibling
        if (next) {
          const child = next.firstElementChild
          if (child.localName !== ACCORDION_ITEM) {
            this.body.firstElementChild.appendChild(next)
          }
        }

        this.expanded = local_state.get(this.key, this.expanded)
        requestAnimationFrame(() => this.body.classList.add('duration-300', TRANSITION_ALL))
      }

      clickHandler() {
        this.expanded = !this.expanded;
      }

    }

    tagClass[ACCORDION_ITEM] = AccordionItem

    class VariantTitle extends ProductBase {

      constructor() {
        super();
        this.spans = this.querySelectorAll(SPN);
      }

      rootChanged() {
        this.spans[0].textContent = this.root.option_titles[this.index] + ':'
        this.spans[1].textContent = this.variant.options[this.index]
      }

      async variantChanged() {
        this.spans[1].textContent = this.variant.options[this.index]
      }

    }

    tagClass[VARIANT_TITLE] = VariantTitle

    class CheckBoxControl extends Base {

      init() {
        super.init()
        this.input = this.querySelector(INPUT)
        changeInputID(this)
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.changeHandler.name,
        ]);
      }

      connect() {
        this.addEventListener(CHANGE, this.changeHandler);
      }

      disconnect() {
        this.removeEventListener(CHANGE, this.changeHandler);
      }

      changeHandler() {
        this.stateChanged(this, this.getState());
      }

      getState() {
        return this.input.checked
      }

      setState(state) {
        this.input.checked = !!state;
      }

    }

    class SwitchControl extends CheckBoxControl {}

    tagClass[SWITCH_CONTROL] = SwitchControl

    class CheckboxSwatch extends CheckBoxControl {}

    tagClass[CHECKBOX_SWATCH] = CheckboxSwatch

    class CheckboxControl extends CheckboxSwatch {}

    tagClass[CHECKBOX_CONTROL] = CheckboxControl

    class CheckboxField extends Base {

      init() {
        this.control = this.querySelector(CHECKBOX_CONTROL);
      }

      getState() {
        return this.control.getState()
      }

      stateChanged(element, value) {
        super.stateChanged(this, value);
      }

    }
    tagClass[CHECKBOX_FIELD] = CheckboxField

    class RangeBase extends Base {
      #value_min; #value_max;

      get value_min() {
        return this.#value_min
      }

      set value_min(value) {
        const check = this.#value_min !== value
        this.#value_min = value
        if (check) {
          this.stateChanged(this, this.value_min, this.value_max)
        }
      }

      get value_max() {
        return this.#value_max
      }

      set value_max(value) {
        const check = this.#value_max !== value
        this.#value_max = value
        if (check) {
          this.stateChanged(this, this.value_min, this.value_max)
        }
      }

      setMinValue(value) {
        this.#value_min = value
      }
      
      setMaxValue(value) {
        this.#value_max = value
      }

    }
    
    class RangeInput extends RangeBase {

      setMinValue(value) {
        super.setMinValue(value)
        this.input_min.value = value !== null ? value.toString() : ''
        this.input_max.min = value !== null ? value.toString() : this.range_min.toString()
      }

      setMaxValue(value) {
        super.setMaxValue(value)
        this.input_max.value = value !== null ? value.toString() : ''
        this.input_min.max = value !== null ? value.toString() : this.range_max.toString()
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.minHandler.name,
          this.maxHandler.name,
        ]);
      }

      connect() {
        this.input_min.addEventListener(CHANGE, this.minHandler)
        this.input_max.addEventListener(CHANGE, this.maxHandler)
      }

      disconnect() {
        this.input_min.removeEventListener(CHANGE, this.minHandler)
        this.input_max.removeEventListener(CHANGE, this.maxHandler)
      }

      init() {
        const input = this.querySelectorAll(INPUT)
        this.input_min = input[0]
        this.input_max = input[1]
        this.range_min = parseInt(this.input_min.min)
        this.range_max = parseInt(this.input_max.max)
        this.setMinValue(this.getInt(this.input_min, null))
        this.setMaxValue(this.getInt(this.input_max, null))
        changeInputID(this.input_min.parentElement)
        changeInputID(this.input_max.parentElement)
      }

      getInt(input, def_value) {
        const source = input.value.trim()
        if (source) {
          const value = input.validity.valid ? parseInt(source) : def_value
          return isNaN(value) ? def_value : value
        }
        return null
      }

      minHandler() {
        const value = this.getInt(this.input_min, this.value_min)
        this.value_min = value !== this.range_min ? value : null
      }

      maxHandler() {
        const value = this.getInt(this.input_max, this.value_max)
        this.value_max = value !== this.range_max ? value : null
      }

    }

    tagClass[RANGE_INPUT] = RangeInput

    class RangeSlider extends RangeBase {

      setMinValue(value) {
        super.setMinValue(value);

        const display_value = value ?? this.range_min

        this.info_min.textContent = display_value.toString()
        this.style.setProperty('--min-pos', `${(display_value - this.range_min) / this.range * 100}%`)

        this.syncAria()
      }

      setMaxValue(value) {
        super.setMaxValue(value);

        const display_value = value ?? this.range_max

        this.info_max.textContent = display_value.toString()
        this.style.setProperty('--max-pos', `${(display_value - this.range_min) / this.range * 100}%`)

        this.syncAria()
      }

      syncAria() {
        if (!this.slider_min || !this.slider_max) return

        const
          value_min = this.value_min ?? this.range_min,
          value_max = this.value_max ?? this.range_max

        this.slider_min.setAttribute('aria-valuemin', this.range_min.toString())
        this.slider_min.setAttribute('aria-valuemax', value_max.toString())
        this.slider_min.setAttribute('aria-valuenow', value_min.toString())

        this.slider_max.setAttribute('aria-valuemin', value_min.toString())
        this.slider_max.setAttribute('aria-valuemax', this.range_max.toString())
        this.slider_max.setAttribute('aria-valuenow', value_max.toString())
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.minPointerDown.name,
          this.minPointerMove.name,
          this.minPointerUp.name,
          this.maxPointerDown.name,
          this.maxPointerMove.name,
          this.maxPointerUp.name,
          this.gotPointerCapture.name,
          this.lostPointerCapture.name,
          this.keyHandler.name,
        ]);
      }

      POINTER_EVENTS = [POINTER_DOWN, POINTER_MOVE, POINTER_UP]

      minPointers() {
        return [this.minPointerDown, this.minPointerMove, this.minPointerUp]
      }
      maxPointers() {
        return [this.maxPointerDown, this.maxPointerMove, this.maxPointerUp]
      }

      connect() {
        this.POINTER_EVENTS
          .forEach((event, index) => {
            this.slider_min.addEventListener(event, this.minPointers()[index])
            this.slider_max.addEventListener(event, this.maxPointers()[index])
          })
        this.addEventListener(GOT_POINTER_CAPTURE, this.gotPointerCapture)
        this.addEventListener(LOST_POINTER_CAPTURE, this.lostPointerCapture)
        this.slider_min.addEventListener(KEY_DOWN, this.keyHandler)
        this.slider_max.addEventListener(KEY_DOWN, this.keyHandler)
      }

      disconnect() {
        this.slider_min.removeEventListener(KEY_DOWN, this.keyHandler)
        this.slider_max.removeEventListener(KEY_DOWN, this.keyHandler)
        this.removeEventListener(GOT_POINTER_CAPTURE, this.gotPointerCapture)
        this.removeEventListener(LOST_POINTER_CAPTURE, this.lostPointerCapture)
        this.POINTER_EVENTS
          .forEach((event, index) => {
            this.slider_min.removeEventListener(event, this.minPointers()[index])
            this.slider_max.removeEventListener(event, this.maxPointers()[index])
          })
      }

      init() {
        this.size = parseInt(this.style.getPropertyValue('--size'))
        const
          root = this.firstElementChild,
          slider = root.firstElementChild,
          info = slider.nextElementSibling,
          ds = this.dataset
        this.slider_body = slider.firstElementChild
        this.slider_min = this.slider_body.children[1]
        this.slider_max = this.slider_body.children[2]
        this.info_min = info.children[0]
        this.info_max = info.children[1]
        this.range_min = parseInt(ds.rangeMin)
        this.range_max = parseInt(ds.rangeMax)
        this.range = this.range_max - this.range_min
        this.setMinValue(this.getInt(ds.min, this.range_min))
        this.setMaxValue(this.getInt(ds.max, this.range_max))
        this.pointer = {id: null, slider: null, pos: 0}
      }

      getInt(source, def_value) {
        if (source) {
          const value = parseInt(source)
          return isNaN(value) ? def_value : value
        }
        return null
      }

      calcValues() {
        const
          pointer = this.pointer,
          parent_rect = this.slider_body.getBoundingClientRect(),
          pos = pointer.pos - parent_rect.left,
          width = parent_rect.width,
          percent = pos / width,
          value = Math.round(this.range * percent) + this.range_min,

          slider = pointer.slider,
          min_limit = slider === this.slider_min ? this.range_min : (this.value_min ?? this.range_min),
          max_limit = slider === this.slider_max ? this.range_max : (this.value_max ?? this.range_max),

          new_value = Math.max(min_limit, Math.min(value, max_limit)),
          new_percent = (new_value - this.range_min) / this.range;

        return {value: new_value, percent: new_percent}
      }

      gotPointerCapture(event) {
        this.pointer.id = event.pointerId
      }

      lostPointerCapture(event) {
        if (this.pointer.id === event.pointerId) {
          this.pointer.id = null
          const {value} = this.calcValues()

          if (this.pointer.slider === this.slider_min) {
            this.value_min = value !== this.range_min ? value : null
          }
          if (this.pointer.slider === this.slider_max) {
            this.value_max = value !== this.range_max ? value : null
          }
        }
      }

      changePosition(event, property, info) {
        this.pointer.pos = event.clientX
        const { percent, value } = this.calcValues()
        this.style.setProperty(property, `${percent * 100}%`)
        info.textContent = value.toString();
      }

      minPointerDown(event) {
        this.slider_min.classList.add('z-1')
        this.slider_max.classList.remove('z-1')

        this.pointer.slider = this.slider_min
        this.changePosition(event, '--min-pos', this.info_min)
        this.slider_min.setPointerCapture(event.pointerId);
      }
      
      minPointerMove(event) {
        if (this.pointer.slider === this.slider_min && this.pointer.id === event.pointerId) {
          this.changePosition(event, '--min-pos', this.info_min)
        }
      }
      
      minPointerUp(event) {
        if (this.pointer.slider === this.slider_min) {
          this.slider_min.releasePointerCapture(event.pointerId);
        }
      }
      
      maxPointerDown(event) {
        this.slider_max.classList.add('z-1')
        this.slider_min.classList.remove('z-1')

        this.pointer.slider = this.slider_max
        this.changePosition(event, '--max-pos', this.info_max)
        this.slider_max.setPointerCapture(event.pointerId);
      }
      
      maxPointerMove(event) {
        if (this.pointer.slider === this.slider_max && this.pointer.id === event.pointerId) {
          this.changePosition(event, '--max-pos', this.info_max)
        }
      }
      
      maxPointerUp(event) {
        if (this.pointer.slider === this.slider_max) {
          this.slider_max.releasePointerCapture(event.pointerId);
        }
      }

      keyHandler(event) {
        const
          slider = event.currentTarget,
          value_min = this.value_min ?? this.range_min,
          value_max = this.value_max ?? this.range_max,
          current_value = slider === this.slider_min ? value_min : value_max,
          min_limit = slider === this.slider_min ? this.range_min : value_min,
          max_limit = slider === this.slider_max ? this.range_max : value_max

        let new_value

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowUp':
            new_value = current_value + 1
            break

          case 'ArrowLeft':
          case 'ArrowDown':
            new_value = current_value - 1
            break

          case 'Home':
            new_value = min_limit
            break

          case 'End':
            new_value = max_limit
            break

          default:
            return
        }

        event.preventDefault()

        new_value = Math.max(min_limit, Math.min(new_value, max_limit))

        if (slider === this.slider_min) {
          this.slider_min.classList.add('z-1')
          this.slider_max.classList.remove('z-1')

          this.value_min = new_value === this.range_min ? null : new_value
        }
        else {
          this.slider_max.classList.add('z-1')
          this.slider_min.classList.remove('z-1')

          this.value_max = new_value === this.range_max ? null : new_value
        }
      }

    }

    tagClass[RANGE_SLIDER] = RangeSlider

    class ControlArrow extends Base {

    }
    tagClass[CONTROL_ARROW] = ControlArrow

    class CarouselList extends Base {

      init() {
        this.focused = false
        this.pause = {
          auto: parseInt(this.dataset.auto) ?? 5,
          manual: parseInt(this.dataset.manual) ?? 10,
        }
        this.timer = this.pause.auto

        this.count = 0
        this.items = []
        this.buttons = null
        this.current_index = null

        const arrows = this.querySelectorAll(CONTROL_ARROW)
        this.arrow_prev = arrows[0]
        this.arrow_next = arrows[1]
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.focusinHandler.name,
          this.focusoutHandler.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.prevHandle.name]: [this.arrow_prev],
          [this.nextHandle.name]: [this.arrow_next],
        });
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.TICKER]: this.tickerHandler.name,
        });
      }

      connect() {
        this.addEventListener('focusin', this.focusinHandler)
        this.addEventListener('focusout', this.focusoutHandler)
      }

      disconnect() {
        this.removeEventListener('focusout', this.focusoutHandler)
        this.removeEventListener('focusin', this.focusinHandler)
      }

      tickerHandler() {
        if (!this.focused && !this.matches(':hover') && this.current_index !== null) {
          this.timer -= 1
        }
        if (this.timer <= 0) {
          this.changeSlideHandler(this.current_index + 1)
          this.timer = this.pause.auto
        }
      }

      manual_pause() {
        this.timer = this.pause.manual
      }

      changeSlideHandler(index) {
        this.current_index = (index + this.count) % this.count

        this.items.forEach((item, i) => {
          if (this.current_index === i && item.ariaHidden === FALSE) {
            item.ariaHidden = TRUE
            item.style.setProperty('--opacity', '100%')
          }
          if (this.current_index !== i && item.ariaHidden === TRUE) {
            item.ariaHidden = FALSE
            item.style.setProperty('--opacity', '0%')
          }
        })

        this.buttons?.setActive(this.items[this.current_index])
      }

      addItem(item) {
        item.classList.remove(INVISIBLE)
        item.classList.add('opacity-(--opacity)')
        item.style.setProperty('--opacity', '0%')
        requestAnimationFrame(() => {
          item.classList.add(TRANSITION_ALL, `${DURATION}-700`)
        })

        item.ariaHidden = FALSE
        this.items.push(item)
        this.count = this.items.length
        this.buttons?.createButton(item, this.count - 1)
        if (this.current_index === null) {
          this.changeSlideHandler(this.items.indexOf(item))
        }
      }

      removeItem(item) {
        const index = this.items.indexOf(item)

        this.items = this.items.slice(index, 1)
        this.count = this.items.length
        this.buttons?.deleteButton(index)

        if (this.current_index === index) {
          this.current_index = null
        }

        if (this.count && this.current_index !== null) {
          this.changeSlideHandler(0)
        }
      }

      setButtons(buttons) {
        this.buttons = buttons
        this.items.forEach((item, index) => {
          this.buttons.createButton(item, index)
        })
        this.buttons.setActive(this.items[this.current_index])
      }

      clearButtons() {
        this.items.forEach(() => {
          this.buttons.deleteButton(0)
        })
        this.buttons = null
      }

      prevHandle(event) {
        event.preventDefault()
        if (this.current_index !== null) {
          this.changeSlideHandler(this.current_index - 1)
          this.manual_pause()
        }
      }

      nextHandle(event) {
        event.preventDefault()
        if (this.current_index !== null) {
          this.changeSlideHandler(this.current_index + 1)
          this.manual_pause()
        }
      }

      buttonHandle(event, index) {
        event.preventDefault()
        this.changeSlideHandler(index)
        this.manual_pause()
      }

      focusinHandler() {
        this.focused = true
      }

      focusoutHandler() {
        this.focused = false
      }

    }

    tagClass[CAROUSEL_LIST] = CarouselList

    class CarouselItem extends Base {

      init() {
        this.list = this.closest(CAROUSEL_LIST)
        this.templates = this.collectStateTemplate([DEFAULT, ACTIVE])
      }

      connect() {
        this.list.addItem(this)
      }

      disconnect() {
        this.list.removeItem(this)
      }

    }

    tagClass[CAROUSEL_ITEM] = CarouselItem

    class CarouselButtons extends Base {

      init() {
        this.list = this.closest(CAROUSEL_LIST)
        this.templates = this.collectStateTemplate([DEFAULT, ACTIVE])

        this.handlers = new WeakMap()
        this.buttons = new Map()
      }

      connect() {
        this.list.setButtons(this)
      }

      disconnect() {
        this.list.clearButtons()
      }

      getTemplate(item, state) {
        return item.templates[state] ?? this.templates[state]
      }

      createButton(item, index) {
        const
          template = this.getTemplate(item, DEFAULT),
          button = searchAndApplyTraits(template.cloneNode(true)),
          handler = (event) => this.list.buttonHandle(event, index);

        button.ariaLabel = `Go to slide ${index + 1}`
        button.ariaCurrent = FALSE
        this.handlers.set(button, handler)
        button.addEventListener(CLICK, handler)

        this.appendChild(button)
        this.buttons.set(button, item)
      }

      deleteButton(index) {
        const buttons = this.buttons[index]
        Object.values(buttons)
          .forEach((button) => {
            button.removeEventListener(CLICK, this.handlers.get(button))
            button.remove()
          })
        this.buttons.splice(index, 1)
      }

      setActive(item) {
        this.buttons.forEach((i, button) => {
          if (item !== i && button.ariaCurrent === TRUE) {
            button.ariaCurrent = FALSE
            applyTemplate(button, this.getTemplate(item, DEFAULT))
          }
          else
          if (item === i && button.ariaCurrent === FALSE) {
            button.ariaCurrent = TRUE
            applyTemplate(button, this.getTemplate(item, ACTIVE))
          }
        })
      }

    }

    tagClass[CAROUSEL_BUTTONS] = CarouselButtons

    class BackToTop extends HTMLElement {

      constructor() {
        super();

        this.visible = false

        this.clickHandler = this.clickHandler.bind(this)
        this.toggleVisibility = this.toggleVisibility.bind(this)
      }

      connectedCallback() {
        this.addEventListener('click', this.clickHandler)
        window.addEventListener('scroll', this.toggleVisibility)

        setTimeout(() => {
          this.toggleVisibility()
        }, 10)
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.toggleVisibility)
        this.removeEventListener('click', this.clickHandler)
      }

      clickHandler() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

      setVisible(visible) {
        if (this.visible !== visible) {
          this.visible = visible
          if (visible) {
            this.classList.remove(HIDDEN)
          } else {
            this.classList.add(HIDDEN)
          }
        }
      }

      toggleVisibility() {
        if (window.scrollY > 300) {
          this.setVisible(true);
        } else {
          this.setVisible(false);
        }
      }

    }

    tagClass[BACK_TO_TOP] = BackToTop

    class ShareButton extends Base {

      init() {
        this.button = this.firstElementChild
        this.event = this.dataset.event ?? E
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.button]
        });
      }

      async clickHandler() {
        if (navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              text: document.querySelector('meta[name="description"]')?.content || '',
              url: location.href,
            })

            return
          }
          catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
              return
            }
          }
        }

        this.openDialog()
      }

      openDialog() {
        if (this.event !== E) {
          pub_sub.publish(PubSub.CUSTOM, {event: this.event, data: {open: true, close: false}})
        }
      }

    }

    tagClass[SHARE_BUTTON] = ShareButton

    class SearchForm extends Base {
      static #search_index = 0

      #abort_controller;
      #timeout;
      #predictive;

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.inputHandler.name,
          this.keyboardHandler.name,
          this.documentPointerHandler.name,
        ]);
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          ...(this.clear.length ? {[this.clearHandler.name]: [this.clear[0]]} : {})
        });
      }

      init() {
        const
          div = this.querySelector(DIV),
          ds = this.dataset;

        this.search_row = div
        this.predictive_types = ds.predictiveTypes

        this.form = this.querySelector(FORM)
        this.input = div.querySelector(INPUT)
        this.clear = [...div.children]
          .filter(element => element.id.endsWith('__clear-icon'))

        this.templates = this.collectStateTemplate(['predictive', 'default'])

        this.search_index = ++SearchForm.#search_index
        this.anchor_name = `--predictive-search-${this.search_index}`
        this.predictive_id = `predictive-search-${this.search_index}`

        this.form.style.setProperty('anchor-name', this.anchor_name)

        this.input.setAttribute('role', 'combobox')
        this.input.setAttribute('aria-autocomplete', 'list')
        this.input.setAttribute('aria-expanded', 'false')
      }

      connect() {
        this.input.addEventListener('input', this.inputHandler)
        this.input.addEventListener('keydown', this.keyboardHandler)
        document.addEventListener('pointerdown', this.documentPointerHandler)
      }

      disconnect() {
        this.input.removeEventListener('input', this.inputHandler)
        this.input.removeEventListener('keydown', this.keyboardHandler)
        document.removeEventListener('pointerdown', this.documentPointerHandler)

        clearTimeout(this.#timeout)
        this.#abort_controller?.abort()
        this.closePredictive()
      }

      clearHandler() {
        this.input.value = ''

        clearTimeout(this.#timeout)
        this.#abort_controller?.abort()

        this.closePredictive()
        this.input.focus({preventScroll: true})
      }

      inputHandler() {
        clearTimeout(this.#timeout)

        const query = this.input.value.trim()

        if (!query) {
          this.#abort_controller?.abort()
          this.closePredictive()
          return
        }

        this.#timeout = setTimeout(() => {
          void this.predictiveSearch(query)
        }, 250)
      }

      documentPointerHandler(event) {
        if (!this.#predictive) return

        const path = event.composedPath()
        if (path.includes(this.search_row) || path.includes(this.#predictive)) {
          return
        }

        this.closePredictive()
      }

      async predictiveSearch(query) {
        this.#abort_controller?.abort()
        this.#abort_controller = new AbortController()

        const url = new URL(ROUTES.predictive_search_url, location.origin)
        url.searchParams.set('q', query)
        url.searchParams.set('section_id', 'json-predictive-search')
        if (this.predictive_types) {
          url.searchParams.set('resources[type]', this.predictive_types)
        }

        try {
          const response = await fetch(url, {signal: this.#abort_controller.signal})

          if (!response.ok) {
            throw new Error(`Predictive search failed: ${response.status}`)
          }

          const
            text = await response.text(),
            json = createHtml(text).querySelector(SCRIPT_JSON)

          if (!json) {
            throw new Error('Predictive search JSON not found')
          }

          const data = JSON.parse(json.textContent)

          this.renderPredictive(query, data)
        }
        catch (error) {
          if (error.name === 'AbortError') return

          console.error(error)
        }

      }

      renderPredictive(query, data) {
        this.#predictive?.remove()

        const
          state = this.templates.default,
          container = this.templates.predictive.cloneNode(true),
          predictive = container.firstElementChild,
          grid = predictive.firstElementChild,
          left = grid.children[0],
          suggestions = left.children[0].lastElementChild,
          pages = left.children[1].lastElementChild,
          products = grid.children[1].lastElementChild,
          search_for = grid.children[2];

        let option_index = 0
        const set_option = (option, a) => {
          option.id = `${this.predictive_id}-option-${++option_index}`
          option.setAttribute('role', 'option')
          option.setAttribute('aria-selected', 'false')
          a.tabIndex = -1
        }

        predictive.id = this.predictive_id
        predictive.setAttribute('role', 'listbox')
        predictive.style.setProperty('position-anchor', this.anchor_name)

        this.input.setAttribute('aria-controls', this.predictive_id)

        data.queries
          .forEach(query => {
            const
              li = createElement(LI, suggestions),
              a = createElement(A, li);

            a.href = query.url
            a.innerHTML = query.styled

            set_option(applyTemplate(li, state), a)
          })

        data.collections
          .forEach(collection => {
            const
              item = collection.collection,
              li = createElement(LI, suggestions),
              a = createElement(A, li);

            a.href = item.url
            a.textContent = item.title

            set_option(applyTemplate(li, state), a)
          });
        if (suggestions.children.length === 0) {
          suggestions.parentElement.classList.add(HIDDEN)
        }

        [...data.articles, ...data.pages]
          .forEach(art_or_page => {
            const
              item = art_or_page.article ?? art_or_page.page,
              li = createElement(LI, pages),
              a = createElement(A, li);

            a.href = item.url
            a.textContent = item.title

            set_option(applyTemplate(li, state), a)
          })
        if (pages.children.length === 0) {
          pages.parentElement.classList.add(HIDDEN)
        }

        data.products
          .forEach(product => {
            const
              item = product.product,
              li = createElement(LI, products),
              a = createElement(A, li),
              img = createElement(IMG, a),
              span = createElement(SPN, a);

            a.href = item.url
            a.className = 'flex flex-row items-center gap-2'
            if (item.image?.image) {
              img.src = modifyUrl(item.image.image, 'width', 75)
              img.alt = item.title
            }
            else {
              img.remove()
            }
            span.textContent = item.title
            span.className = 'whitespace-normal'

            set_option(applyTemplate(li, state), a)
          })
        if (products.children.length === 0) {
          products.parentElement.classList.add(HIDDEN)
        }

        const
          classes = [...search_for.classList],
          a = search_for.firstElementChild,
          span = a.firstElementChild,
          search_url = new URL(this.form.action, location.origin),
          search_params = new URLSearchParams(new FormData(this.form));
        search_params.set('q', query)
        search_url.search = search_params
        a.href = search_url
        span.textContent = t_custom(E, span.textContent, {query})

        set_option(applyTemplate(search_for, state), a)
        classes.forEach(item => {search_for.classList.add(item)})

        this.predictive_left = left
        this.predictive_suggestions = suggestions
        this.predictive_pages = pages
        this.predictive_products = products
        this.predictive_search_for = search_for

        this.form.append(predictive)
        this.#predictive = predictive
        this.#predictive.showPopover()
        this.input.setAttribute('aria-expanded', 'true')
      }

      closePredictive() {
        if (!this.#predictive) return

        const selected_option =
          this.#predictive.querySelector('[aria-selected="true"]')

        selected_option?.setAttribute('aria-selected', 'false')

        this.input.removeAttribute('aria-activedescendant')
        this.input.setAttribute('aria-expanded', 'false')

        if (this.#predictive.matches(':popover-open')) {
          this.#predictive.hidePopover()
        }
      }

      getPredictiveOptions() {
        if (!this.#predictive) return []

        const
          suggestions = [...this.predictive_suggestions.children],
          pages = [...this.predictive_pages.children],
          products = [...this.predictive_products.children],
          search_for = this.predictive_search_for,
          is_mobile = getComputedStyle(this.predictive_left).display === 'contents';

        return is_mobile
          ? [...suggestions, ...products, ...pages, search_for]
          : [...suggestions, ...pages, ...products, search_for]
      }

      switchOption(direction) {
        if (!this.#predictive?.matches(':popover-open')) return

        const
          options = this.getPredictiveOptions(),
          selected_option = this.#predictive.querySelector('[aria-selected="true"]');

        if (!options.length) return

        const selected_index = options.indexOf(selected_option)

        let active_index

        if (selected_index === -1) {
          active_index = direction === 'down' ? 0 : options.length - 1
        }
        else if (direction === 'down') {
          active_index = (selected_index + 1) % options.length
        }
        else {
          active_index = selected_index === 0
            ? options.length - 1
            : selected_index - 1
        }

        this.setActiveOption(options[active_index])
      }

      setActiveOption(active_option) {
        const selected_option = this.#predictive?.querySelector('[aria-selected="true"]')
        selected_option?.setAttribute('aria-selected', 'false')

        if (!active_option) {
          this.input.removeAttribute('aria-activedescendant')
          return
        }

        active_option.setAttribute('aria-selected', 'true')
        this.input.setAttribute('aria-activedescendant', active_option.id)
        active_option.scrollIntoView({block: 'nearest'})
      }

      selectOption() {
        const selected_option = this.#predictive?.querySelector('[aria-selected="true"]')
        selected_option?.querySelector(A)?.click()
      }

      keyboardHandler(event) {
        if (!this.#predictive?.matches(':popover-open')) return

        switch (event.code) {
          case 'ArrowDown':
            event.preventDefault()
            this.switchOption('down')
            break

          case 'ArrowUp':
            event.preventDefault()
            this.switchOption('up')
            break

          case 'Enter':
            if (this.#predictive.querySelector('[aria-selected="true"]')) {
              event.preventDefault()
              this.selectOption()
            }
            break

          case 'Escape':
            event.preventDefault()
            this.closePredictive()
            break

          case 'Tab':
            this.closePredictive()
            break
        }
      }

    }

    tagClass[SEARCH_FORM] = SearchForm

    class ShareForm extends Base {

      init() {
        this.querySelectorAll(BTN)
          .forEach((item) => {
            item.addEventListener(CLICK, () => {this.clickHandler(item)})
          })
      }

      async clickHandler(button) {
        const service = button.dataset.service

        if (service === 'copy') {
          await navigator.clipboard.writeText(location.href)
        }
        else if (service === 'email') {
          const url = this.getShareUrl(service)
          if (url) {
            location.href = url
          }
        }
        else {
          const url = this.getShareUrl(service)
          if (url) {
            window.open(url, '_blank', 'noopener,noreferrer')
          }
        }

        const section = this.closest(THEME_SECTION)
        const event = section.dataset.event ?? E

        if (event !== E) {
          await pub_sub.publish(PubSub.CUSTOM, {event, data: {open: false, close: true}})
        }
      }

      getShareUrl(service) {
        const pageUrl = location.href

        const title =
          document.querySelector('meta[property="og:title"]')?.content ||
          document.title

        const description =
          document.querySelector('meta[property="og:description"]')?.content ||
          document.querySelector('meta[name="description"]')?.content ||
          ''

        const image =
          document.querySelector('meta[property="og:image"]')?.content ||
          ''

        let url = null

        switch (service) {
          case 'facebook':
            url = new URL('https://www.facebook.com/sharer/sharer.php')
            url.searchParams.set('u', pageUrl)
            break
          case 'x':
            url = new URL('https://x.com/intent/tweet')
            url.searchParams.set('text', title)
            url.searchParams.set('url', pageUrl)
            break
          case 'linkedin':
            url = new URL('https://www.linkedin.com/sharing/share-offsite/')
            url.searchParams.set('url', pageUrl)
            break
          case 'pinterest':
            url = new URL('https://www.pinterest.com/pin/create/button/')
            url.searchParams.set('url', pageUrl)
            url.searchParams.set('description', title)
            if (image) {
              url.searchParams.set('media', image)
            }
            break
          case 'telegram':
            url = new URL('https://t.me/share/url')
            url.searchParams.set('url', pageUrl)
            url.searchParams.set('text', title)
            break
          case 'whatsapp':
            url = new URL('https://wa.me/')
            url.searchParams.set('text', `${title}\n${pageUrl}`)
            break
          case 'bluesky':
            url = new URL('https://bsky.app/intent/compose')
            url.searchParams.set('text', `${title}\n${pageUrl}`)
            break
          case 'tumblr':
            url = new URL('https://www.tumblr.com/widgets/share/tool')
            url.searchParams.set('canonicalUrl', pageUrl)
            url.searchParams.set('title', title)
            if (description) {
              url.searchParams.set('caption', description)
            }
            break
          case 'line':
            url = new URL('https://social-plugins.line.me/lineit/share')
            url.searchParams.set('url', pageUrl)
            url.searchParams.set('text', title)
            break
          case 'reddit':
            url = new URL('https://www.reddit.com/submit')
            url.searchParams.set('url', pageUrl)
            url.searchParams.set('title', title)
            break
          case 'email':
            const subject = encodeURIComponent(title)
            const body = encodeURIComponent(description ? `${description}\n\n${pageUrl}` : pageUrl)
            url = `mailto:?subject=${subject}&body=${body}`
        }

        return url
      }


    }

    tagClass[SHARE_FORM] = ShareForm

    class CountryLanguageBase extends ComboBox(Base) {

      getComboElements() {
        const
          templates = this.collectStateTemplate([DEFAULT, SELECTED], DIV),
          button = this.querySelector(BTN),
          label = button.firstElementChild,
          chevron = button.querySelector(SVG),
          dropdown = button.nextElementSibling,
          buttons = [...dropdown.children]
            .map(item => {
              const
                selected = item.dataset.selected === TRUE,
                template = templates[selected ? SELECTED : DEFAULT],
                clones = [...template.children].map(el => el.cloneNode(true));
              item.code = item.dataset.code
              item.selected = selected
              item.className = template.className
              item.style.cssText = template.style.cssText
              item.append(...clones)
              return searchAndApplyTraits(item)
            }),
          current = buttons.find(item => item.selected)

        return {button, label, chevron, dropdown, buttons, current}
      }

      itemSelected(item) {
        this.combo.label.innerHTML = item.innerHTML
        this.input.value = item.code
        this.form.submit()
      }
    }

    class CountrySelect extends CountryLanguageBase {

      init() {
        super.init()
        this.form = this.querySelector(FORM);
        this.input = this.form.querySelector('input[name="country_code"]')
      }

    }

    tagClass[COUNTRY_SELECT] = CountrySelect

    class LanguageSelect extends CountryLanguageBase {

      init() {
        super.init()
        this.form = this.querySelector(FORM);
        this.input = this.form.querySelector('input[name="language_code"]')
      }

    }

    tagClass[LANGUAGE_SELECT] = LanguageSelect

    class ParallaxImg extends Base {
      frame_id = 0

      init() {
        this.container = this.parentElement
        this.parallax = parseInt(this.style.getPropertyValue('--parallax'))
        this.updateParallax()
        this.classList.remove(INVISIBLE)
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.updateParallax.name,
          this.resizeHandle.name,
          this.scrollHandle.name,
        ]);
      }

      connect() {
        window.addEventListener(SCROLL, this.scrollHandle, {passive: true});
        window.addEventListener(RESIZE, this.resizeHandle);
      }

      disconnect() {
        cancelAnimationFrame(this.frame_id);
        window.removeEventListener(SCROLL, this.scrollHandle);
        window.removeEventListener(RESIZE, this.resizeHandle);
      }

      updateParallax() {
        const rect = this.container.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const isOffTop = rect.bottom <= 0;
        const isOffBottom = rect.top >= viewportHeight;

        if (isOffTop || isOffBottom) {
          return;
        }

        const screenCenter = viewportHeight / 2;
        const containerCenter = rect.top + (rect.height / 2);
        const maxDistance = (viewportHeight + rect.height) / 2;
        const deviation = (containerCenter - screenCenter) / maxDistance;

        const totalAllowedShift = rect.height * (this.parallax / 100);
        const maxSingleDirectionShift = totalAllowedShift / 2;
        const y = deviation * maxSingleDirectionShift;

        this.style.setProperty('--translate-y', y + 'px')
      }

      resizeHandle() {
        cancelAnimationFrame(this.frame_id);
        this.frame_id = requestAnimationFrame(this.updateParallax);
      }

      scrollHandle() {
        cancelAnimationFrame(this.frame_id);
        this.frame_id = requestAnimationFrame(this.updateParallax);
      }

    }

    tagClass[PARALLAX_IMG] = ParallaxImg

    class TemplateSlot extends Base {

      init() {
        const handler = `${TEMPLATE}.${TEMPLATE}-${this.dataset.handler}`;
        const section = this.closest(SHOPIFY_SECTION)
        const template = section.querySelector(handler) || document.querySelector(handler)
        if (template) {
          const snippet = template.content.cloneNode(true).firstElementChild
          this.appendChild(searchAndApplyTraits(snippet))
        }
      }

    }

    tagClass[TEMPLATE_SLOT] = TemplateSlot

    class PageBase extends Base {
      #page;

      set page(value) {
        this.#page = value;
      }

      get page() {
        if (!this.#page) {
          this.#page = super.getPageInfo()
        }
        return this.#page;
      }

    }

    class PageRoot extends Root(PageBase) {

      getPageRoot() {
        return this
      }

      getPageInfo() {
        return this.page
      }

      parseData(data) {
        this.page = data.page
      }

    }

    tagClass[PAGE_ROOT] = PageRoot

    class PageCard extends PageRoot {}

    tagClass[PAGE_CARD] = PageCard

    class PageLink extends PageBase {

      init() {
        this.firstElementChild.href = this.page.url
      }

    }

    tagClass[PAGE_LINK] = PageLink

    class PageTitle extends PageBase {

      init() {
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.page.title
      }

    }

    tagClass[PAGE_TITLE] = PageTitle

    class PageImage extends ImageBase(PageBase) {

      getImage() {
        const field = this.dataset.field
      }

    }

    tagClass[PAGE_IMAGE] = PageImage

    class PageTextarea extends PageBase {

      init() {
        const field = this.dataset.field
        if (field === 'content') {
          const text = this.page[field]?.text
          if (text !== undefined) {
            this.firstElementChild.textContent = text
          }
        }
      }

    }

    tagClass[PAGE_TEXTAREA] = PageTextarea

    class PageRichtext extends PageBase {

      init() {
        const field = this.dataset.field
        if (field === 'content') {
          const html = this.page[field]?.html
          if (html !== undefined) {
            this.firstElementChild.firstElementChild.innerHTML = html
          }
        }
      }

    }

    tagClass[PAGE_RICHTEXT] = PageRichtext

    class BlogBase extends Base {
      #blog;
      #article;

      set blog(value) {
        this.#blog = value;
      }

      get blog() {
        if (!this.#blog) {
          this.#blog = super.getBlogInfo()
        }
        return this.#blog;
      }

      set article(value) {
        this.#article = value;
      }

      get article() {
        if (!this.#article) {
          this.#article = super.getArticleInfo()
        }
        return this.#article;
      }

    }

    class BlogRoot extends Root(BlogBase) {

      getBlogRoot() {
        return this
      }

      getBlogInfo() {
        return this.blog
      }

      getArticleInfo() {
        return this.article
      }

      parseData(data) {
        this.blog = data.blog
        this.article = data.article
      }

    }

    tagClass[BLOG_ROOT] = BlogRoot

    class BlogTitle extends BlogBase {

      init() {
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.blog.title
      }

    }

    tagClass[BLOG_TITLE] = BlogTitle

    class BlogImage extends ImageBase(BlogBase) {

      getImage() {
        const field = this.dataset.field
      }

    }

    tagClass[BLOG_IMAGE] = BlogImage

    class BlogTextarea extends BlogBase {}

    tagClass[BLOG_TEXTAREA] = BlogTextarea

    class BlogRichText extends BlogBase {}

    tagClass[BLOG_RICHTEXT] = BlogRichText

    class BlogFilter extends BlogBase {

      init() {
        const states = this.collectStateTemplate([DEFAULT, SELECTED], A)
        const links = [...this.querySelectorAll(`${SCOPE} > ${A}`)];
        const all = links.shift()
        let active = all

        links.forEach((link) => {
          if (link.href === all.href) {
            active = link
          } else {
            applyTemplate(link, states[DEFAULT])
          }
        })

        if (active !== all) {
          applyTemplate(all, states[DEFAULT])
        }
        applyTemplate(active, states[SELECTED])
      }

    }

    tagClass[BLOG_FILTER] = BlogFilter


    class ArticleBase extends Base {
      #article;
      #blog;

      set article(value) {
        this.#article = value;
      }

      get article() {
        if (!this.#article) {
          this.#article = super.getArticleInfo()
        }
        return this.#article;
      }

      set blog(value) {
        this.#blog = value;
      }

      get blog() {
        if (!this.#blog) {
          this.#blog = super.getBlogInfo()
        }
        return this.#blog;
      }

    }

    class ArticleRoot extends Root(ArticleBase) {

      getArticleRoot() {
        return this
      }

      getArticleInfo() {
        return this.article
      }

      getBlogInfo() {
        return this.blog
      }

      parseData(data) {
        this.article = data.article
        this.blog = data.blog
      }

    }

    tagClass[ARTICLE_ROOT] = ArticleRoot

    class ArticleCard extends ArticleRoot {
    }

    tagClass[ARTICLE_CARD] = ArticleCard

    class ArticleBlog extends ArticleBase {

      init() {
        this.firstElementChild.textContent = this.blog.title
      }

    }

    tagClass[ARTICLE_BLOG] = ArticleBlog

    class ArticleTitle extends ArticleBase {

      init() {
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.article.title
      }

    }

    tagClass[ARTICLE_TITLE] = ArticleTitle

    class ArticleLink extends ArticleBase {

      init() {
        this.firstElementChild.href = this.article.url
      }

    }

    tagClass[ARTICLE_LINK] = ArticleLink

    class ArticleImage extends ImageBase(ArticleBase) {

      getImage() {
        const field = this.dataset.field

        if (field === 'image') {
          return this.article.image
        }

      }

    }

    tagClass[ARTICLE_IMAGE] = ArticleImage

    class ArticleTime extends ArticleBase {

      init() {
        const pattern = this.dataset.pattern
        const text = this.article.content.text
        const size = text.split(' ').length
        const value = Math.round(size / 200)
        this.firstElementChild.textContent = t_custom('', pattern, {value})
      }

    }

    tagClass[ARTICLE_TIME] = ArticleTime

    class ArticleExcerpt extends ArticleBase {

      init() {
        this.firstElementChild.textContent = stripHtml(this.article.excerpt)
      }

    }

    tagClass[ARTICLE_EXCERPT] = ArticleExcerpt

    class ArticleAuthor extends ArticleBase {

      init() {
        const pattern = this.dataset.pattern
        this.firstElementChild.textContent = t_custom('', pattern, {value: this.article.author})
      }

    }

    tagClass[ARTICLE_AUTHOR] = ArticleAuthor

    class ArticleDate extends ArticleBase {

      init() {
        const type = this.dataset.type
        const pattern = this.dataset.pattern
        const time_tag = this.firstElementChild

        const datetime = this.article[type]
        time_tag.setAttribute('datetime', datetime)
        time_tag.textContent = dateFormat(datetime, pattern)
      }

    }

    tagClass[ARTICLE_DATE] = ArticleDate

    class ArticleTags extends ArticleBase {

      init() {
        const state = this.collectStateTemplate([DEFAULT], A)[DEFAULT]

        this.querySelectorAll(`${SCOPE} > ${A}`)
          .forEach((link) => {
            applyTemplate(link, state)
          })
      }

    }

    tagClass[ARTICLE_TAGS] = ArticleTags

    class ArticleTextarea extends ArticleBase {

      init() {
        const field = this.dataset.field
        if (['excerpt_or_content', 'content', 'excerpt'].includes(field)) {
          const text = this.article[field]?.text
          if (text !== undefined) {
            this.firstElementChild.textContent = text
          }
        }
      }

    }

    tagClass[ARTICLE_TEXTAREA] = ArticleTextarea

    class ArticleRichtext extends ArticleBase {

      init() {
        const field = this.dataset.field
        if (['excerpt_or_content', 'content', 'excerpt'].includes(field)) {
          const html = this.article[field]?.html
          if (html !== undefined) {
            this.firstElementChild.firstElementChild.innerHTML = html
          }
        }
      }

    }

    tagClass[ARTICLE_RICHTEXT] = ArticleRichtext

    class CommentForm extends ArticleBase {

      init() {
        const url = new URL(location.href);

        if (url.searchParams.has('comment') && url.hash === '#comments') {
          url.hash = '#comment_form'
          history.replaceState(null, '', url)
          document.querySelector('#comment_form')?.scrollIntoView()
        }

        this.button = this.querySelector('[type="button"]')
      }

      clickBinder(click_bind) {
        super.clickBinder({
          ...click_bind,
          [this.clickHandler.name]: [this.button]
        });
      }

      clickHandler() {
        window.location = modifyUrl(location.href, 'comment')
      }

    }

    tagClass[COMMENT_FORM] = CommentForm

    class PaginationRoot extends Root(Base) {
      #observer;

      addPagination(pagination) {
        this.paginations.push(pagination)
        if (this.paginate) {
          pagination.initPagination(this.paginate)
        }
      }

      parseData(data) {
        this.paginate = data.paginate;
        this.paginations = []
      }

      connect() {
        this.#observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;

          this.viewportEnter();
        });

        this.#observer.observe(this);
      }

      disconnect() {
        this.#observer?.disconnect();
      }

      viewportEnter() {
        this.paginations.forEach(pagination => {
          pagination.viewportEnter();
        })
      }

    }

    tagClass[PAGINATION_ROOT] = PaginationRoot

    class Pagination extends Base {

      init() {
        const section = this.closest(THEME_SECTION)
        const root = section.querySelector(PAGINATION_ROOT)
        customElements.upgrade(root);
        root.addPagination(this)
      }

      initPagination(paginate) {
      }

      viewportEnter() {
      }

    }

    class PaginationNumbers extends Pagination {

      init() {
        this.types = [PREV, NEXT, ELLIPSIS, DEFAULT, SELECTED];
        this.templates = this.collectStateTemplate(this.types)
        super.init()
      }

      initPagination(paginate) {
        if (paginate.pages === 1) return;

        const
          ds = this.dataset,
          show_arrows = ds.showArrows === TRUE,
          show_pages = ds.showPages === TRUE,
          show_current = ds.showCurrent === TRUE,
          page_window = ds.pageWindow ?? 5,
          step = Math.floor(page_window / 2),
          current = paginate.current_page,
          last = paginate.pages,
          first_active = current === 1,
          last_active = current === last;

        let
          start = current - step,
          begin_space = true,
          stop = current + step,
          end_space = true;

        if (start < 2) {
          start = 2
          begin_space = false
        }
        if (stop > last - 1) {
          stop = last - 1
          end_space = false
        }

        const param = paginate.page_param

        const createButton = (page, text, label) => {
          const html = (1 <= page && page <= last)
            ? `<a href="${modifyUrl(location.href, param, page)}" aria-label="${label}">${text}</a>`
            : `<span aria-hidden="true">${text}</span>`
          const button = createHtml(html)
          if (page === current) {
            button.ariaCurrent = 'page'
          }
          return button
        }

        const nav = this.firstElementChild
        nav.textContent = ''

        if (show_arrows) {
          const prev_text = t('page.prev')
          const prev_button = createButton(current - 1, prev_text, prev_text)
          prev_button.ariaDisabled = first_active
          nav.append(applyTemplate(prev_button, this.templates[PREV], ''))
        }

        if (show_pages) {
          nav.append(
            applyTemplate(
              createButton(1, 1, t('page.goto', {page: 1})),
              this.templates[current === 1 ? SELECTED : DEFAULT]
            )
          )
          if (begin_space) {
            nav.append(applyTemplate(createButton(0, '…'), this.templates[ELLIPSIS], ''))
          }
          for (let page = start; page <= stop; page++) {
            nav.append(
              applyTemplate(
                createButton(page, page, t('page.goto', {page: page})),
                this.templates[current === page ? SELECTED : DEFAULT]
              )
            )
          }
          if (end_space) {
            nav.append(applyTemplate(createButton(0, '…'), this.templates[ELLIPSIS], ''))
          }
          nav.append(
            applyTemplate(
              createButton(last, last, t('page.goto', {page: last})),
              this.templates[current === last ? SELECTED : DEFAULT]
            )
          )
        }
        else if (show_current && show_arrows) {
          nav.append(
            applyTemplate(
              createButton(current, current, t('page.goto', {page: current})),
              this.templates[SELECTED]
            )
          )
        }

        if (show_arrows) {
          const next_text = t('page.next')
          const next_button = createButton(current + 1, next_text, next_text)
          next_button.ariaDisabled = last_active
          nav.append(applyTemplate(next_button, this.templates[NEXT], ''))
        }
      }


    }

    tagClass[PAGINATION_NUMBERS] = PaginationNumbers

    class PaginationSelect extends ComboBox(Pagination) {
      #elements

      init() {
        super.init()
      }

      get elements() {
        if (!this.#elements) {
          const
            button = this.querySelector(BTN),
            label = button.firstElementChild,
            chevron = button.lastElementChild,
            dropdown = button.nextElementSibling;

          this.#elements = {button, label, chevron, dropdown, buttons: [], current: null}
        }
        return this.#elements;
      }

      getComboElements() {
        return this.elements
      }

      initPagination(paginate) {
        const
          pattern = this.dataset.pattern,
          pages = paginate.pages,
          current = paginate.current_page,
          param = paginate.page_param,
          templates = this.collectStateTemplate([DEFAULT, SELECTED]),
          elements = this.elements;

        elements.label.textContent = t_custom(E, pattern, {value: current})

        for (let page = 1; page <= pages; page++) {
          const
            item = createElement(A, elements.dropdown),
            selected = current === page;
          item.href = modifyUrl(location.href, param, page)
          item.textContent = t_custom(E, pattern, {value: page})
          applyTemplate(item, templates[selected ? SELECTED : DEFAULT])
          elements.buttons.push(item)
          if (selected) {
            elements.current = item
          }
          if (this.combo) {
            this.registerComboItem(item)
          }
        }
      }
    }

    tagClass[PAGINATION_SELECT] = PaginationSelect

    class PaginationInfo extends Pagination {

      initPagination(paginate) {
        const
          spn = this.firstElementChild,
          pattern = this.dataset.pattern,
          count = paginate.items;

        let start = paginate.current_offset + 1
        if (start > count) {
          start = count
        }
        let end = start + paginate.page_size - 1
        if (end > count) {
          end = count
        }

        spn.textContent = t_custom(E, pattern, {count, start, end})
      }

    }

    tagClass[PAGINATION_INFO] = PaginationInfo

    class CartBase extends Base {
      #cart;

      set cart(value) {
        this.#cart = value;
      }

      get cart() {
        if (!this.#cart) {
          this.#cart = super.getCartInfo()
        }
        return this.#cart;
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.CART_CHANGED]: this.cartChangedHandler.name,
          [PubSub.CART_NOTE]: this.cartNoteHandler.name,
        });
      }

      cartChanged(data) {}

      cartChangedHandler(data) {
        this.cartChanged(data)
      }

      cartNote(data) {}

      cartNoteHandler(data) {
        data.sender !== this
        && this.cartNote(data)
      }

      sendMessage(message, data = {}) {
        data.sender = this
        pub_sub.publish(message, data);
      }

    }

    class CartBaseRoot extends Root(CartBase) {

      getCartInfo() {
        return this.cart
      }

      parseData(data) {
        this.cart = data.cart
      }

      cartChanged(data) {
        this.cart = {
          empty: data.item_count === 0,
          item_count: data.item_count,
          requires_shipping: data.requires_shipping,
          price: {
            original_total: data.original_total_price,
            items_subtotal: data.items_subtotal_price,
            total: data.total_price,
          },
          total_weight: data.total_weight,
          discounts: data.cart_level_discount_applications
            .map(discount => ({title: discount.title, amount: discount.total_allocated_amount})),
        }

        this.querySelectorAll(`${CART_SUMMARY},${CART_DISCOUNT}`).forEach((item) => item.update())
      }

    }

    class CartRoot extends CartBaseRoot {

      init() {
        this.test = this.dataset.test
        const
          footer = this.lastElementChild,
          lines = footer.previousElementSibling,
          header = lines.previousElementSibling;

        this.empty = [header.previousElementSibling.firstElementChild]
        this.lines = [header, lines, footer].map(item => item.firstElementChild)
        this.show(this.test === EMPTY || this.cart.empty ? EMPTY : LINES)
      }

      show(type, state = true) {
        this[type].forEach(item => item.classList.toggle(HIDDEN, !state))
      }

      cartChanged(data) {
        const old_empty = this.cart.empty
        super.cartChanged(data)
        const new_empty = this.cart.empty

        if (!this.test && old_empty !== new_empty) {
          this.show(EMPTY, new_empty)
          this.show(LINES, !new_empty)
        }
      }

    }

    tagClass[CART_ROOT] = CartRoot

    class CartButton extends CartBaseRoot {

      init() {
        this.cart_root = ROUTES.cart_url
      }

      connect() {
        const
          event = this.dataset.event ?? ''

        this.lastElementChild.addEventListener(CLICK, () => {
          if (location.pathname !== ROUTES.cart_url) {
            if (event) {
              pub_sub
                .publish(PubSub.CUSTOM, {event})
                .then((response) => {
                  if (!response.some(Boolean)) {
                    window.location = this.cart_root
                  }
                })
            } else {
              window.location = this.cart_root
            }
          }
        });
      }

      cartChanged(data) {
        super.cartChanged(data)
        if (location.pathname !== this.cart_root) {
          const event = this.dataset.event ?? E
          if (event) {
            pub_sub.publish(PubSub.CUSTOM, {event, data: {open: true}})
          }
        }
      }

    }

    tagClass[CART_BUTTON] = CartButton;

    class CartSummary extends CartBase {

      init() {
        this.pattern = this.dataset.pattern;
        this.hide = this.dataset.hide === TRUE;
        this.updateContent()
      }

      updateContent() {
        const
          cart = this.cart,
          discount = cart.price.original_total - cart.price.total,
          params = {
            count: cart.item_count,
            subtotal: moneyFormat(cart.price.items_subtotal),
            total: moneyFormat(cart.price.total),
          }

        this.querySelector(SPN_CONTENT).textContent = t_custom(E, this.pattern, params)
        this.classList.toggle(HIDDEN, this.hide && discount === 0)
      }

      update() {
        this.cart = undefined
        this.updateContent()
      }

    }

    tagClass[CART_SUMMARY] = CartSummary

    class CartDiscount extends CartBase {

      init() {
        this.pattern = this.dataset.pattern
        this.template = this.collectStateTemplate([E])[E]
        this.updateContent()
      }

      updateContent() {
        const
          cart = this.cart,
          discounts = cart.discounts

        this.textContent = ''

        discounts.forEach((discount) => {
          const
            element = this.template.cloneNode(true),
            params = {
              discount: discount.title,
              value: moneyFormat(discount.amount),
            }
          element.querySelector(SPN_CONTENT).textContent = t_custom(E, this.pattern, params)
          this.append(element)
        })
      }


      update() {
        this.cart = undefined
        this.updateContent()
      }

    }

    tagClass[CART_DISCOUNT] = CartDiscount

    class CartNote extends CartBase {
      static timer;
      static pending = Promise.resolve();

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.inputHandler.name,
          this.changeHandler.name,
        ]);
      }

      init() {
         this.input = this.querySelector(TEXTAREA)
       }

      connect() {
        this.input.addEventListener(CHANGE, this.changeHandler)
        this.input.addEventListener(INPUT, this.inputHandler)
      }

      disconnect() {
        this.input.removeEventListener(INPUT, this.inputHandler)
        this.input.removeEventListener(CHANGE, this.changeHandler)
      }

      cartNote(data) {
         this.input.value = data.note
      }

      inputHandler() {
        const note = this.input.value

        this.sendMessage(PubSub.CART_NOTE, {note})

        clearTimeout(this.constructor.timer)
        this.constructor.timer = setTimeout(() => {
          this.constructor.timer = null
          this.queueSave(this.input.value)
        }, 300)
      }

      changeHandler() {
        if (this.constructor.timer == null) return

        clearTimeout(this.constructor.timer)
        this.constructor.timer = null
        this.queueSave(this.input.value)
      }

      async save(note) {
        const response = await fetch(`${ROUTES.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({note}),
        })

        const data = await response.json()

        if (!response.ok || data.errors) {
          throw new Error(
            data.description || data.message || 'Failed to update cart note'
          )
        }
      }

      queueSave(note) {
        this.constructor.pending = this.constructor.pending
          .catch(() => {})
          .then(() => this.save(note))

        this.constructor.pending.catch(error => console.error(error))
      }

    }

    tagClass[CART_NOTE] = CartNote

    class CartCheckout extends CartBase {

      init() {
        this.note = this.querySelector('input[name="note"]')
      }

      cartNote(data) {
        this.note.value = data.note
      }

    }

    tagClass[CART_CHECKOUT] = CartCheckout

    class CartLines extends CartBase {

      init() {
        this.template = this.collectStateTemplate([E])[E]

        this.querySelectorAll(CART_LINE_ROOT)
          .forEach((line) => {
            customElements.upgrade(line)
            line.append(this.template.cloneNode(true))
          })
      }

      cartChanged(data) {
        const
          items = data.items,
          added = data.items_added,
          removed = data.items_removed,
          roots = new Map(
            [...this.children]
              .filter(element => element.matches(CART_LINE_ROOT))
              .map(element => [element.line.key, element])
          )

        removed.forEach((item, key) => {
          if (!items.has(key)) {
            roots.get(key)?.remove()
            roots.delete(key)
          }
        })

        if (added.size) {
          let reference = null
          const keys = [...data.items.keys()]

          while (keys.length) {
            const key = keys.pop()

            if (roots.has(key)) {
              reference = roots.get(key)
            }
            else if (added.has(key)) {
              const
                item = added.get(key),
                json = JSON.stringify(item).replace(/</g, '\\u003c'),
                html = `<${CART_LINE_ROOT} class="contents">` +
                  `<script type="application/json">${json}</script>` +
                  `</${CART_LINE_ROOT}>`,
                element = createHtml(html);

              element.append(this.template.cloneNode(true))
              this.insertBefore(element, reference)
              roots.set(key, element)
              reference = element
            }
          }
        }
      }

    }

    tagClass[CART_LINES] = CartLines

    class CartLineBase extends Base {
      #line;

      set line(value) {
        this.#line = value;
      }

      get line() {
        if (!this.#line) {
          this.#line = super.getCartLineInfo().line
        }
        return this.#line;
      }

    }

    class CartLineRoot extends Root(CartLineBase) {

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.CART_CHANGED]: this.cartChangedHandler.name,
        });
      }

      getCartLineInfo() {
        return {
          line: this.line,
        }
      }

      parseData(data) {
        this.line = data.line_item
      }

      cartChangedHandler(data) {
        const
          key = this.line.key,
          item = data.items.get(key)

        if (item) {
          const line = item.line_item;
          ['quantity', 'in_cart', 'inventory', 'rule', 'price', 'original', 'final', 'discounts']
            .forEach((property) => {
              if (line[property] !== null) {
                this.line[property] = line[property]
              }
            })
          this.querySelectorAll(`${CART_LINE_QUANTITY}, ${CART_LINE_PRICE}`)
            .forEach((item) => item.update())

        }
      }

    }

    tagClass[CART_LINE_ROOT] = CartLineRoot

    class CartLine extends CartLineBase {}

    tagClass[CART_LINE] = CartLine

    class CartLineChildIndicator extends CartLineBase {

      init() {
        this.classList.toggle(HIDDEN, !this.line.parent_key)
      }

    }

    tagClass[CART_LINE_CHILD_INDICATOR] = CartLineChildIndicator

    class CartLineTitle extends CartLineBase {

      init() {
        const type = this.dataset.type
        this.querySelector(`${SCOPE} > * > ${SPN_CONTENT}`).textContent = this.line.title[type]
      }

    }

    tagClass[CART_LINE_TITLE] = CartLineTitle

    class CartLineImage extends CartLineBase {

      init() {
        const image = this.collectStateTemplate([E], IMG)[E];
        void replaceImage(image, this.line.image);
        this.prepend(image)
        imageDimensions(searchAndApplyTraits(this))
      }

    }

    tagClass[CART_LINE_IMAGE] = CartLineImage

    class CartLineLink extends CartLineBase {

      init() {
        this.firstElementChild.href = this.line.url
      }

    }

    tagClass[CART_LINE_LINK] = CartLineLink

    class CartLineQuantity extends CartLineBase {

      init() {
        const type = this.dataset.type
        this.container = this.firstElementChild
        this[`${type}Init`]()
      }

      update() {
        this.line = undefined
        this.init()
      }

      clickBinder(click_bind) {
        const type = this.dataset.type
        super.clickBinder({
          ...click_bind,
          ...(type === 'qnt' ? {} : {[`${type}Handler`]: [this.container]})
        });
      }

      canIncrease() {
        const
          line = this.line,
          next = line.in_cart + line.rule.inc,
          rule_ok = line.rule.max == null || next <= line.rule.max,
          inventory_ok =
            line.inventory.management !== 'shopify' ||
            line.inventory.policy !== 'deny' ||
            next <= line.inventory.quantity;

        return line.can_update_quantity && rule_ok && inventory_ok
      }

      incInit() {
        this.container.ariaLabel = 'Increase quantity'
        this.container.ariaDisabled = (!this.canIncrease()).toString()
      }

      canDecrease() {
        const
          line = this.line,
          nextLine = line.quantity - line.rule.inc,
          nextTotal = line.in_cart - line.rule.inc;

        return line.can_update_quantity && nextLine > 0 && nextTotal >= line.rule.min
      }

      decInit() {
        this.container.ariaLabel = 'Decrease quantity'
        this.container.ariaDisabled = (!this.canDecrease()).toString()
      }

      canDelete() {
        return this.line.can_remove
      }

      delInit() {
        this.container.ariaLabel = 'Delete item'
        this.container.classList.toggle(HIDDEN, !this.canDelete())
      }

      qntInit() {
        this.querySelector(SPN_CONTENT).textContent = this.line.quantity
      }

      incHandler() {
        if (this.canIncrease()) {
          const line = this.line
          void this.fetch({quantity: line.quantity + line.rule.inc})
        }
      }

      decHandler() {
        if (this.canDecrease()) {
          const line = this.line
          void this.fetch({quantity: line.quantity - line.rule.inc})
        }
      }

      delHandler(event) {
        void this.fetch({quantity: 0})
      }

      async fetch(request) {
        request.id = this.line.key
        try {
          const response = await fetch(`${ROUTES.cart_change_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(request),
          });

          const data = await response.json()

          if (!response || !response.ok) {
            throw new Error(data.description || data.message || 'Failed to update cart')
          }

          await pub_sub.publish(PubSub.CART_CHANGED, await preprocessCart(data))
        } catch (error) {
          console.error(error)
        }
      }

    }

    tagClass[CART_LINE_QUANTITY] = CartLineQuantity

    class CartLinePrice extends CartLineBase {

      init() {
        const pattern = this.dataset.pattern,
          final = this.line.final,
          original = this.line.original,
          params = {
          price: moneyFormat(this.line.final.price),
          total: moneyFormat(this.line.final.line_price),
        }

        if (final.price !== original.price) {
          params.old_price = moneyFormat(original.price)
          params.old_total = moneyFormat(original.line_price)
          params.save = moneyFormat(original.line_price - final.line_price)
          this.classList.remove(HIDDEN)
        }
        else {
          const r = /\[\[\s*(old_price|old_total|save)\s*]]/
          this.classList[r.test(pattern) ? ADD : REMOVE](HIDDEN)
        }
        this.querySelector(SPN_CONTENT).textContent = t_custom(E, pattern, params)
      }

      update() {
        this.line = undefined
        this.init()
      }

    }

    tagClass[CART_LINE_PRICE] = CartLinePrice


    class CartLineDiscount extends CartLineBase {

      init() {
        this.pattern = this.dataset.pattern
        this.template = this.collectStateTemplate([E])[E]
        this.updateContent()
      }

      updateContent() {
        const discounts = this.line.discounts

        this.textContent = ''

        discounts.forEach((discount) => {
          const
            element = this.template.cloneNode(true),
            params = {
              discount: discount.title,
              value: moneyFormat(discount.amount),
            }
          element.querySelector(SPN_CONTENT).textContent = t_custom(E, this.pattern, params)
          this.append(element)
        })
      }


      update() {
        this.line = undefined
        this.updateContent()
      }

    }

    tagClass[CART_LINE_DISCOUNT] = CartLineDiscount

    class CartLineSellingPlan extends CartLineBase {

      init() {
        const
          selling_plan_name = this.line.selling_plan_name,
          p = this.firstElementChild
        p.classList.toggle(HIDDEN, !selling_plan_name)
        p.querySelector(SPN_CONTENT).textContent = selling_plan_name
      }

    }

    tagClass[CART_LINE_SELLING_PLAN] = CartLineSellingPlan

    class CartLineDetail extends CartLineBase {

      init() {
        const type = this.dataset.type
        this.template = this.collectStateTemplate([E])[E]
        this[type]()
      }

      options() {
        const options = this.line.options
        if (options.length) {
          const container = this.template.cloneNode(true)
          for (const option of options) {
            const
              div = createElement(DIV, container),
              dt = createElement(DT, div),
              dd = createElement(DD, div);
            dt.textContent = option.name + ':'
            dd.textContent = option.value
          }
          this.append(container)
        }
      }

      properties() {
        const properties = this.line.properties
          .filter(([name, value]) => name[0] !== '_' && value !== null && value !== undefined && value !== '')

        if (properties.length) {
          const container = this.template.cloneNode(true)
          for (const [name, value] of properties) {
            const
              div = createElement(DIV, container),
              dt = createElement(DT, div),
              dd = createElement(DD, div);
            dt.textContent = name + ':'
            if (typeof value === 'string' && value.includes('/uploads/')) {
              const a = createElement(A, dd)
              a.href = value
              a.target = '_blank'
              a.rel = 'noopener'
              a.textContent = value.split('/').pop()
            }
            else {
              dd.textContent = value
            }
          }
          this.append(container)
        }
      }

      components() {
        const components = this.line.components
        if (components.length) {
          const container = this.template.cloneNode(true)
          for (const component of components) {
            const
              li = createElement(LI, container),
              name = createElement(SPN, li);
            name.textContent = component.title
            if (component.quantity > 1) {
              const qnt = createElement(SPN, li);
              qnt.textContent = ` × ${component.quantity}`
            }
          }
          this.append(container)
        }
      }

    }

    tagClass[CART_LINE_DETAIL] = CartLineDetail

    class VideoSection extends Base {

      init() {
        this.design = this.dataset.design === TRUE
        this.video = this.firstElementChild
        this.state = {
          muted: this.video.muted,
          play: this.video.autoplay
        }
        this.mute_always = false
        this.unmute_always = false
      }

      binder(bind_list) {
        super.binder([
          ...bind_list,
          this.playHandler.name,
          this.pauseHandler.name,
          this.muteHandler.name,
          this.unmuteHandler.name,
        ]);
      }

      canPlaying() {
        return this.design ? true : !this.state.play
      }

      canPaused() {
        return this.design ? true : this.state.play
      }

      canMuted() {
        const result = !this.state.muted && (this.mute_always ? true : this.state.play)
        return this.design ? true : result
      }

      canUnmuted() {
        const result = this.state.muted && (this.unmute_always ? true : this.state.play)
        return this.design ? true : result
      }

      setPlaying(state) {
        this.state.play = state
        this.play?.classList[this.canPlaying() ? REMOVE : ADD](HIDDEN)
        this.pause?.classList[this.canPaused() ? REMOVE : ADD](HIDDEN)
        this.mute?.classList[this.canMuted() ? REMOVE : ADD](HIDDEN)
        this.unmute?.classList[this.canUnmuted() ? REMOVE : ADD](HIDDEN)
      }

      setMuted(state) {
        this.state.muted = state
        this.video.muted = state
        this.mute?.classList[this.canMuted() ? REMOVE : ADD](HIDDEN)
        this.unmute?.classList[this.canUnmuted() ? REMOVE : ADD](HIDDEN)
      }

      setPlay(button) {
        this.play = button
        button.classList[this.canPlaying() ? REMOVE : ADD](HIDDEN)
        button.addEventListener(CLICK, this.playHandler)
      }

      setPause(button) {
        this.pause = button
        button.classList[this.canPaused() ? REMOVE : ADD](HIDDEN)
        button.addEventListener(CLICK, this.pauseHandler)
      }

      setMute(button, always) {
        this.mute = button
        this.mute_always = always
        button.classList[this.canMuted() ? REMOVE : ADD](HIDDEN)
        button.addEventListener(CLICK, this.muteHandler)
      }

      setUnmute(button, always) {
        this.unmute = button
        this.unmute_always = always
        button.classList[this.canUnmuted() ? REMOVE : ADD](HIDDEN)
        button.addEventListener(CLICK, this.unmuteHandler)
      }

      async playHandler() {
        try {
          await this.video.play();
          this.setPlaying(true);
        }
        catch (error) {
          this.setPlaying(false);
        }
      }

      async pauseHandler() {
        try {
          await this.video.pause();
          this.setPlaying(false);
        }
        catch (error) {
          this.setPlaying(true);
        }
      }

      muteHandler() {
        this.setMuted(true)
      }

      unmuteHandler() {
        this.setMuted(false)
      }
    }

    tagClass[VIDEO_SECTION] = VideoSection

    class VideoButton extends Base {

      init() {
        const
          [first, ...rest] = this.dataset.type,
          type = first.toUpperCase() + rest.join("");
        this.closest(VIDEO_SECTION)[`set${type}`](this, this.dataset.always === TRUE)
      }

    }

    tagClass[VIDEO_BUTTON] = VideoButton

    class Timer extends Base {
      #pattern; #date; #started = false; subscribers = []

      set pattern(value) {
        this.#pattern = value.trim();
        this.start()
      }

      get pattern() {
        return this.#pattern;
      }

      set date(value) {
        this.#date = value;
        this.start()
      }

      get date() {
        return this.#date;
      }

      start() {
        if (this.#pattern !== undefined && this.#date) {
          this.#started = true
          this.tickHandler()
        }
      }

      subscribeBinder(subscribe_bind) {
        super.subscribeBinder({
          ...subscribe_bind,
          [PubSub.TICKER]: this.tickHandler.name,
        });
      }

      subscribe(subscriber) {
        this.subscribers.push(subscriber);
      }

      tickHandler() {
        PERFORMANCE_TIME('timer')
        if (this.#started) {
          let seconds = Math.floor((this.#date - new Date()) / 1000);
          if (seconds < 0) {
            seconds = 0
          }
          const params = {
            total_seconds: seconds.toString().padStart(2, '0'),
            seconds: (seconds % 60).toString().padStart(2, '0'),
          }
          const minutes = Math.floor(seconds / 60);
          params['total_minutes'] = minutes.toString().padStart(2, '0');
          params['minutes'] = (minutes % 60).toString().padStart(2, '0');
          const hours = Math.floor(minutes / 60);
          params['total_hours'] = hours.toString().padStart(2, '0');
          params['hours'] = (hours % 24).toString().padStart(2, '0');
          params['days'] = Math.floor(hours / 24);

          if (this.#pattern !== E) {
            this.firstElementChild.textContent = t_custom('', this.#pattern, params);
          }

          this.subscribers.forEach(subscriber => {subscriber.render(params)})
        }
      }


    }

    class CountdownTimer extends Timer {

      init() {
        this.pattern = this.dataset.pattern;

        if (!this.dataset.date) {
          return;
        }

        const date = new Date(this.dataset.date);

        if (Number.isNaN(date.getTime())) {
          return;
        }

        this.date = date;
      }

    }

    tagClass[COUNTDOWN_TIMER] = CountdownTimer

    class CountdownViewer extends Base {

      init() {
        this.pattern = this.dataset.pattern.trim();
        const timer = this.findTimer()
        if (timer) {
          timer.subscribe(this)
        }
      }

      findTimer() {
        let parent = this.parentElement
        while (parent !== document.body) {
          if (parent instanceof Timer) {
            return parent
          }
          parent = parent.parentElement
        }
      }

      render(params) {
        if (this.pattern !== E) {
          this.firstElementChild.textContent = t_custom('', this.pattern, params);
        }
      }

    }

    tagClass[COUNTDOWN_VIEWER] = CountdownViewer

    Object.entries(tagClass).forEach(([tag, obj]) => {
      customElements.define(tag, obj)
    })


  }

)(window.Shopify)